export const nodeIndex = [
    {
        "name": "n8n-nodes-base.actionNetwork",
        "displayName": "Action Network",
        "description": "Consume the Action Network API",
        "group": "transform",
        "keywords": [
            "action",
            "network",
            "transform",
            "sales",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/ActionNetwork/actionNetwork.svg"
        },
        "operations": {
            "attendance": [
                "create",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "event": [
                "create",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "person": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "petition": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "signature": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "tag": [
                "create",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "personTag": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.activeCampaign",
        "displayName": "ActiveCampaign",
        "description": "Create and edit data in ActiveCampaign",
        "group": "transform",
        "keywords": [
            "activecampaign",
            "transform",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/ActiveCampaign/activeCampaign.svg",
            "darkValue": "nodes/ActiveCampaign/activeCampaign.dark.svg"
        },
        "operations": {
            "account": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "contact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "accountContact": [
                "create",
                "delete",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "contactList": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "contactTag": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "list": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "tag": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "deal": [
                "create",
                "createNote",
                "delete",
                "get",
                "getAll",
                "update",
                "updateNote",
                "__CUSTOM_API_CALL__"
            ],
            "connection": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "ecommerceOrder": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "ecommerceCustomer": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "ecommerceOrderProducts": [
                "getAll",
                "getByProductId",
                "getByOrderId",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.activeCampaignTrigger",
        "displayName": "ActiveCampaign Trigger",
        "description": "Handle ActiveCampaign events via webhooks",
        "group": "trigger",
        "keywords": [
            "activecampaign",
            "trigger",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/ActiveCampaign/activeCampaign.svg",
            "darkValue": "nodes/ActiveCampaign/activeCampaign.dark.svg"
        }
    },
    {
        "name": "n8n-nodes-base.acuitySchedulingTrigger",
        "displayName": "Acuity Scheduling Trigger",
        "description": "Handle Acuity Scheduling events via webhooks",
        "group": "trigger",
        "keywords": [
            "acuity",
            "scheduling",
            "trigger",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/AcuityScheduling/acuityScheduling.png"
        }
    },
    {
        "name": "n8n-nodes-base.adalo",
        "displayName": "Adalo",
        "description": "Consume Adalo API",
        "group": "transform",
        "keywords": [
            "adalo",
            "transform",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Adalo/adalo.svg"
        },
        "operations": {
            "collection": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.affinity",
        "displayName": "Affinity",
        "description": "Consume Affinity API",
        "group": "output",
        "keywords": [
            "affinity",
            "output",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Affinity/affinity.svg",
            "darkValue": "nodes/Affinity/affinity.dark.svg"
        },
        "operations": {
            "list": [
                "get",
                "getAll"
            ],
            "listEntry": [
                "create",
                "delete",
                "get",
                "getAll"
            ],
            "organization": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "person": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.affinityTrigger",
        "displayName": "Affinity Trigger",
        "description": "Handle Affinity events via webhooks",
        "group": "trigger",
        "keywords": [
            "affinity",
            "trigger",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Affinity/affinity.svg",
            "darkValue": "nodes/Affinity/affinity.dark.svg"
        }
    },
    {
        "name": "n8n-nodes-base.agileCrm",
        "displayName": "Agile CRM",
        "description": "Consume Agile CRM API",
        "group": "transform",
        "keywords": [
            "agile",
            "crm",
            "transform",
            "marketing",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/AgileCrm/agilecrm.png"
        },
        "operations": {
            "contact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "company": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "deal": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.airtable",
        "displayName": "Airtable",
        "description": "Read, update, write and delete data from Airtable",
        "group": "input",
        "keywords": [
            "airtable",
            "input",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Airtable/airtable.svg"
        },
        "operations": {
            "record": [
                "create",
                "upsert",
                "deleteRecord",
                "get",
                "search",
                "update"
            ],
            "base": [
                "getMany",
                "getSchema"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.airtableTrigger",
        "displayName": "Airtable Trigger",
        "description": "Starts the workflow when Airtable events occur",
        "group": "trigger",
        "keywords": [
            "airtable",
            "trigger",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Airtable/airtable.svg"
        }
    },
    {
        "name": "n8n-nodes-base.airtop",
        "displayName": "Airtop",
        "description": "Scrape and control any site with Airtop",
        "group": "transform",
        "keywords": [
            "airtop",
            "transform",
            "productivity",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Airtop/airtop.svg"
        },
        "operations": {
            "agent": [
                "run"
            ],
            "session": [
                "create",
                "save",
                "terminate",
                "waitForDownload"
            ],
            "window": [
                "close",
                "create",
                "getLiveView",
                "list",
                "load",
                "takeScreenshot"
            ],
            "file": [
                "deleteFile",
                "get",
                "getMany",
                "load",
                "upload"
            ],
            "extraction": [
                "query",
                "getPaginated",
                "scrape"
            ],
            "interaction": [
                "click",
                "fill",
                "hover",
                "scroll",
                "type"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.aiTransform",
        "displayName": "AI Transform",
        "description": "Modify data based on instructions written in plain english",
        "group": "transform",
        "keywords": [
            "transform",
            "development",
            "core",
            "nodes",
            "code",
            "javascript",
            "script",
            "custom",
            "function",
            "llm",
            "data",
            "transformation"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/AiTransform/aitransform.svg"
        }
    },
    {
        "name": "n8n-nodes-base.amqp",
        "displayName": "AMQP Sender",
        "description": "Sends a raw-message via AMQP 1.0, executed once per item",
        "group": "transform",
        "keywords": [
            "amqp",
            "sender",
            "transform",
            "development",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Amqp/amqp.svg"
        }
    },
    {
        "name": "n8n-nodes-base.amqpTrigger",
        "displayName": "AMQP Trigger",
        "description": "Listens to AMQP 1.0 Messages",
        "group": "trigger",
        "keywords": [
            "amqp",
            "trigger",
            "development",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Amqp/amqp.svg"
        }
    },
    {
        "name": "n8n-nodes-base.apiTemplateIo",
        "displayName": "APITemplate.io",
        "description": "Consume the APITemplate.io API",
        "group": "transform",
        "keywords": [
            "apitemplate.io",
            "transform",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/ApiTemplateIo/apiTemplateIo.svg"
        },
        "operations": {
            "image": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "pdf": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "account": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.asana",
        "displayName": "Asana",
        "description": "Consume Asana REST API",
        "group": "input",
        "keywords": [
            "asana",
            "input",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Asana/asana.svg"
        },
        "operations": {
            "subtask": [
                "create",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "move",
                "search",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "taskComment": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "taskProject": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "taskTag": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "project": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.asanaTrigger",
        "displayName": "Asana Trigger",
        "description": "Starts the workflow when Asana events occur.",
        "group": "trigger",
        "keywords": [
            "asana",
            "trigger",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Asana/asana.svg"
        }
    },
    {
        "name": "n8n-nodes-base.autopilot",
        "displayName": "Autopilot",
        "description": "Consume Autopilot API",
        "group": "input",
        "keywords": [
            "autopilot",
            "input",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Autopilot/autopilot.svg"
        },
        "operations": {
            "contact": [
                "upsert",
                "delete",
                "get",
                "getAll"
            ],
            "contactJourney": [
                "add"
            ],
            "contactList": [
                "add",
                "exist",
                "getAll",
                "remove"
            ],
            "list": [
                "create",
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.autopilotTrigger",
        "displayName": "Autopilot Trigger",
        "description": "Handle Autopilot events via webhooks",
        "group": "trigger",
        "keywords": [
            "autopilot",
            "trigger",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Autopilot/autopilot.svg"
        }
    },
    {
        "name": "n8n-nodes-base.awsLambda",
        "displayName": "AWS Lambda",
        "description": "Invoke functions on AWS Lambda",
        "group": "output",
        "keywords": [
            "aws",
            "lambda",
            "output",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Aws/lambda.svg"
        },
        "operations": {
            "_": [
                "invoke",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.awsSns",
        "displayName": "AWS SNS",
        "description": "Sends data to AWS SNS",
        "group": "output",
        "keywords": [
            "aws",
            "sns",
            "output",
            "development",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Aws/sns.svg"
        },
        "operations": {
            "_": [
                "create",
                "delete",
                "publish",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.awsSnsTrigger",
        "displayName": "AWS SNS Trigger",
        "description": "Handle AWS SNS events via webhooks",
        "group": "trigger",
        "keywords": [
            "aws",
            "sns",
            "trigger",
            "development",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Aws/sns.svg"
        }
    },
    {
        "name": "n8n-nodes-base.awsCertificateManager",
        "displayName": "AWS Certificate Manager",
        "description": "Sends data to AWS Certificate Manager",
        "group": "output",
        "keywords": [
            "aws",
            "certificate",
            "manager",
            "output",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Aws/CertificateManager/acm.svg"
        },
        "operations": {
            "certificate": [
                "delete",
                "get",
                "getMany",
                "getMetadata",
                "renew",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.awsCognito",
        "displayName": "AWS Cognito",
        "description": "Sends data to AWS Cognito",
        "group": "output",
        "keywords": [
            "aws",
            "cognito",
            "output",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Aws/Cognito/cognito.svg",
            "darkValue": "nodes/Aws/Cognito/cognito.svg"
        },
        "operations": {
            "group": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "addToGroup",
                "create",
                "delete",
                "get",
                "getAll",
                "removeFromGroup",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "userPool": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.awsComprehend",
        "displayName": "AWS Comprehend",
        "description": "Sends data to Amazon Comprehend",
        "group": "output",
        "keywords": [
            "aws",
            "comprehend",
            "output",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Aws/Comprehend/comprehend.svg"
        },
        "operations": {
            "text": [
                "detectDominantLanguage",
                "detectEntities",
                "detectSentiment",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": [
                "detectDominantLanguage",
                "detectEntities",
                "detectSentiment",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.awsDynamoDb",
        "displayName": "AWS DynamoDB",
        "description": "Consume the AWS DynamoDB API",
        "group": "transform",
        "keywords": [
            "aws",
            "dynamodb",
            "transform",
            "data",
            "storage",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Aws/DynamoDB/dynamodb.svg"
        },
        "operations": {
            "item": [
                "upsert",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.awsElb",
        "displayName": "AWS ELB",
        "description": "Sends data to AWS ELB API",
        "group": "output",
        "keywords": [
            "aws",
            "elb",
            "output",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Aws/ELB/elb.svg"
        },
        "operations": {
            "loadBalancer": [
                "create",
                "delete",
                "get",
                "getMany",
                "__CUSTOM_API_CALL__"
            ],
            "listenerCertificate": [
                "add",
                "getMany",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.awsIam",
        "displayName": "AWS IAM",
        "description": "Interacts with Amazon IAM",
        "group": "output",
        "keywords": [
            "aws",
            "iam",
            "output",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Aws/IAM/AwsIam.svg"
        },
        "operations": {
            "user": [
                "addToGroup",
                "create",
                "delete",
                "get",
                "getAll",
                "removeFromGroup",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "group": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.awsRekognition",
        "displayName": "AWS Rekognition",
        "description": "Sends data to AWS Rekognition",
        "group": "output",
        "keywords": [
            "aws",
            "rekognition",
            "output",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Aws/Rekognition/rekognition.svg"
        },
        "operations": {
            "image": [
                "analyze",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": [
                "analyze",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.awsS3",
        "displayName": "AWS S3",
        "description": "Sends data to AWS S3",
        "group": "output",
        "keywords": [
            "aws",
            "output",
            "development",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Aws/S3/s3.svg"
        },
        "operations": {
            "bucket": [
                "create",
                "delete",
                "getAll",
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "folder": [
                "create",
                "delete",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "file": [
                "copy",
                "delete",
                "download",
                "getAll",
                "upload",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.awsSes",
        "displayName": "AWS SES",
        "description": "Sends data to AWS SES",
        "group": "output",
        "keywords": [
            "aws",
            "ses",
            "output",
            "communication",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Aws/SES/ses.svg"
        },
        "operations": {
            "customVerificationEmail": [
                "create",
                "delete",
                "get",
                "getAll",
                "send",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "email": [
                "send",
                "sendTemplate",
                "__CUSTOM_API_CALL__"
            ],
            "template": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.awsSqs",
        "displayName": "AWS SQS",
        "description": "Sends messages to AWS SQS",
        "group": "output",
        "keywords": [
            "aws",
            "sqs",
            "output",
            "development",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Aws/SQS/sqs.svg"
        },
        "operations": {
            "_": [
                "sendMessage",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.awsTextract",
        "displayName": "AWS Textract",
        "description": "Sends data to Amazon Textract",
        "group": "output",
        "keywords": [
            "aws",
            "textract",
            "output",
            "utility"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Aws/Textract/textract.svg"
        },
        "operations": {
            "_": [
                "analyzeExpense",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.awsTranscribe",
        "displayName": "AWS Transcribe",
        "description": "Sends data to AWS Transcribe",
        "group": "output",
        "keywords": [
            "aws",
            "transcribe",
            "output",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Aws/Transcribe/transcribe.svg"
        },
        "operations": {
            "transcriptionJob": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.bambooHr",
        "displayName": "BambooHR",
        "description": "Consume BambooHR API",
        "group": "transform",
        "keywords": [
            "bamboohr",
            "transform",
            "miscellaneous"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/BambooHr/bambooHr.png"
        },
        "operations": {
            "employee": [
                "create",
                "get",
                "getAll",
                "update"
            ],
            "employeeDocument": [
                "delete",
                "download",
                "getAll",
                "update",
                "upload"
            ],
            "file": [
                "delete",
                "download",
                "getAll",
                "update",
                "upload"
            ],
            "companyReport": [
                "get"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.bannerbear",
        "displayName": "Bannerbear",
        "description": "Consume Bannerbear API",
        "group": "output",
        "keywords": [
            "bannerbear",
            "output",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Bannerbear/bannerbear.png"
        },
        "operations": {
            "image": [
                "create",
                "get"
            ],
            "template": [
                "get",
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.baserow",
        "displayName": "Baserow",
        "description": "Consume the Baserow API",
        "group": "output",
        "keywords": [
            "baserow",
            "output",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Baserow/baserow.svg"
        },
        "operations": {
            "row": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.beeminder",
        "displayName": "Beeminder",
        "description": "Consume Beeminder API",
        "group": "output",
        "keywords": [
            "beeminder",
            "output",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Beeminder/beeminder.png"
        },
        "operations": {
            "charge": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "datapoint": [
                "create",
                "createAll",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "goal": [
                "create",
                "get",
                "getAll",
                "getArchived",
                "update",
                "refresh",
                "shortCircuit",
                "stepDown",
                "cancelStepDown",
                "uncle",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.bitbucketTrigger",
        "displayName": "Bitbucket Trigger",
        "description": "Handle Bitbucket events via webhooks",
        "group": "trigger",
        "keywords": [
            "bitbucket",
            "trigger",
            "development",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Bitbucket/bitbucket.svg"
        }
    },
    {
        "name": "n8n-nodes-base.bitly",
        "displayName": "Bitly",
        "description": "Consume Bitly API",
        "group": "output",
        "keywords": [
            "bitly",
            "output",
            "utility"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Bitly/bitly.svg"
        },
        "operations": {
            "link": [
                "create",
                "get",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.bitwarden",
        "displayName": "Bitwarden",
        "description": "Consume the Bitwarden API",
        "group": "transform",
        "keywords": [
            "bitwarden",
            "transform",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Bitwarden/bitwarden.svg"
        },
        "operations": {
            "collection": [
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "event": [
                "getAll"
            ],
            "group": [
                "create",
                "delete",
                "get",
                "getAll",
                "getMembers",
                "update",
                "updateMembers"
            ],
            "member": [
                "create",
                "delete",
                "get",
                "getGroups",
                "getAll",
                "update",
                "updateGroups"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.box",
        "displayName": "Box",
        "description": "Consume Box API",
        "group": "input",
        "keywords": [
            "box",
            "input",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Box/box.png"
        },
        "operations": {
            "file": [
                "copy",
                "delete",
                "download",
                "get",
                "search",
                "share",
                "upload",
                "__CUSTOM_API_CALL__"
            ],
            "folder": [
                "create",
                "delete",
                "get",
                "search",
                "share",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.boxTrigger",
        "displayName": "Box Trigger",
        "description": "Starts the workflow when Box events occur",
        "group": "trigger",
        "keywords": [
            "box",
            "trigger",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Box/box.png"
        }
    },
    {
        "name": "n8n-nodes-base.Brandfetch",
        "displayName": "Brandfetch",
        "description": "Consume Brandfetch API",
        "group": "output",
        "keywords": [
            "brandfetch",
            "output",
            "utility",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Brandfetch/brandfetch.png"
        },
        "operations": {
            "_": [
                "color",
                "company",
                "font",
                "industry",
                "logo",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.bubble",
        "displayName": "Bubble",
        "description": "Consume the Bubble Data API",
        "group": "transform",
        "keywords": [
            "bubble",
            "transform",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Bubble/bubble.svg",
            "darkValue": "nodes/Bubble/bubble.dark.svg"
        },
        "operations": {
            "object": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.calTrigger",
        "displayName": "Cal.com Trigger",
        "description": "Handle Cal.com events via webhooks",
        "group": "trigger",
        "keywords": [
            "cal.com",
            "trigger",
            "productivity",
            "utility"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Cal/cal.svg",
            "darkValue": "nodes/Cal/cal.dark.svg"
        }
    },
    {
        "name": "n8n-nodes-base.calendlyTrigger",
        "displayName": "Calendly Trigger",
        "description": "Starts the workflow when Calendly events occur",
        "group": "trigger",
        "keywords": [
            "calendly",
            "trigger",
            "productivity",
            "utility"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Calendly/calendly.svg"
        }
    },
    {
        "name": "n8n-nodes-base.chargebee",
        "displayName": "Chargebee",
        "description": "Retrieve data from Chargebee API",
        "group": "input",
        "keywords": [
            "chargebee",
            "input",
            "finance",
            "accounting"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Chargebee/chargebee.png"
        },
        "operations": {
            "customer": [
                "create"
            ],
            "invoice": [
                "list",
                "pdfUrl"
            ],
            "subscription": [
                "cancel",
                "delete"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.chargebeeTrigger",
        "displayName": "Chargebee Trigger",
        "description": "Starts the workflow when Chargebee events occur",
        "group": "trigger",
        "keywords": [
            "chargebee",
            "trigger",
            "finance",
            "accounting"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Chargebee/chargebee.png"
        }
    },
    {
        "name": "n8n-nodes-base.circleCi",
        "displayName": "CircleCI",
        "description": "Consume CircleCI API",
        "group": "output",
        "keywords": [
            "circleci",
            "output",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/CircleCi/circleCi.svg",
            "darkValue": "nodes/CircleCi/circleCi.dark.svg"
        },
        "operations": {
            "pipeline": [
                "get",
                "getAll",
                "trigger"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.ciscoWebex",
        "displayName": "Webex by Cisco",
        "description": "Consume the Cisco Webex API",
        "group": "transform",
        "keywords": [
            "webex",
            "cisco",
            "transform",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Cisco/Webex/ciscoWebex.png"
        },
        "operations": {
            "meeting": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "message": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.ciscoWebexTrigger",
        "displayName": "Webex by Cisco Trigger",
        "description": "Starts the workflow when Cisco Webex events occur.",
        "group": "trigger",
        "keywords": [
            "webex",
            "cisco",
            "trigger",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Cisco/Webex/ciscoWebex.png"
        }
    },
    {
        "name": "n8n-nodes-base.cloudflare",
        "displayName": "Cloudflare",
        "description": "Consume Cloudflare API",
        "group": "input",
        "keywords": [
            "cloudflare",
            "input",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Cloudflare/cloudflare.svg"
        },
        "operations": {
            "zoneCertificate": [
                "delete",
                "get",
                "getMany",
                "upload",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.clearbit",
        "displayName": "Clearbit",
        "description": "Consume Clearbit API",
        "group": "output",
        "keywords": [
            "clearbit",
            "output",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Clearbit/clearbit.svg"
        },
        "operations": {
            "company": [
                "autocomplete",
                "enrich"
            ],
            "person": [
                "enrich"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.clickUp",
        "displayName": "ClickUp",
        "description": "Consume ClickUp API (Beta)",
        "group": "output",
        "keywords": [
            "clickup",
            "output",
            "productivity",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/ClickUp/clickup.svg"
        },
        "operations": {
            "checklist": [
                "create",
                "delete",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "checklistItem": [
                "create",
                "delete",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "comment": [
                "create",
                "delete",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "folder": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "goal": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "goalKeyResult": [
                "create",
                "delete",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "taskTag": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "taskList": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "spaceTag": [
                "create",
                "delete",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "member",
                "setCustomField",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "taskDependency": [
                "create",
                "delete",
                "__CUSTOM_API_CALL__"
            ],
            "timeEntry": [
                "create",
                "delete",
                "get",
                "getAll",
                "start",
                "stop",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "timeEntryTag": [
                "add",
                "getAll",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "list": [
                "create",
                "customFields",
                "delete",
                "get",
                "getAll",
                "member",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.clickUpTrigger",
        "displayName": "ClickUp Trigger",
        "description": "Handle ClickUp events via webhooks (Beta)",
        "group": "trigger",
        "keywords": [
            "clickup",
            "trigger",
            "productivity",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/ClickUp/clickup.svg"
        }
    },
    {
        "name": "n8n-nodes-base.clockify",
        "displayName": "Clockify",
        "description": "Consume Clockify REST API",
        "group": "transform",
        "keywords": [
            "clockify",
            "transform",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Clockify/clockify.svg",
            "darkValue": "nodes/Clockify/clockify.dark.svg"
        },
        "operations": {
            "client": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "project": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "tag": [
                "create",
                "delete",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "timeEntry": [
                "create",
                "delete",
                "get",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "workspace": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.clockifyTrigger",
        "displayName": "Clockify Trigger",
        "description": "Listens to Clockify events",
        "group": "trigger",
        "keywords": [
            "clockify",
            "trigger",
            "utility",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Clockify/clockify.svg",
            "darkValue": "nodes/Clockify/clockify.dark.svg"
        }
    },
    {
        "name": "n8n-nodes-base.cockpit",
        "displayName": "Cockpit",
        "description": "Consume Cockpit API",
        "group": "output",
        "keywords": [
            "cockpit",
            "output",
            "marketing",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Cockpit/cockpit.svg",
            "darkValue": "nodes/Cockpit/cockpit.dark.svg"
        },
        "operations": {
            "collection": [
                "create",
                "getAll",
                "update"
            ],
            "form": [
                "submit"
            ],
            "singleton": [
                "get"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.coda",
        "displayName": "Coda",
        "description": "Consume Coda API",
        "group": "output",
        "keywords": [
            "coda",
            "output",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Coda/coda.svg"
        },
        "operations": {
            "table": [
                "createRow",
                "deleteRow",
                "getAllColumns",
                "getAllRows",
                "getColumn",
                "getRow",
                "pushButton"
            ],
            "formula": [
                "get",
                "getAll"
            ],
            "control": [
                "get",
                "getAll"
            ],
            "view": [
                "deleteViewRow",
                "get",
                "getAllViewColumns",
                "getAll",
                "getAllViewRows",
                "pushViewButton",
                "updateViewRow"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.code",
        "displayName": "Code",
        "description": "Run custom JavaScript or Python code",
        "group": "transform",
        "keywords": [
            "code",
            "transform",
            "development",
            "core",
            "nodes",
            "cpde",
            "javascript",
            "python",
            "script",
            "custom",
            "function",
            "helpers",
            "data",
            "transformation"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Code/code.svg"
        }
    },
    {
        "name": "n8n-nodes-base.coinGecko",
        "displayName": "CoinGecko",
        "description": "Consume CoinGecko API",
        "group": "output",
        "keywords": [
            "coingecko",
            "output",
            "productivity",
            "finance",
            "accounting"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/CoinGecko/coinGecko.svg"
        },
        "operations": {
            "coin": [
                "candlestick",
                "get",
                "getAll",
                "history",
                "market",
                "marketChart",
                "price",
                "ticker"
            ],
            "event": [
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.compareDatasets",
        "displayName": "Compare Datasets",
        "description": "Compare two inputs for changes",
        "group": "transform",
        "keywords": [
            "compare",
            "datasets",
            "transform",
            "core",
            "nodes",
            "join",
            "concatenate",
            "dataset",
            "split",
            "sync",
            "syncing",
            "flow"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/CompareDatasets/compare.svg"
        }
    },
    {
        "name": "n8n-nodes-base.compression",
        "displayName": "Compression",
        "description": "Compress and decompress files",
        "group": "transform",
        "keywords": [
            "compression",
            "transform",
            "core",
            "nodes",
            "data",
            "storage",
            "zip",
            "gzip",
            "uncompress",
            "compress",
            "decompress",
            "archive",
            "unarchive",
            "binary",
            "files",
            "file",
            "transformation"
        ],
        "icon": {
            "type": "fa",
            "value": "file-archive",
            "color": "green"
        },
        "operations": {
            "_": [
                "compress",
                "decompress"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.contentful",
        "displayName": "Contentful",
        "description": "Consume Contentful API",
        "group": "input",
        "keywords": [
            "contentful",
            "input",
            "marketing",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Contentful/contentful.png"
        },
        "operations": {
            "space": [
                "get"
            ],
            "contentType": [
                "get"
            ],
            "entry": [
                "get",
                "getAll"
            ],
            "asset": [
                "get",
                "getAll"
            ],
            "locale": [
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.convertKit",
        "displayName": "ConvertKit",
        "description": "Consume ConvertKit API",
        "group": "input",
        "keywords": [
            "convertkit",
            "input",
            "marketing",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/ConvertKit/convertKit.svg"
        },
        "operations": {
            "customField": [
                "create",
                "delete",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "form": [
                "addSubscriber",
                "getAll",
                "getSubscriptions",
                "__CUSTOM_API_CALL__"
            ],
            "sequence": [
                "addSubscriber",
                "getAll",
                "getSubscriptions",
                "__CUSTOM_API_CALL__"
            ],
            "tag": [
                "create",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "tagSubscriber": [
                "add",
                "getAll",
                "delete",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.convertKitTrigger",
        "displayName": "ConvertKit Trigger",
        "description": "Handle ConvertKit events via webhooks",
        "group": "trigger",
        "keywords": [
            "convertkit",
            "trigger",
            "marketing",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/ConvertKit/convertKit.svg"
        }
    },
    {
        "name": "n8n-nodes-base.copper",
        "displayName": "Copper",
        "description": "Consume the Copper API",
        "group": "transform",
        "keywords": [
            "copper",
            "transform",
            "marketing",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Copper/copper.svg"
        },
        "operations": {
            "company": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "customerSource": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "lead": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "opportunity": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "person": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "project": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.copperTrigger",
        "displayName": "Copper Trigger",
        "description": "Handle Copper events via webhooks",
        "group": "trigger",
        "keywords": [
            "copper",
            "trigger",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Copper/copper.svg"
        }
    },
    {
        "name": "n8n-nodes-base.cortex",
        "displayName": "Cortex",
        "description": "Apply the Cortex analyzer/responder on the given entity",
        "group": "transform",
        "keywords": [
            "cortex",
            "transform",
            "development",
            "analytics"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Cortex/cortex.svg"
        },
        "operations": {
            "analyzer": [
                "execute",
                "__CUSTOM_API_CALL__"
            ],
            "responder": [
                "execute",
                "__CUSTOM_API_CALL__"
            ],
            "job": [
                "get",
                "report",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.crateDb",
        "displayName": "CrateDB",
        "description": "Add and update data in CrateDB",
        "group": "input",
        "keywords": [
            "cratedb",
            "input",
            "development",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/CrateDb/cratedb.png"
        },
        "operations": {
            "_": [
                "executeQuery",
                "insert",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.cron",
        "displayName": "Cron",
        "description": "Triggers the workflow at a specific time",
        "group": "trigger",
        "keywords": [
            "cron",
            "trigger",
            "schedule",
            "core",
            "nodes",
            "time",
            "scheduler",
            "polling",
            "interval",
            "flow"
        ],
        "icon": {
            "type": "fa",
            "value": "clock"
        }
    },
    {
        "name": "n8n-nodes-base.crypto",
        "displayName": "Crypto",
        "description": "Provide cryptographic utilities",
        "group": "transform",
        "keywords": [
            "crypto",
            "transform",
            "development",
            "core",
            "nodes",
            "encrypt",
            "sha",
            "hash",
            "data",
            "transformation"
        ],
        "icon": {
            "type": "fa",
            "value": "key",
            "color": "green"
        }
    },
    {
        "name": "n8n-nodes-base.currents",
        "displayName": "Currents",
        "description": "Interact with the Currents API for test orchestration and analytics",
        "group": "transform",
        "keywords": [
            "currents",
            "transform"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Currents/currents.svg"
        },
        "operations": {
            "action": [
                "create",
                "delete",
                "disable",
                "enable",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "instance": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "project": [
                "get",
                "getAll",
                "getInsights",
                "__CUSTOM_API_CALL__"
            ],
            "run": [
                "cancel",
                "cancelGithub",
                "delete",
                "find",
                "get",
                "getAll",
                "reset",
                "__CUSTOM_API_CALL__"
            ],
            "signature": [
                "generate",
                "__CUSTOM_API_CALL__"
            ],
            "specFile": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "test": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "testResult": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.currentsTrigger",
        "displayName": "Currents Trigger",
        "description": "Starts the workflow when Currents events occur",
        "group": "trigger",
        "keywords": [
            "currents",
            "trigger"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Currents/currents.svg"
        }
    },
    {
        "name": "n8n-nodes-base.customerIo",
        "displayName": "Customer.io",
        "description": "Consume Customer.io API",
        "group": "output",
        "keywords": [
            "customer.io",
            "output",
            "communication",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/CustomerIo/customerio.svg",
            "darkValue": "nodes/CustomerIo/customerio.dark.svg"
        },
        "operations": {
            "campaign": [
                "get",
                "getAll",
                "getMetrics",
                "__CUSTOM_API_CALL__"
            ],
            "customer": [
                "upsert",
                "delete",
                "__CUSTOM_API_CALL__"
            ],
            "event": [
                "track",
                "trackAnonymous",
                "__CUSTOM_API_CALL__"
            ],
            "segment": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.customerIoTrigger",
        "displayName": "Customer.io Trigger",
        "description": "Starts the workflow on a Customer.io update (Beta)",
        "group": "trigger",
        "keywords": [
            "customer.io",
            "trigger",
            "communication",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/CustomerIo/customerio.svg",
            "darkValue": "nodes/CustomerIo/customerio.dark.svg"
        }
    },
    {
        "name": "n8n-nodes-base.dataTable",
        "displayName": "Data table",
        "description": "Permanently save data across workflow executions in a table",
        "group": "input",
        "keywords": [
            "data",
            "table",
            "input",
            "transform",
            "core",
            "nodes",
            "development",
            "knowledge",
            "sheet",
            "database",
            "base",
            "mysql",
            "postgres",
            "postgresql",
            "airtable",
            "supabase",
            "noco",
            "notion",
            "helpers"
        ],
        "icon": {
            "type": "fa",
            "value": "table",
            "color": "orange-red"
        },
        "operations": {
            "row": [
                "deleteRows",
                "get",
                "rowExists",
                "rowNotExists",
                "insert",
                "update",
                "upsert"
            ],
            "table": [
                "create",
                "delete",
                "list",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.dateTime",
        "displayName": "Date & Time",
        "description": "Manipulate date and time values",
        "group": "transform",
        "keywords": [
            "date",
            "time",
            "transform",
            "core",
            "nodes",
            "data",
            "transformation"
        ],
        "icon": {
            "type": "fa",
            "value": "clock",
            "color": "green"
        },
        "operations": {
            "_": [
                "addToDate",
                "extractDate",
                "formatDate",
                "getCurrentDate",
                "getTimeBetweenDates",
                "roundDate",
                "subtractFromDate"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.debugHelper",
        "displayName": "DebugHelper",
        "description": "Causes problems intentionally and generates useful data for debugging",
        "group": "output",
        "keywords": [
            "debughelper",
            "output",
            "development",
            "mock",
            "sample",
            "demo",
            "test",
            "throw",
            "error",
            "oom",
            "out",
            "memory",
            "placeholder"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/DebugHelper/DebugHelper.svg",
            "darkValue": "nodes/DebugHelper/DebugHelper.dark.svg"
        }
    },
    {
        "name": "n8n-nodes-base.deepL",
        "displayName": "DeepL",
        "description": "Translate data using DeepL",
        "group": "input",
        "keywords": [
            "deepl",
            "input",
            "output",
            "utility",
            "translate",
            "translator"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/DeepL/deepl.svg",
            "darkValue": "nodes/DeepL/deepL.dark.svg"
        },
        "operations": {
            "language": [
                "translate",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.demio",
        "displayName": "Demio",
        "description": "Consume the Demio API",
        "group": "output",
        "keywords": [
            "demio",
            "output",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Demio/demio.svg"
        },
        "operations": {
            "event": [
                "get",
                "getAll",
                "register"
            ],
            "report": [
                "get"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.dhl",
        "displayName": "DHL",
        "description": "Consume DHL API",
        "group": "input",
        "keywords": [
            "dhl",
            "input",
            "miscellaneous",
            "shipping"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Dhl/dhl.svg"
        },
        "operations": {
            "_": [
                "get"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.discord",
        "displayName": "Discord",
        "description": "Sends data to Discord",
        "group": "output",
        "keywords": [
            "discord",
            "output",
            "communication",
            "hitl",
            "human",
            "form",
            "wait",
            "approval",
            "the",
            "loop"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Discord/discord.svg"
        },
        "operations": {
            "message": [
                "deleteMessage",
                "get",
                "getAll",
                "react",
                "send",
                "sendAndWait",
                "__CUSTOM_API_CALL__"
            ],
            "channel": [
                "create",
                "deleteChannel",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "member": [
                "getAll",
                "roleAdd",
                "roleRemove",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": [
                "sendLegacy",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.discourse",
        "displayName": "Discourse",
        "description": "Consume Discourse API",
        "group": "input",
        "keywords": [
            "discourse",
            "input",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Discourse/discourse.svg"
        },
        "operations": {
            "category": [
                "create",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "group": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "post": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "create",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "userGroup": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.disqus",
        "displayName": "Disqus",
        "description": "Access data on Disqus",
        "group": "input",
        "keywords": [
            "disqus",
            "input",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Disqus/disqus.png"
        },
        "operations": {
            "forum": [
                "get",
                "getCategories",
                "getThreads",
                "getPosts"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.drift",
        "displayName": "Drift",
        "description": "Consume Drift API",
        "group": "output",
        "keywords": [
            "drift",
            "output",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Drift/drift.svg",
            "darkValue": "nodes/Drift/drift.dark.svg"
        },
        "operations": {
            "contact": [
                "create",
                "getCustomAttributes",
                "delete",
                "get",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.dropbox",
        "displayName": "Dropbox",
        "description": "Access data on Dropbox",
        "group": "input",
        "keywords": [
            "dropbox",
            "input",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Dropbox/dropbox.svg"
        },
        "operations": {
            "file": [
                "copy",
                "delete",
                "download",
                "move",
                "upload",
                "__CUSTOM_API_CALL__"
            ],
            "folder": [
                "copy",
                "create",
                "delete",
                "list",
                "move",
                "__CUSTOM_API_CALL__"
            ],
            "search": [
                "query",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.dropcontact",
        "displayName": "Dropcontact",
        "description": "Find B2B emails and enrich contacts",
        "group": "transform",
        "keywords": [
            "dropcontact",
            "transform",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Dropcontact/dropcontact.svg"
        },
        "operations": {
            "contact": [
                "enrich",
                "fetchRequest",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": [
                "enrich",
                "fetchRequest",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.editImage",
        "displayName": "Edit Image",
        "description": "Edits an image like blur, resize or adding border and text",
        "group": "transform",
        "keywords": [
            "edit",
            "image",
            "transform",
            "marketing",
            "core",
            "nodes",
            "files",
            "data",
            "transformation"
        ],
        "icon": {
            "type": "fa",
            "value": "image",
            "color": "purple"
        },
        "operations": {
            "_": [
                "blur",
                "border",
                "composite",
                "create",
                "crop",
                "draw",
                "information",
                "multiStep",
                "resize",
                "rotate",
                "shear",
                "text",
                "transparent"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.egoi",
        "displayName": "E-goi",
        "description": "Consume E-goi API",
        "group": "output",
        "keywords": [
            "e-goi",
            "output",
            "communication",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Egoi/egoi.svg"
        },
        "operations": {
            "contact": [
                "create",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.elasticsearch",
        "displayName": "Elasticsearch",
        "description": "Consume the Elasticsearch API",
        "group": "transform",
        "keywords": [
            "elasticsearch",
            "transform",
            "development",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Elastic/Elasticsearch/elasticsearch.svg"
        },
        "operations": {
            "document": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "index": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.elasticSecurity",
        "displayName": "Elastic Security",
        "description": "Consume the Elastic Security API",
        "group": "transform",
        "keywords": [
            "elastic",
            "security",
            "transform",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Elastic/ElasticSecurity/elasticSecurity.svg"
        },
        "operations": {
            "case": [
                "create",
                "delete",
                "get",
                "getAll",
                "getStatus",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "caseComment": [
                "add",
                "get",
                "getAll",
                "remove",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "caseTag": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "connector": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.emailReadImap",
        "displayName": "Email Trigger (IMAP)",
        "description": "Triggers the workflow when a new email is received",
        "group": "trigger",
        "keywords": [
            "email",
            "trigger",
            "imap",
            "communication",
            "core",
            "nodes",
            "other"
        ],
        "icon": {
            "type": "fa",
            "value": "inbox",
            "color": "green"
        }
    },
    {
        "name": "n8n-nodes-base.emailSend",
        "displayName": "Send Email",
        "description": "Sends an email using SMTP protocol",
        "group": "output",
        "keywords": [
            "send",
            "email",
            "output",
            "communication",
            "hitl",
            "core",
            "nodes",
            "smtp",
            "human",
            "form",
            "wait",
            "approval",
            "the",
            "loop"
        ],
        "icon": {
            "type": "fa",
            "value": "envelope"
        },
        "operations": {
            "_": [
                "send",
                "sendAndWait"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.emelia",
        "displayName": "Emelia",
        "description": "Consume the Emelia API",
        "group": "input",
        "keywords": [
            "emelia",
            "input",
            "communication",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Emelia/emelia.svg"
        },
        "operations": {
            "campaign": [
                "addContact",
                "create",
                "duplicate",
                "get",
                "getAll",
                "pause",
                "start"
            ],
            "contactList": [
                "add",
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.emeliaTrigger",
        "displayName": "Emelia Trigger",
        "description": "Handle Emelia campaign activity events via webhooks",
        "group": "trigger",
        "keywords": [
            "emelia",
            "trigger",
            "communication",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Emelia/emelia.svg"
        }
    },
    {
        "name": "n8n-nodes-base.erpNext",
        "displayName": "ERPNext",
        "description": "Consume ERPNext API",
        "group": "output",
        "keywords": [
            "erpnext",
            "output",
            "finance",
            "accounting",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/ERPNext/erpnext.svg"
        },
        "operations": {
            "document": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.errorTrigger",
        "displayName": "Error Trigger",
        "description": "Triggers the workflow when another workflow has an error",
        "group": "trigger",
        "keywords": [
            "error",
            "trigger",
            "development",
            "core",
            "nodes",
            "other"
        ],
        "icon": {
            "type": "fa",
            "value": "bug",
            "color": "blue"
        }
    },
    {
        "name": "n8n-nodes-base.evaluationTrigger",
        "displayName": "Evaluation Trigger",
        "description": "Run a test dataset through your workflow to check performance",
        "group": "trigger",
        "keywords": [
            "evaluation",
            "trigger",
            "test",
            "metrics",
            "evals",
            "set",
            "output",
            "when",
            "fetching",
            "dataset",
            "row"
        ],
        "icon": {
            "type": "fa",
            "value": "check-double"
        }
    },
    {
        "name": "n8n-nodes-base.evaluation",
        "displayName": "Evaluation",
        "description": "Runs an evaluation",
        "group": "transform",
        "keywords": [
            "evaluation",
            "transform",
            "utility",
            "test",
            "metrics",
            "evals",
            "set",
            "output"
        ],
        "icon": {
            "type": "fa",
            "value": "check-double"
        },
        "operations": {
            "_": [
                "setInputs",
                "setOutputs",
                "setMetrics",
                "checkIfEvaluating",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.eventbriteTrigger",
        "displayName": "Eventbrite Trigger",
        "description": "Handle Eventbrite events via webhooks",
        "group": "trigger",
        "keywords": [
            "eventbrite",
            "trigger",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Eventbrite/eventbrite.png"
        }
    },
    {
        "name": "n8n-nodes-base.executeWorkflow",
        "displayName": "Execute Sub-workflow",
        "description": "Execute another workflow",
        "group": "transform",
        "keywords": [
            "execute",
            "sub-workflow",
            "transform",
            "core",
            "nodes",
            "n8n",
            "call",
            "sub",
            "workflow",
            "subworkflow",
            "helpers",
            "flow"
        ],
        "icon": {
            "type": "fa",
            "value": "sign-in-alt",
            "color": "orange-red"
        }
    },
    {
        "name": "n8n-nodes-base.executeWorkflowTrigger",
        "displayName": "Execute Workflow Trigger",
        "description": "Helpers for calling other n8n workflows. Used for designing modular, microservice-like workflows.",
        "group": "trigger",
        "keywords": [
            "execute",
            "workflow",
            "trigger",
            "core",
            "nodes",
            "helpers",
            "when",
            "executed",
            "another"
        ],
        "icon": {
            "type": "fa",
            "value": "sign-out-alt"
        }
    },
    {
        "name": "n8n-nodes-base.executionData",
        "displayName": "Execution Data",
        "description": "Add execution data for search",
        "group": "input",
        "keywords": [
            "execution",
            "data",
            "input",
            "development",
            "core",
            "nodes",
            "filter",
            "set",
            "helpers"
        ],
        "icon": {
            "type": "fa",
            "value": "tasks",
            "color": "light-green"
        },
        "operations": {
            "_": [
                "save"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.facebookGraphApi",
        "displayName": "Facebook Graph API",
        "description": "Interacts with Facebook using the Graph API",
        "group": "transform",
        "keywords": [
            "facebook",
            "graph",
            "api",
            "transform",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Facebook/facebook.svg"
        }
    },
    {
        "name": "n8n-nodes-base.facebookTrigger",
        "displayName": "Facebook Trigger",
        "description": "Starts the workflow when Facebook events occur",
        "group": "trigger",
        "keywords": [
            "facebook",
            "trigger",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Facebook/facebook.svg"
        }
    },
    {
        "name": "n8n-nodes-base.facebookLeadAdsTrigger",
        "displayName": "Facebook Lead Ads Trigger",
        "description": "Handle Facebook Lead Ads events via webhooks",
        "group": "trigger",
        "keywords": [
            "facebook",
            "lead",
            "ads",
            "trigger",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/FacebookLeadAds/facebook.svg"
        }
    },
    {
        "name": "n8n-nodes-base.figmaTrigger",
        "displayName": "Figma Trigger (Beta)",
        "description": "Starts the workflow when Figma events occur",
        "group": "trigger",
        "keywords": [
            "figma",
            "trigger",
            "beta",
            "miscellaneous"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Figma/figma.svg"
        }
    },
    {
        "name": "n8n-nodes-base.filemaker",
        "displayName": "FileMaker",
        "description": "Retrieve data from the FileMaker data API",
        "group": "input",
        "keywords": [
            "filemaker",
            "input",
            "development",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/FileMaker/filemaker.png"
        }
    },
    {
        "name": "n8n-nodes-base.readWriteFile",
        "displayName": "Read/Write Files from Disk",
        "description": "Read or write files from the computer that runs n8n",
        "group": "input",
        "keywords": [
            "read/write",
            "files",
            "from",
            "disk",
            "input",
            "core",
            "nodes",
            "binary",
            "file",
            "text",
            "open",
            "import",
            "save",
            "export",
            "transfer"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Files/ReadWriteFile/readWriteFile.svg"
        },
        "operations": {
            "_": [
                "read",
                "write"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.convertToFile",
        "displayName": "Convert to File",
        "description": "Convert JSON data to binary data",
        "group": "input",
        "keywords": [
            "convert",
            "file",
            "input",
            "core",
            "nodes",
            "csv",
            "spreadsheet",
            "excel",
            "xls",
            "xlsx",
            "ods",
            "tabular",
            "encode",
            "encoding",
            "move",
            "binary",
            "data",
            "json",
            "html",
            "ics",
            "ical",
            "rtf",
            "base64",
            "files",
            "transformation"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Files/ConvertToFile/convertToFile.svg",
            "darkValue": "nodes/Files/ConvertToFile/convertToFile.dark.svg"
        },
        "operations": {
            "_": [
                "csv",
                "html",
                "iCal",
                "toJson",
                "ods",
                "rtf",
                "toText",
                "xls",
                "xlsx",
                "toBinary"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.extractFromFile",
        "displayName": "Extract from File",
        "description": "Convert binary data to JSON",
        "group": "input",
        "keywords": [
            "extract",
            "from",
            "file",
            "input",
            "core",
            "nodes",
            "csv",
            "spreadsheet",
            "excel",
            "xls",
            "xlsx",
            "ods",
            "tabular",
            "decode",
            "decoding",
            "move",
            "binary",
            "data",
            "pdf",
            "json",
            "html",
            "ics",
            "ical",
            "txt",
            "text",
            "rtf",
            "xml",
            "base64",
            "convert",
            "files",
            "transformation"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Files/ExtractFromFile/extractFromFile.svg",
            "darkValue": "nodes/Files/ExtractFromFile/extractFromFile.dark.svg"
        },
        "operations": {
            "_": [
                "csv",
                "html",
                "fromIcs",
                "fromJson",
                "ods",
                "pdf",
                "rtf",
                "text",
                "xml",
                "xls",
                "xlsx",
                "binaryToPropery"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.filter",
        "displayName": "Filter",
        "description": "Remove items matching a condition",
        "group": "transform",
        "keywords": [
            "filter",
            "transform",
            "core",
            "nodes",
            "router",
            "condition",
            "logic",
            "boolean",
            "branch",
            "flow",
            "data",
            "transformation"
        ],
        "icon": {
            "type": "fa",
            "value": "filter",
            "color": "light-blue"
        }
    },
    {
        "name": "n8n-nodes-base.flow",
        "displayName": "Flow",
        "description": "Consume Flow API",
        "group": "output",
        "keywords": [
            "flow",
            "output",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Flow/flow.svg"
        },
        "operations": {
            "task": [
                "create",
                "update",
                "get",
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.flowTrigger",
        "displayName": "Flow Trigger",
        "description": "Handle Flow events via webhooks",
        "group": "trigger",
        "keywords": [
            "flow",
            "trigger",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Flow/flow.svg"
        }
    },
    {
        "name": "n8n-nodes-base.form",
        "displayName": "n8n Form",
        "description": "Generate webforms in n8n and pass their responses to the workflow",
        "group": "input",
        "keywords": [
            "n8n",
            "form",
            "input",
            "core",
            "nodes",
            "table",
            "submit",
            "post",
            "page",
            "step",
            "stage",
            "multi",
            "helpers"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Form/form.svg"
        },
        "operations": {
            "_": [
                "page",
                "completion"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.formTrigger",
        "displayName": "n8n Form Trigger",
        "description": "Generate webforms in n8n and pass their responses to the workflow",
        "group": "trigger",
        "keywords": [
            "n8n",
            "form",
            "trigger",
            "core",
            "nodes",
            "table",
            "submit",
            "post",
            "other",
            "submission"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Form/form.svg"
        }
    },
    {
        "name": "n8n-nodes-base.formIoTrigger",
        "displayName": "Form.io Trigger",
        "description": "Handle form.io events via webhooks",
        "group": "trigger",
        "keywords": [
            "form.io",
            "trigger",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/FormIo/formio.svg"
        }
    },
    {
        "name": "n8n-nodes-base.formstackTrigger",
        "displayName": "Formstack Trigger",
        "description": "Starts the workflow on a Formstack form submission.",
        "group": "trigger",
        "keywords": [
            "formstack",
            "trigger",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Formstack/formstack.svg"
        }
    },
    {
        "name": "n8n-nodes-base.freshdesk",
        "displayName": "Freshdesk",
        "description": "Consume Freshdesk API",
        "group": "output",
        "keywords": [
            "freshdesk",
            "output",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Freshdesk/freshdesk.svg"
        },
        "operations": {
            "ticket": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "contact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.freshservice",
        "displayName": "Freshservice",
        "description": "Consume the Freshservice API",
        "group": "transform",
        "keywords": [
            "freshservice",
            "transform",
            "productivity",
            "freshdesk"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Freshservice/freshservice.svg"
        },
        "operations": {
            "agent": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "agentGroup": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "agentRole": [
                "get",
                "getAll"
            ],
            "announcement": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "assetType": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "change": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "department": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "location": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "problem": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "product": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "release": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "requester": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "requesterGroup": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "software": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "ticket": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.freshworksCrm",
        "displayName": "Freshworks CRM",
        "description": "Consume the Freshworks CRM API",
        "group": "transform",
        "keywords": [
            "freshworks",
            "crm",
            "transform",
            "marketing",
            "sales",
            "freshdesk"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/FreshworksCrm/freshworksCrm.svg"
        },
        "operations": {
            "account": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "appointment": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "contact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "deal": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "note": [
                "create",
                "delete",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "salesActivity": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "search": [
                "query",
                "lookup",
                "__CUSTOM_API_CALL__"
            ],
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.ftp",
        "displayName": "FTP",
        "description": "Transfer files via FTP or SFTP",
        "group": "input",
        "keywords": [
            "ftp",
            "input",
            "core",
            "nodes",
            "data",
            "storage",
            "development",
            "utility",
            "sftp",
            "binary",
            "file",
            "transfer",
            "files",
            "helpers"
        ],
        "icon": {
            "type": "fa",
            "value": "server",
            "color": "dark-blue"
        },
        "operations": {
            "_": [
                "delete",
                "download",
                "list",
                "rename",
                "upload"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.function",
        "displayName": "Function",
        "description": "Run custom function code which gets executed once and allows you to add, remove, change and replace items",
        "group": "transform",
        "keywords": [
            "function",
            "transform",
            "development",
            "core",
            "nodes",
            "code",
            "javascript",
            "custom",
            "script",
            "cpde",
            "data",
            "transformation"
        ],
        "icon": {
            "type": "fa",
            "value": "code"
        }
    },
    {
        "name": "n8n-nodes-base.functionItem",
        "displayName": "Function Item",
        "description": "Run custom function code which gets executed once per item",
        "group": "transform",
        "keywords": [
            "function",
            "item",
            "transform",
            "development",
            "core",
            "nodes",
            "javascript",
            "code",
            "custom",
            "data",
            "transformation"
        ],
        "icon": {
            "type": "fa",
            "value": "code"
        }
    },
    {
        "name": "n8n-nodes-base.getResponse",
        "displayName": "GetResponse",
        "description": "Consume GetResponse API",
        "group": "input",
        "keywords": [
            "getresponse",
            "input",
            "communication",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/GetResponse/getResponse.png"
        },
        "operations": {
            "contact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.getResponseTrigger",
        "displayName": "GetResponse Trigger",
        "description": "Starts the workflow when GetResponse events occur",
        "group": "trigger",
        "keywords": [
            "getresponse",
            "trigger",
            "communication",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/GetResponse/getResponse.png"
        }
    },
    {
        "name": "n8n-nodes-base.ghost",
        "displayName": "Ghost",
        "description": "Consume Ghost API",
        "group": "input",
        "keywords": [
            "ghost",
            "input",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Ghost/ghost.svg"
        },
        "operations": {
            "post": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.git",
        "displayName": "Git",
        "description": "Control git.",
        "group": "transform",
        "keywords": [
            "git",
            "transform",
            "core",
            "nodes",
            "development",
            "helpers"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Git/git.svg"
        },
        "operations": {
            "_": [
                "add",
                "addConfig",
                "clone",
                "commit",
                "fetch",
                "listConfig",
                "log",
                "pull",
                "push",
                "pushTags",
                "reflog",
                "status",
                "switchBranch",
                "tag",
                "userSetup"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.github",
        "displayName": "GitHub",
        "description": "Consume GitHub API",
        "group": "input",
        "keywords": [
            "github",
            "input",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Github/github.svg",
            "darkValue": "nodes/Github/github.dark.svg"
        },
        "operations": {
            "organization": [
                "getRepositories",
                "__CUSTOM_API_CALL__"
            ],
            "issue": [
                "create",
                "createComment",
                "edit",
                "get",
                "lock",
                "__CUSTOM_API_CALL__"
            ],
            "file": [
                "create",
                "delete",
                "edit",
                "get",
                "list",
                "__CUSTOM_API_CALL__"
            ],
            "repository": [
                "get",
                "getIssues",
                "getLicense",
                "getProfile",
                "getPullRequests",
                "listPopularPaths",
                "listReferrers",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "getRepositories",
                "getUserIssues",
                "invite",
                "__CUSTOM_API_CALL__"
            ],
            "release": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "review": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "workflow": [
                "disable",
                "dispatch",
                "dispatchAndWait",
                "enable",
                "get",
                "getUsage",
                "list",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.githubTrigger",
        "displayName": "Github Trigger",
        "description": "Starts the workflow when Github events occur",
        "group": "trigger",
        "keywords": [
            "github",
            "trigger",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Github/github.svg",
            "darkValue": "nodes/Github/github.dark.svg"
        }
    },
    {
        "name": "n8n-nodes-base.gitlab",
        "displayName": "GitLab",
        "description": "Retrieve data from GitLab API",
        "group": "input",
        "keywords": [
            "gitlab",
            "input",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Gitlab/gitlab.svg"
        },
        "operations": {
            "issue": [
                "create",
                "createComment",
                "edit",
                "get",
                "lock",
                "__CUSTOM_API_CALL__"
            ],
            "repository": [
                "get",
                "getIssues",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "getRepositories",
                "__CUSTOM_API_CALL__"
            ],
            "release": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "file": [
                "create",
                "delete",
                "edit",
                "get",
                "list",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.gitlabTrigger",
        "displayName": "GitLab Trigger",
        "description": "Starts the workflow when GitLab events occur",
        "group": "trigger",
        "keywords": [
            "gitlab",
            "trigger",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Gitlab/gitlab.svg"
        }
    },
    {
        "name": "n8n-nodes-base.gong",
        "displayName": "Gong",
        "description": "Interact with Gong API",
        "group": "transform",
        "keywords": [
            "gong",
            "transform",
            "development",
            "developer",
            "tools"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Gong/gong.svg"
        },
        "operations": {
            "call": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleAds",
        "displayName": "Google Ads",
        "description": "Use the Google Ads API",
        "group": "transform",
        "keywords": [
            "google",
            "ads",
            "transform",
            "analytics"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Ads/googleAds.svg"
        },
        "operations": {
            "campaign": [
                "getAll",
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleAnalytics",
        "displayName": "Google Analytics",
        "description": "Use the Google Analytics API",
        "group": "transform",
        "keywords": [
            "google",
            "analytics",
            "transform"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Analytics/analytics.svg"
        },
        "operations": {
            "report": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "userActivity": [
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleBigQuery",
        "displayName": "Google BigQuery",
        "description": "Consume Google BigQuery API",
        "group": "input",
        "keywords": [
            "google",
            "bigquery",
            "input",
            "data",
            "storage",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/BigQuery/googleBigQuery.svg"
        },
        "operations": {
            "_": [
                "executeQuery",
                "insert"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.googleBooks",
        "displayName": "Google Books",
        "description": "Read data from Google Books",
        "group": "input",
        "keywords": [
            "google",
            "books",
            "input",
            "output",
            "miscellaneous"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Books/googlebooks.svg"
        },
        "operations": {
            "bookshelf": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "bookshelfVolume": [
                "add",
                "clear",
                "getAll",
                "move",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "volume": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleCalendar",
        "displayName": "Google Calendar",
        "description": "Consume Google Calendar API",
        "group": "input",
        "keywords": [
            "google",
            "calendar",
            "input",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Calendar/googleCalendar.svg"
        },
        "operations": {
            "calendar": [
                "availability",
                "__CUSTOM_API_CALL__"
            ],
            "event": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleCalendarTrigger",
        "displayName": "Google Calendar Trigger",
        "description": "Starts the workflow when Google Calendar events occur",
        "group": "trigger",
        "keywords": [
            "google",
            "calendar",
            "trigger",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Calendar/googleCalendar.svg"
        }
    },
    {
        "name": "n8n-nodes-base.googleChat",
        "displayName": "Google Chat",
        "description": "Consume Google Chat API",
        "group": "input",
        "keywords": [
            "google",
            "chat",
            "input",
            "communication",
            "hitl",
            "human",
            "form",
            "wait",
            "approval",
            "the",
            "loop"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Chat/googleChat.svg"
        },
        "operations": {
            "member": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "message": [
                "create",
                "delete",
                "get",
                "sendAndWait",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "space": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleCloudNaturalLanguage",
        "displayName": "Google Cloud Natural Language",
        "description": "Consume Google Cloud Natural Language API",
        "group": "input",
        "keywords": [
            "google",
            "cloud",
            "natural",
            "language",
            "input",
            "output",
            "analytics"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/CloudNaturalLanguage/googlecloudnaturallanguage.png"
        },
        "operations": {
            "document": [
                "analyzeSentiment",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleCloudStorage",
        "displayName": "Google Cloud Storage",
        "description": "Use the Google Cloud Storage API",
        "group": "transform",
        "keywords": [
            "google",
            "cloud",
            "storage",
            "transform",
            "development",
            "data"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/CloudStorage/googleCloudStorage.svg"
        },
        "operations": {
            "bucket": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "object": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleContacts",
        "displayName": "Google Contacts",
        "description": "Consume Google Contacts API",
        "group": "input",
        "keywords": [
            "google",
            "contacts",
            "input",
            "miscellaneous"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Contacts/googleContacts.png"
        },
        "operations": {
            "contact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleDocs",
        "displayName": "Google Docs",
        "description": "Consume Google Docs API.",
        "group": "input",
        "keywords": [
            "google",
            "docs",
            "input",
            "miscellaneous"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Docs/googleDocs.svg"
        },
        "operations": {
            "document": [
                "create",
                "get",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleDrive",
        "displayName": "Google Drive",
        "description": "Access data on Google Drive",
        "group": "input",
        "keywords": [
            "google",
            "drive",
            "input",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Drive/googleDrive.svg"
        },
        "operations": {
            "drive": [
                "create",
                "deleteDrive",
                "get",
                "list",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "file": [
                "copy",
                "createFromText",
                "deleteFile",
                "download",
                "move",
                "share",
                "update",
                "upload",
                "__CUSTOM_API_CALL__"
            ],
            "fileFolder": [
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "folder": [
                "create",
                "deleteFolder",
                "share",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleDriveTrigger",
        "displayName": "Google Drive Trigger",
        "description": "Starts the workflow when Google Drive events occur",
        "group": "trigger",
        "keywords": [
            "google",
            "drive",
            "trigger",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Drive/googleDrive.svg"
        }
    },
    {
        "name": "n8n-nodes-base.googleFirebaseCloudFirestore",
        "displayName": "Google Cloud Firestore",
        "description": "Interact with Google Firebase - Cloud Firestore API",
        "group": "input",
        "keywords": [
            "google",
            "cloud",
            "firestore",
            "input",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Firebase/CloudFirestore/googleFirebaseCloudFirestore.png"
        },
        "operations": {
            "document": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "query",
                "__CUSTOM_API_CALL__"
            ],
            "collection": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleFirebaseRealtimeDatabase",
        "displayName": "Google Cloud Realtime Database",
        "description": "Interact with Google Firebase - Realtime Database API",
        "group": "input",
        "keywords": [
            "google",
            "cloud",
            "realtime",
            "database",
            "input",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Firebase/RealtimeDatabase/googleFirebaseRealtimeDatabase.svg"
        },
        "operations": {
            "_": [
                "create",
                "delete",
                "get",
                "push",
                "update",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.gmail",
        "displayName": "Gmail",
        "description": "Consume the Gmail API",
        "group": "transform",
        "keywords": [
            "gmail",
            "transform",
            "communication",
            "hitl",
            "email",
            "human",
            "form",
            "wait",
            "approval",
            "the",
            "loop"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Gmail/gmail.svg"
        },
        "operations": {
            "draft": [
                "create",
                "delete",
                "get",
                "getAll"
            ],
            "label": [
                "create",
                "delete",
                "get",
                "getAll"
            ],
            "message": [
                "addLabels",
                "delete",
                "get",
                "getAll",
                "markAsRead",
                "markAsUnread",
                "removeLabels",
                "reply",
                "send",
                "sendAndWait"
            ],
            "thread": [
                "addLabels",
                "delete",
                "get",
                "getAll",
                "removeLabels",
                "reply",
                "trash",
                "untrash"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.gmailTrigger",
        "displayName": "Gmail Trigger",
        "description": "Fetches emails from Gmail and starts the workflow on specified polling intervals.",
        "group": "trigger",
        "keywords": [
            "gmail",
            "trigger",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Gmail/gmail.svg"
        }
    },
    {
        "name": "n8n-nodes-base.gSuiteAdmin",
        "displayName": "Google Workspace Admin",
        "description": "Consume Google Workspace Admin API",
        "group": "input",
        "keywords": [
            "google",
            "workspace",
            "admin",
            "input",
            "utility",
            "workspaces"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/GSuiteAdmin/gSuiteAdmin.svg"
        },
        "operations": {
            "device": [
                "get",
                "getAll",
                "update",
                "changeStatus",
                "__CUSTOM_API_CALL__"
            ],
            "group": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "addToGroup",
                "create",
                "delete",
                "get",
                "getAll",
                "removeFromGroup",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleBusinessProfile",
        "displayName": "Google Business Profile",
        "description": "Consume Google Business Profile API",
        "group": "input",
        "keywords": [
            "google",
            "business",
            "profile",
            "input",
            "marketing",
            "productivity",
            "gmb"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/BusinessProfile/googleBusinessProfile.svg"
        },
        "operations": {
            "post": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "review": [
                "delete",
                "get",
                "getAll",
                "reply",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleBusinessProfileTrigger",
        "displayName": "Google Business Profile Trigger",
        "description": "Fetches reviews from Google Business Profile and starts the workflow on specified polling intervals.",
        "group": "trigger",
        "keywords": [
            "google",
            "business",
            "profile",
            "trigger",
            "communication",
            "gmb"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/BusinessProfile/googleBusinessProfile.svg"
        }
    },
    {
        "name": "n8n-nodes-base.googlePerspective",
        "displayName": "Google Perspective",
        "description": "Consume Google Perspective API",
        "group": "transform",
        "keywords": [
            "google",
            "perspective",
            "transform",
            "analytics",
            "utility",
            "moderation"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Perspective/googlePerspective.svg",
            "darkValue": "nodes/Google/Perspective/googlePerspective.dark.svg"
        },
        "operations": {
            "_": [
                "analyzeComment",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.googleSheets",
        "displayName": "Google Sheets",
        "description": "Read, update and write data to Google Sheets",
        "group": "input",
        "keywords": [
            "google",
            "sheets",
            "input",
            "output",
            "data",
            "storage",
            "productivity",
            "csv",
            "sheet",
            "spreadsheet"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Sheet/googleSheets.svg"
        },
        "operations": {
            "sheet": [
                "appendOrUpdate",
                "append",
                "clear",
                "create",
                "remove",
                "delete",
                "read",
                "update"
            ],
            "spreadsheet": [
                "create",
                "deleteSpreadsheet"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.googleSheetsTrigger",
        "displayName": "Google Sheets Trigger",
        "description": "Starts the workflow when Google Sheets events occur",
        "group": "trigger",
        "keywords": [
            "google",
            "sheets",
            "trigger",
            "data",
            "storage",
            "productivity",
            "csv",
            "spreadsheet"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Sheet/googleSheets.svg"
        }
    },
    {
        "name": "n8n-nodes-base.googleSlides",
        "displayName": "Google Slides",
        "description": "Consume the Google Slides API",
        "group": "input",
        "keywords": [
            "google",
            "slides",
            "input",
            "output",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Slides/googleslides.svg"
        },
        "operations": {
            "presentation": [
                "create",
                "get",
                "getSlides",
                "replaceText",
                "__CUSTOM_API_CALL__"
            ],
            "page": [
                "get",
                "getThumbnail",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleTasks",
        "displayName": "Google Tasks",
        "description": "Consume Google Tasks API",
        "group": "input",
        "keywords": [
            "google",
            "tasks",
            "input",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Task/googleTasks.svg"
        },
        "operations": {
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleTranslate",
        "displayName": "Google Translate",
        "description": "Translate data using Google Translate",
        "group": "input",
        "keywords": [
            "google",
            "translate",
            "input",
            "output",
            "utility"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Translate/googletranslate.png"
        },
        "operations": {
            "language": [
                "translate",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.youTube",
        "displayName": "YouTube",
        "description": "Consume YouTube API",
        "group": "input",
        "keywords": [
            "youtube",
            "input",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/YouTube/youTube.png"
        },
        "operations": {
            "channel": [
                "get",
                "getAll",
                "update",
                "uploadBanner",
                "__CUSTOM_API_CALL__"
            ],
            "playlist": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "playlistItem": [
                "add",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "video": [
                "delete",
                "get",
                "getAll",
                "rate",
                "update",
                "upload",
                "__CUSTOM_API_CALL__"
            ],
            "videoCategory": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.gotify",
        "displayName": "Gotify",
        "description": "Consume Gotify API",
        "group": "input",
        "keywords": [
            "gotify",
            "input",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Gotify/gotify.png"
        },
        "operations": {
            "message": [
                "create",
                "delete",
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.goToWebinar",
        "displayName": "GoToWebinar",
        "description": "Consume the GoToWebinar API",
        "group": "transform",
        "keywords": [
            "gotowebinar",
            "transform",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/GoToWebinar/gotowebinar.svg"
        },
        "operations": {
            "attendee": [
                "get",
                "getAll",
                "getDetails",
                "__CUSTOM_API_CALL__"
            ],
            "coorganizer": [
                "create",
                "delete",
                "getAll",
                "reinvite",
                "__CUSTOM_API_CALL__"
            ],
            "panelist": [
                "create",
                "delete",
                "getAll",
                "reinvite",
                "__CUSTOM_API_CALL__"
            ],
            "registrant": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "session": [
                "get",
                "getAll",
                "getDetails",
                "__CUSTOM_API_CALL__"
            ],
            "webinar": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.grafana",
        "displayName": "Grafana",
        "description": "Consume the Grafana API",
        "group": "transform",
        "keywords": [
            "grafana",
            "transform",
            "development",
            "analytics",
            "prometheus"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Grafana/grafana.svg"
        },
        "operations": {
            "dashboard": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "team": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "teamMember": [
                "add",
                "getAll",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "delete",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.graphql",
        "displayName": "GraphQL",
        "description": "Makes a GraphQL request and returns the received data",
        "group": "input",
        "keywords": [
            "graphql",
            "input",
            "data",
            "storage",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/GraphQL/graphql.png"
        }
    },
    {
        "name": "n8n-nodes-base.grist",
        "displayName": "Grist",
        "description": "Consume the Grist API",
        "group": "input",
        "keywords": [
            "grist",
            "input",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Grist/grist.svg"
        },
        "operations": {
            "_": [
                "create",
                "delete",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.gumroadTrigger",
        "displayName": "Gumroad Trigger",
        "description": "Handle Gumroad events via webhooks",
        "group": "trigger",
        "keywords": [
            "gumroad",
            "trigger",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Gumroad/gumroad.png"
        }
    },
    {
        "name": "n8n-nodes-base.hackerNews",
        "displayName": "Hacker News",
        "description": "Consume Hacker News API",
        "group": "transform",
        "keywords": [
            "hacker",
            "news",
            "transform",
            "communication",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/HackerNews/hackernews.png"
        },
        "operations": {
            "all": [
                "getAll"
            ],
            "article": [
                "get"
            ],
            "user": [
                "get"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.haloPSA",
        "displayName": "HaloPSA",
        "description": "Consume HaloPSA API",
        "group": "input",
        "keywords": [
            "halopsa",
            "input",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/HaloPSA/halopsa.svg"
        },
        "operations": {
            "client": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "ticket": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "site": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "user": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.harvest",
        "displayName": "Harvest",
        "description": "Access data on Harvest",
        "group": "input",
        "keywords": [
            "harvest",
            "input",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Harvest/harvest.png"
        },
        "operations": {
            "client": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "company": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "contact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "estimate": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "expense": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "invoice": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "project": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "timeEntry": [
                "createByDuration",
                "createByStartEnd",
                "delete",
                "deleteExternal",
                "get",
                "getAll",
                "restartTime",
                "stopTime",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "create",
                "delete",
                "get",
                "getAll",
                "me",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.helpScout",
        "displayName": "Help Scout",
        "description": "Consume Help Scout API",
        "group": "input",
        "keywords": [
            "help",
            "scout",
            "input",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/HelpScout/helpScout.svg"
        },
        "operations": {
            "conversation": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "customer": [
                "create",
                "get",
                "getAll",
                "properties",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "mailbox": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "thread": [
                "create",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.helpScoutTrigger",
        "displayName": "Help Scout Trigger",
        "description": "Starts the workflow when Help Scout events occur",
        "group": "trigger",
        "keywords": [
            "help",
            "scout",
            "trigger",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/HelpScout/helpScout.svg"
        }
    },
    {
        "name": "n8n-nodes-base.highLevel",
        "displayName": "HighLevel",
        "description": "Consume HighLevel API v2",
        "group": "transform",
        "keywords": [
            "highlevel",
            "transform",
            "marketing",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/HighLevel/highLevel.svg"
        },
        "operations": {
            "contact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "opportunity": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "calendar": [
                "bookAppointment",
                "getFreeSlots",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.homeAssistant",
        "displayName": "Home Assistant",
        "description": "Consume Home Assistant API",
        "group": "output",
        "keywords": [
            "home",
            "assistant",
            "output",
            "miscellaneous"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/HomeAssistant/homeAssistant.svg"
        },
        "operations": {
            "cameraProxy": [
                "getScreenshot"
            ],
            "config": [
                "get",
                "check"
            ],
            "event": [
                "create",
                "getAll"
            ],
            "history": [
                "getAll"
            ],
            "log": [
                "getErroLogs",
                "getLogbookEntries"
            ],
            "service": [
                "call",
                "getAll"
            ],
            "state": [
                "upsert",
                "get",
                "getAll"
            ],
            "template": [
                "create"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.htmlExtract",
        "displayName": "HTML Extract",
        "description": "Extracts data from HTML",
        "group": "transform",
        "keywords": [
            "html",
            "extract",
            "transform",
            "core",
            "nodes",
            "helpers",
            "data",
            "transformation"
        ],
        "icon": {
            "type": "fa",
            "value": "cut"
        }
    },
    {
        "name": "n8n-nodes-base.html",
        "displayName": "HTML",
        "description": "Work with HTML",
        "group": "transform",
        "keywords": [
            "html",
            "transform",
            "core",
            "nodes",
            "extract",
            "template",
            "table",
            "data",
            "transformation"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Html/html.svg",
            "darkValue": "nodes/Html/html.dark.svg"
        },
        "operations": {
            "_": [
                "generateHtmlTemplate",
                "extractHtmlContent",
                "convertToHtmlTable"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.httpRequest",
        "displayName": "HTTP Request",
        "description": "Makes an HTTP request and returns the response data",
        "group": "output",
        "keywords": [
            "http",
            "request",
            "output",
            "development",
            "core",
            "nodes",
            "api",
            "url",
            "build",
            "curl",
            "helpers"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/HttpRequest/httprequest.svg",
            "darkValue": "nodes/HttpRequest/httprequest.dark.svg"
        }
    },
    {
        "name": "n8n-nodes-base.hubspot",
        "displayName": "HubSpot",
        "description": "Consume HubSpot API",
        "group": "output",
        "keywords": [
            "hubspot",
            "output",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Hubspot/hubspot.svg"
        },
        "operations": {
            "contact": [
                "upsert",
                "delete",
                "get",
                "getAll",
                "getRecentlyCreatedUpdated",
                "search"
            ],
            "contactList": [
                "add",
                "remove"
            ],
            "company": [
                "create",
                "delete",
                "get",
                "getAll",
                "getRecentlyCreatedUpdated",
                "searchByDomain",
                "update"
            ],
            "deal": [
                "create",
                "delete",
                "get",
                "getAll",
                "getRecentlyCreatedUpdated",
                "search",
                "update"
            ],
            "engagement": [
                "create",
                "delete",
                "get",
                "getAll"
            ],
            "ticket": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.hubspotTrigger",
        "displayName": "HubSpot Trigger",
        "description": "Starts the workflow when HubSpot events occur",
        "group": "trigger",
        "keywords": [
            "hubspot",
            "trigger",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Hubspot/hubspot.svg"
        }
    },
    {
        "name": "n8n-nodes-base.humanticAi",
        "displayName": "Humantic AI",
        "description": "Consume Humantic AI API",
        "group": "output",
        "keywords": [
            "humantic",
            "output",
            "analytics"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/HumanticAI/humanticai.svg"
        },
        "operations": {
            "profile": [
                "create",
                "get",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.hunter",
        "displayName": "Hunter",
        "description": "Consume Hunter API",
        "group": "output",
        "keywords": [
            "hunter",
            "output",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Hunter/hunter.png"
        },
        "operations": {
            "_": [
                "domainSearch",
                "emailFinder",
                "emailVerifier"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.iCal",
        "displayName": "iCalendar",
        "description": "Create iCalendar file",
        "group": "input",
        "keywords": [
            "icalendar",
            "input",
            "core",
            "nodes",
            "productivity",
            "ics",
            "files"
        ],
        "icon": {
            "type": "fa",
            "value": "calendar"
        },
        "operations": {
            "_": [
                "createEventFile"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.if",
        "displayName": "If",
        "description": "Route items to different branches (true/false)",
        "group": "transform",
        "keywords": [
            "transform",
            "core",
            "nodes",
            "router",
            "filter",
            "condition",
            "logic",
            "boolean",
            "branch",
            "flow"
        ],
        "icon": {
            "type": "fa",
            "value": "map-signs",
            "color": "green"
        }
    },
    {
        "name": "n8n-nodes-base.intercom",
        "displayName": "Intercom",
        "description": "Consume Intercom API",
        "group": "output",
        "keywords": [
            "intercom",
            "output",
            "communication",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Intercom/intercom.svg"
        },
        "operations": {
            "lead": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "company": [
                "create",
                "get",
                "getAll",
                "update",
                "users",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.interval",
        "displayName": "Interval",
        "description": "Triggers the workflow in a given interval",
        "group": "trigger",
        "keywords": [
            "interval",
            "trigger",
            "schedule",
            "core",
            "nodes",
            "time",
            "scheduler",
            "polling",
            "flow",
            "other"
        ],
        "icon": {
            "type": "fa",
            "value": "hourglass"
        }
    },
    {
        "name": "n8n-nodes-base.invoiceNinja",
        "displayName": "Invoice Ninja",
        "description": "Consume Invoice Ninja API",
        "group": "output",
        "keywords": [
            "invoice",
            "ninja",
            "output",
            "finance",
            "accounting"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/InvoiceNinja/invoiceNinja.svg"
        },
        "operations": {
            "client": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "invoice": [
                "create",
                "delete",
                "email",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "payment": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "expense": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "quote": [
                "create",
                "delete",
                "email",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "bank_transaction": [
                "create",
                "delete",
                "get",
                "getAll",
                "matchPayment",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.invoiceNinjaTrigger",
        "displayName": "Invoice Ninja Trigger",
        "description": "Starts the workflow when Invoice Ninja events occur",
        "group": "trigger",
        "keywords": [
            "invoice",
            "ninja",
            "trigger",
            "finance",
            "accounting"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/InvoiceNinja/invoiceNinja.svg"
        }
    },
    {
        "name": "n8n-nodes-base.itemLists",
        "displayName": "Item Lists",
        "description": "Helper for working with lists of items and transforming arrays",
        "group": "input",
        "keywords": [
            "item",
            "lists",
            "input",
            "core",
            "nodes",
            "aggregate",
            "dedupe",
            "deduplicate",
            "duplicates",
            "limit",
            "remove",
            "slice",
            "sort",
            "split",
            "unique",
            "json",
            "transform",
            "array",
            "list",
            "object",
            "map",
            "format",
            "nested",
            "iterate",
            "summarise",
            "summarize",
            "group",
            "pivot",
            "sum",
            "count",
            "min",
            "max",
            "helpers",
            "data",
            "transformation"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/ItemLists/itemLists.svg"
        },
        "operations": {
            "_": [
                "concatenateItems",
                "limit",
                "removeDuplicates",
                "sort",
                "splitOutItems",
                "summarize"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.iterable",
        "displayName": "Iterable",
        "description": "Consume Iterable API",
        "group": "input",
        "keywords": [
            "iterable",
            "input",
            "communication",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Iterable/iterable.png"
        },
        "operations": {
            "event": [
                "track",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "upsert",
                "delete",
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "userList": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.jenkins",
        "displayName": "Jenkins",
        "description": "Consume Jenkins API",
        "group": "output",
        "keywords": [
            "jenkins",
            "output",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Jenkins/jenkins.svg"
        },
        "operations": {
            "job": [
                "copy",
                "create",
                "trigger",
                "triggerParams"
            ],
            "instance": [
                "cancelQuietDown",
                "quietDown",
                "restart",
                "safeRestart",
                "safeExit",
                "exit"
            ],
            "build": [
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.jinaAi",
        "displayName": "Jina AI",
        "description": "Interact with Jina AI API",
        "group": "transform",
        "keywords": [
            "jina",
            "transform",
            "miscellaneous"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/JinaAI/jinaAi.svg",
            "darkValue": "nodes/JinaAI/jinaAi.dark.svg"
        },
        "operations": {
            "reader": [
                "read",
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "research": [
                "deepResearch",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.jira",
        "displayName": "Jira Software",
        "description": "Consume Jira Software API",
        "group": "output",
        "keywords": [
            "jira",
            "software",
            "output",
            "development",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Jira/jira.svg"
        },
        "operations": {
            "issue": [
                "changelog",
                "create",
                "delete",
                "get",
                "getAll",
                "notify",
                "transitions",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "issueAttachment": [
                "add",
                "get",
                "getAll",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "issueComment": [
                "add",
                "get",
                "getAll",
                "remove",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "create",
                "delete",
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.jiraTrigger",
        "displayName": "Jira Trigger",
        "description": "Starts the workflow when Jira events occur",
        "group": "trigger",
        "keywords": [
            "jira",
            "trigger",
            "development",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Jira/jira.svg"
        }
    },
    {
        "name": "n8n-nodes-base.jotFormTrigger",
        "displayName": "Jotform Trigger",
        "description": "Handle Jotform events via webhooks",
        "group": "trigger",
        "keywords": [
            "jotform",
            "trigger",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/JotForm/jotform.svg",
            "darkValue": "nodes/JotForm/jotform.dark.svg"
        }
    },
    {
        "name": "n8n-nodes-base.jwt",
        "displayName": "JWT",
        "description": "JWT",
        "group": "transform",
        "keywords": [
            "jwt",
            "transform",
            "development",
            "token",
            "key",
            "json",
            "payload",
            "sign",
            "verify",
            "decode"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Jwt/jwt.svg"
        },
        "operations": {
            "_": [
                "decode",
                "sign",
                "verify"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.kafka",
        "displayName": "Kafka",
        "description": "Sends messages to a Kafka topic",
        "group": "transform",
        "keywords": [
            "kafka",
            "transform",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Kafka/kafka.svg",
            "darkValue": "nodes/Kafka/kafka.dark.svg"
        }
    },
    {
        "name": "n8n-nodes-base.kafkaTrigger",
        "displayName": "Kafka Trigger",
        "description": "Consume messages from a Kafka topic",
        "group": "trigger",
        "keywords": [
            "kafka",
            "trigger",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Kafka/kafka.svg",
            "darkValue": "nodes/Kafka/kafka.dark.svg"
        }
    },
    {
        "name": "n8n-nodes-base.keap",
        "displayName": "Keap",
        "description": "Consume Keap API",
        "group": "input",
        "keywords": [
            "keap",
            "input",
            "sales",
            "communication",
            "infusionsoft"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Keap/keap.png"
        },
        "operations": {
            "company": [
                "create",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "contact": [
                "upsert",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "contactNote": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "contactTag": [
                "create",
                "delete",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "ecommerceOrder": [
                "create",
                "get",
                "delete",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "ecommerceProduct": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "email": [
                "createRecord",
                "getAll",
                "send",
                "__CUSTOM_API_CALL__"
            ],
            "file": [
                "delete",
                "getAll",
                "upload",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.keapTrigger",
        "displayName": "Keap Trigger",
        "description": "Starts the workflow when Infusionsoft events occur",
        "group": "trigger",
        "keywords": [
            "keap",
            "trigger",
            "sales",
            "communication",
            "infusionsoft"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Keap/keap.png"
        }
    },
    {
        "name": "n8n-nodes-base.koBoToolbox",
        "displayName": "KoBoToolbox",
        "description": "Work with KoBoToolbox forms and submissions",
        "group": "transform",
        "keywords": [
            "kobotoolbox",
            "transform",
            "communication",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/KoBoToolbox/koBoToolbox.svg"
        },
        "operations": {
            "form": [
                "get",
                "getAll",
                "redeploy",
                "__CUSTOM_API_CALL__"
            ],
            "hook": [
                "get",
                "getAll",
                "getLogs",
                "retryAll",
                "retryOne",
                "__CUSTOM_API_CALL__"
            ],
            "submission": [
                "delete",
                "get",
                "getAll",
                "getValidation",
                "setValidation",
                "__CUSTOM_API_CALL__"
            ],
            "file": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.koBoToolboxTrigger",
        "displayName": "KoBoToolbox Trigger",
        "description": "Process KoBoToolbox submissions",
        "group": "trigger",
        "keywords": [
            "kobotoolbox",
            "trigger",
            "communication",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/KoBoToolbox/koBoToolbox.svg"
        }
    },
    {
        "name": "n8n-nodes-base.ldap",
        "displayName": "Ldap",
        "description": "Interact with LDAP servers",
        "group": "transform",
        "keywords": [
            "ldap",
            "transform",
            "development",
            "developer",
            "tools",
            "active",
            "directory"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Ldap/ldap.svg",
            "darkValue": "nodes/Ldap/ldap.dark.svg"
        },
        "operations": {
            "_": [
                "compare",
                "create",
                "delete",
                "rename",
                "search",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.lemlist",
        "displayName": "Lemlist",
        "description": "Consume the Lemlist API",
        "group": "transform",
        "keywords": [
            "lemlist",
            "transform",
            "communication",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Lemlist/lemlist.svg"
        },
        "operations": {
            "activity": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "campaign": [
                "getAll",
                "getStats",
                "__CUSTOM_API_CALL__"
            ],
            "enrich": [
                "get",
                "enrichLead",
                "enrichPerson",
                "__CUSTOM_API_CALL__"
            ],
            "lead": [
                "create",
                "delete",
                "get",
                "unsubscribe",
                "__CUSTOM_API_CALL__"
            ],
            "team": [
                "get",
                "getCredits",
                "__CUSTOM_API_CALL__"
            ],
            "unsubscribe": [
                "add",
                "delete",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.lemlistTrigger",
        "displayName": "Lemlist Trigger",
        "description": "Handle Lemlist events via webhooks",
        "group": "trigger",
        "keywords": [
            "lemlist",
            "trigger",
            "communication",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Lemlist/lemlist.svg"
        }
    },
    {
        "name": "n8n-nodes-base.line",
        "displayName": "Line",
        "description": "Consume Line API",
        "group": "input",
        "keywords": [
            "line",
            "input",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Line/line.png"
        },
        "operations": {
            "notification": [
                "send",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.linear",
        "displayName": "Linear",
        "description": "Consume Linear API",
        "group": "output",
        "keywords": [
            "linear",
            "output",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Linear/linear.svg"
        },
        "operations": {
            "comment": [
                "addComment",
                "__CUSTOM_API_CALL__"
            ],
            "issue": [
                "addLink",
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.linearTrigger",
        "displayName": "Linear Trigger",
        "description": "Starts the workflow when Linear events occur",
        "group": "trigger",
        "keywords": [
            "linear",
            "trigger",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Linear/linear.svg"
        }
    },
    {
        "name": "n8n-nodes-base.lingvaNex",
        "displayName": "LingvaNex",
        "description": "Consume LingvaNex API",
        "group": "output",
        "keywords": [
            "lingvanex",
            "output",
            "miscellaneous"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/LingvaNex/lingvanex.png"
        },
        "operations": {
            "_": [
                "translate"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.linkedIn",
        "displayName": "LinkedIn",
        "description": "Consume LinkedIn API",
        "group": "input",
        "keywords": [
            "linkedin",
            "input",
            "marketing",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/LinkedIn/linkedin.svg"
        },
        "operations": {
            "post": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.loneScaleTrigger",
        "displayName": "LoneScale Trigger",
        "description": "Trigger LoneScale Workflow",
        "group": "trigger",
        "keywords": [
            "lonescale",
            "trigger",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/LoneScale/loneScale.svg",
            "darkValue": "nodes/LoneScale/loneScale.dark.svg"
        }
    },
    {
        "name": "n8n-nodes-base.loneScale",
        "displayName": "LoneScale",
        "description": "Create List, add / delete items",
        "group": "transform",
        "keywords": [
            "lonescale",
            "transform",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/LoneScale/loneScale.svg",
            "darkValue": "nodes/LoneScale/loneScale.dark.svg"
        },
        "operations": {
            "list": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "item": [
                "add",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.magento2",
        "displayName": "Magento 2",
        "description": "Consume Magento API",
        "group": "input",
        "keywords": [
            "magento",
            "input",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Magento/magento.svg"
        },
        "operations": {
            "customer": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "invoice": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "order": [
                "cancel",
                "get",
                "getAll",
                "ship",
                "__CUSTOM_API_CALL__"
            ],
            "product": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.mailcheck",
        "displayName": "Mailcheck",
        "description": "Consume Mailcheck API",
        "group": "transform",
        "keywords": [
            "mailcheck",
            "transform",
            "utility",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Mailcheck/mailcheck.svg"
        },
        "operations": {
            "email": [
                "check"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.mailchimp",
        "displayName": "Mailchimp",
        "description": "Consume Mailchimp API",
        "group": "output",
        "keywords": [
            "mailchimp",
            "output",
            "marketing",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Mailchimp/mailchimp.svg",
            "darkValue": "nodes/Mailchimp/mailchimp.dark.svg"
        },
        "operations": {
            "member": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "memberTag": [
                "create",
                "delete",
                "__CUSTOM_API_CALL__"
            ],
            "listGroup": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "campaign": [
                "delete",
                "get",
                "getAll",
                "replicate",
                "resend",
                "send",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.mailchimpTrigger",
        "displayName": "Mailchimp Trigger",
        "description": "Handle Mailchimp events via webhooks",
        "group": "trigger",
        "keywords": [
            "mailchimp",
            "trigger",
            "marketing",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Mailchimp/mailchimp.svg",
            "darkValue": "nodes/Mailchimp/mailchimp.dark.svg"
        }
    },
    {
        "name": "n8n-nodes-base.mailerLite",
        "displayName": "MailerLite",
        "description": "Consume Mailer Lite API",
        "group": "input",
        "keywords": [
            "mailerlite",
            "input",
            "communication",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/MailerLite/MailerLite.svg"
        },
        "operations": {
            "subscriber": [
                "create",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.mailerLiteTrigger",
        "displayName": "MailerLite Trigger",
        "description": "Starts the workflow when MailerLite events occur",
        "group": "trigger",
        "keywords": [
            "mailerlite",
            "trigger",
            "communication",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/MailerLite/MailerLite.svg"
        }
    },
    {
        "name": "n8n-nodes-base.mailgun",
        "displayName": "Mailgun",
        "description": "Sends an email via Mailgun",
        "group": "output",
        "keywords": [
            "mailgun",
            "output",
            "communication",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Mailgun/mailgun.svg"
        }
    },
    {
        "name": "n8n-nodes-base.mailjet",
        "displayName": "Mailjet",
        "description": "Consume Mailjet API",
        "group": "output",
        "keywords": [
            "mailjet",
            "output",
            "communication",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Mailjet/mailjet.svg"
        },
        "operations": {
            "email": [
                "send",
                "sendTemplate",
                "__CUSTOM_API_CALL__"
            ],
            "sms": [
                "send",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.mailjetTrigger",
        "displayName": "Mailjet Trigger",
        "description": "Handle Mailjet events via webhooks",
        "group": "trigger",
        "keywords": [
            "mailjet",
            "trigger",
            "communication",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Mailjet/mailjet.svg"
        }
    },
    {
        "name": "n8n-nodes-base.mandrill",
        "displayName": "Mandrill",
        "description": "Consume Mandrill API",
        "group": "output",
        "keywords": [
            "mandrill",
            "output",
            "communication",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Mandrill/mandrill.svg"
        },
        "operations": {
            "message": [
                "sendTemplate",
                "sendHtml"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.manualTrigger",
        "displayName": "Manual Trigger",
        "description": "Runs the flow on clicking a button in n8n",
        "group": "trigger",
        "keywords": [
            "manual",
            "trigger",
            "core",
            "nodes",
            "when",
            "clicking",
            "execute",
            "workflow"
        ],
        "icon": {
            "type": "fa",
            "value": "mouse-pointer"
        }
    },
    {
        "name": "n8n-nodes-base.markdown",
        "displayName": "Markdown",
        "description": "Convert data between Markdown and HTML",
        "group": "output",
        "keywords": [
            "markdown",
            "output",
            "core",
            "nodes",
            "data",
            "transformation"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Markdown/markdown.svg",
            "darkValue": "nodes/Markdown/markdown.dark.svg"
        }
    },
    {
        "name": "n8n-nodes-base.marketstack",
        "displayName": "Marketstack",
        "description": "Consume Marketstack API",
        "group": "transform",
        "keywords": [
            "marketstack",
            "transform",
            "analytics",
            "finance",
            "accounting"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Marketstack/marketstack.svg",
            "darkValue": "nodes/Marketstack/marketstack.dark.svg"
        },
        "operations": {
            "endOfDayData": [
                "getAll"
            ],
            "exchange": [
                "get"
            ],
            "ticker": [
                "get"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.matrix",
        "displayName": "Matrix",
        "description": "Consume Matrix API",
        "group": "output",
        "keywords": [
            "matrix",
            "output",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Matrix/matrix.png"
        },
        "operations": {
            "account": [
                "me"
            ],
            "event": [
                "get"
            ],
            "media": [
                "upload"
            ],
            "message": [
                "create",
                "getAll"
            ],
            "room": [
                "create",
                "invite",
                "join",
                "kick",
                "leave"
            ],
            "roomMember": [
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.mattermost",
        "displayName": "Mattermost",
        "description": "Sends data to Mattermost",
        "group": "output",
        "keywords": [
            "mattermost",
            "output",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Mattermost/mattermost.svg"
        },
        "operations": {
            "channel": [
                "addUser",
                "create",
                "delete",
                "members",
                "restore",
                "search",
                "statistics",
                "__CUSTOM_API_CALL__"
            ],
            "message": [
                "delete",
                "post",
                "postEphemeral",
                "__CUSTOM_API_CALL__"
            ],
            "reaction": [
                "create",
                "delete",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "create",
                "deactive",
                "getByEmail",
                "getById",
                "getAll",
                "invite",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.mautic",
        "displayName": "Mautic",
        "description": "Consume Mautic API",
        "group": "output",
        "keywords": [
            "mautic",
            "output",
            "marketing",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Mautic/mautic.svg"
        },
        "operations": {
            "company": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "contact": [
                "create",
                "delete",
                "editContactPoint",
                "editDoNotContactList",
                "get",
                "getAll",
                "sendEmail",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "contactSegment": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "campaignContact": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "companyContact": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "segmentEmail": [
                "send",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.mauticTrigger",
        "displayName": "Mautic Trigger",
        "description": "Handle Mautic events via webhooks",
        "group": "trigger",
        "keywords": [
            "mautic",
            "trigger",
            "marketing",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Mautic/mautic.svg"
        }
    },
    {
        "name": "n8n-nodes-base.medium",
        "displayName": "Medium",
        "description": "Consume Medium API",
        "group": "output",
        "keywords": [
            "medium",
            "output",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Medium/medium.png"
        },
        "operations": {
            "post": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "publication": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.merge",
        "displayName": "Merge",
        "description": "Merges data of multiple streams once data from both is available",
        "group": "transform",
        "keywords": [
            "merge",
            "transform",
            "core",
            "nodes",
            "join",
            "concatenate",
            "wait",
            "flow",
            "data",
            "transformation"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Merge/merge.svg"
        }
    },
    {
        "name": "n8n-nodes-base.messageBird",
        "displayName": "MessageBird",
        "description": "Sends SMS via MessageBird",
        "group": "output",
        "keywords": [
            "messagebird",
            "output",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/MessageBird/messagebird.svg"
        },
        "operations": {
            "sms": [
                "send"
            ],
            "balance": [
                "get"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.metabase",
        "displayName": "Metabase",
        "description": "Use the Metabase API",
        "group": "transform",
        "keywords": [
            "metabase",
            "transform",
            "development",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Metabase/metabase.svg"
        },
        "operations": {
            "questions": [
                "get",
                "getAll",
                "resultData",
                "__CUSTOM_API_CALL__"
            ],
            "metrics": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "databases": [
                "addNewDatasource",
                "getAll",
                "getFields",
                "__CUSTOM_API_CALL__"
            ],
            "alerts": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.azureCosmosDb",
        "displayName": "Azure Cosmos DB",
        "description": "Interact with Azure Cosmos DB API",
        "group": "transform",
        "keywords": [
            "azure",
            "cosmos",
            "transform",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/AzureCosmosDb/AzureCosmosDb.svg",
            "darkValue": "nodes/Microsoft/AzureCosmosDb/AzureCosmosDb.svg"
        },
        "operations": {
            "container": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "item": [
                "create",
                "delete",
                "get",
                "getAll",
                "query",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.microsoftDynamicsCrm",
        "displayName": "Microsoft Dynamics CRM",
        "description": "Consume Microsoft Dynamics CRM API",
        "group": "input",
        "keywords": [
            "microsoft",
            "dynamics",
            "crm",
            "input",
            "marketing",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/Dynamics/microsoftDynamicsCrm.svg",
            "darkValue": "nodes/Microsoft/Dynamics/microsoftDynamicsCrm.dark.svg"
        },
        "operations": {
            "account": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.microsoftEntra",
        "displayName": "Microsoft Entra ID",
        "description": "Interact with Microsoft Entra ID API",
        "group": "transform",
        "keywords": [
            "microsoft",
            "entra",
            "transform",
            "development",
            "developer",
            "tools"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/Entra/microsoftEntra.svg",
            "darkValue": "nodes/Microsoft/Entra/microsoftEntra.dark.svg"
        },
        "operations": {
            "group": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "user": [
                "addGroup",
                "create",
                "delete",
                "get",
                "getAll",
                "removeGroup",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.microsoftExcel",
        "displayName": "Microsoft Excel 365",
        "description": "Consume Microsoft Excel API",
        "group": "input",
        "keywords": [
            "microsoft",
            "excel",
            "365",
            "input",
            "data",
            "storage",
            "productivity",
            "sheet",
            "csv",
            "spreadsheet"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/Excel/excel.svg"
        },
        "operations": {
            "table": [
                "append",
                "convertToRange",
                "addTable",
                "deleteTable",
                "getColumns",
                "getRows",
                "lookup"
            ],
            "workbook": [
                "addWorksheet",
                "deleteWorkbook",
                "getAll"
            ],
            "worksheet": [
                "append",
                "upsert",
                "clear",
                "deleteWorksheet",
                "getAll",
                "readRows",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.microsoftGraphSecurity",
        "displayName": "Microsoft Graph Security",
        "description": "Consume the Microsoft Graph Security API",
        "group": "transform",
        "keywords": [
            "microsoft",
            "graph",
            "security",
            "transform",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/GraphSecurity/microsoftGraph.svg"
        },
        "operations": {
            "secureScore": [
                "get",
                "getAll"
            ],
            "secureScoreControlProfile": [
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.microsoftOneDrive",
        "displayName": "Microsoft OneDrive",
        "description": "Consume Microsoft OneDrive API",
        "group": "input",
        "keywords": [
            "microsoft",
            "onedrive",
            "input",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/OneDrive/oneDrive.svg"
        },
        "operations": {
            "file": [
                "copy",
                "delete",
                "download",
                "get",
                "rename",
                "search",
                "share",
                "upload"
            ],
            "folder": [
                "create",
                "delete",
                "getChildren",
                "rename",
                "search",
                "share"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.microsoftOneDriveTrigger",
        "displayName": "Microsoft OneDrive Trigger",
        "description": "Trigger for Microsoft OneDrive API.",
        "group": "trigger",
        "keywords": [
            "microsoft",
            "onedrive",
            "trigger",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/OneDrive/oneDrive.svg"
        }
    },
    {
        "name": "n8n-nodes-base.microsoftOutlook",
        "displayName": "Microsoft Outlook",
        "description": "Consume Microsoft Outlook API",
        "group": "transform",
        "keywords": [
            "microsoft",
            "outlook",
            "transform",
            "communication",
            "hitl",
            "email",
            "human",
            "form",
            "wait",
            "approval",
            "the",
            "loop"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/Outlook/outlook.svg"
        },
        "operations": {
            "calendar": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "contact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "draft": [
                "create",
                "delete",
                "get",
                "send",
                "update"
            ],
            "event": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "folder": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "folderMessage": [
                "getAll"
            ],
            "message": [
                "delete",
                "get",
                "getAll",
                "move",
                "reply",
                "send",
                "sendAndWait",
                "update"
            ],
            "messageAttachment": [
                "add",
                "download",
                "get",
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.microsoftOutlookTrigger",
        "displayName": "Microsoft Outlook Trigger",
        "description": "Fetches emails from Microsoft Outlook and starts the workflow on specified polling intervals.",
        "group": "trigger",
        "keywords": [
            "microsoft",
            "outlook",
            "trigger",
            "communication",
            "email"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/Outlook/outlook.svg"
        }
    },
    {
        "name": "n8n-nodes-base.microsoftSharePoint",
        "displayName": "Microsoft SharePoint",
        "description": "Interact with Microsoft SharePoint API",
        "group": "transform",
        "keywords": [
            "microsoft",
            "sharepoint",
            "transform"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/SharePoint/microsoftSharePoint.svg",
            "darkValue": "nodes/Microsoft/SharePoint/microsoftSharePoint.svg"
        },
        "operations": {
            "file": [
                "download",
                "update",
                "upload"
            ],
            "item": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "list": [
                "get",
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.microsoftSql",
        "displayName": "Microsoft SQL",
        "description": "Get, add and update data in Microsoft SQL",
        "group": "input",
        "keywords": [
            "microsoft",
            "sql",
            "input",
            "development",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/Sql/mssql.svg"
        },
        "operations": {
            "_": [
                "executeQuery",
                "insert",
                "update",
                "delete"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.azureStorage",
        "displayName": "Azure Storage",
        "description": "Interact with Azure Storage API",
        "group": "transform",
        "keywords": [
            "azure",
            "storage",
            "transform",
            "data"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/Storage/azureStorage.svg",
            "darkValue": "nodes/Microsoft/Storage/azureStorage.dark.svg"
        },
        "operations": {
            "blob": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "container": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.microsoftTeams",
        "displayName": "Microsoft Teams",
        "description": "Consume Microsoft Teams API",
        "group": "input",
        "keywords": [
            "microsoft",
            "teams",
            "input",
            "communication",
            "hitl",
            "human",
            "form",
            "wait",
            "approval",
            "the",
            "loop"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/Teams/teams.svg"
        },
        "operations": {
            "channel": [
                "create",
                "deleteChannel",
                "get",
                "getAll",
                "update"
            ],
            "channelMessage": [
                "create",
                "getAll"
            ],
            "chatMessage": [
                "create",
                "get",
                "getAll",
                "sendAndWait"
            ],
            "task": [
                "create",
                "deleteTask",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.microsoftTeamsTrigger",
        "displayName": "Microsoft Teams Trigger",
        "description": "Triggers workflows in n8n based on events from Microsoft Teams, such as new messages or team updates, using specified configurations.",
        "group": "trigger",
        "keywords": [
            "microsoft",
            "teams",
            "trigger",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/Teams/teams.svg"
        }
    },
    {
        "name": "n8n-nodes-base.microsoftToDo",
        "displayName": "Microsoft To Do",
        "description": "Consume Microsoft To Do API.",
        "group": "input",
        "keywords": [
            "microsoft",
            "input",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/ToDo/todo.svg"
        },
        "operations": {
            "linkedResource": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "list": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.mindee",
        "displayName": "Mindee",
        "description": "Consume Mindee API",
        "group": "input",
        "keywords": [
            "mindee",
            "input",
            "utility"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Mindee/mindee.svg"
        },
        "operations": {
            "invoice": [
                "predict",
                "__CUSTOM_API_CALL__"
            ],
            "receipt": [
                "predict",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": [
                "predict",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.misp",
        "displayName": "MISP",
        "description": "Consume the MISP API",
        "group": "transform",
        "keywords": [
            "misp",
            "transform",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Misp/misp.svg"
        },
        "operations": {
            "attribute": [
                "create",
                "delete",
                "get",
                "getAll",
                "search",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "event": [
                "create",
                "delete",
                "get",
                "getAll",
                "publish",
                "search",
                "unpublish",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "eventTag": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "feed": [
                "create",
                "disable",
                "enable",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "galaxy": [
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "noticelist": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "object": [
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "organisation": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "tag": [
                "create",
                "delete",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "warninglist": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.mistralAi",
        "displayName": "Mistral AI",
        "description": "Consume Mistral AI API",
        "group": "transform",
        "keywords": [
            "mistral",
            "transform",
            "utility"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/MistralAI/mistralAi.svg",
            "darkValue": "nodes/MistralAI/mistralAi.svg"
        },
        "operations": {
            "document": [
                "extractText",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.mocean",
        "displayName": "Mocean",
        "description": "Send SMS and voice messages via Mocean",
        "group": "transform",
        "keywords": [
            "mocean",
            "transform",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Mocean/mocean.svg",
            "darkValue": "nodes/Mocean/mocean.dark.svg"
        },
        "operations": {
            "sms": [
                "send"
            ],
            "voice": [
                "send"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.mondayCom",
        "displayName": "Monday.com",
        "description": "Consume Monday.com API",
        "group": "output",
        "keywords": [
            "monday.com",
            "output",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/MondayCom/mondayCom.svg"
        },
        "operations": {
            "board": [
                "archive",
                "create",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "boardColumn": [
                "create",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "boardGroup": [
                "delete",
                "create",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "boardItem": [
                "addUpdate",
                "changeColumnValue",
                "changeMultipleColumnValues",
                "create",
                "delete",
                "get",
                "getByColumnValue",
                "getAll",
                "move",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.mongoDb",
        "displayName": "MongoDB",
        "description": "Find, insert and update documents in MongoDB",
        "group": "input",
        "keywords": [
            "mongodb",
            "input",
            "development",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/MongoDb/mongodb.svg"
        },
        "operations": {
            "document": [
                "aggregate",
                "delete",
                "find",
                "findOneAndReplace",
                "findOneAndUpdate",
                "insert",
                "update"
            ],
            "searchIndexes": [
                "createSearchIndex",
                "dropSearchIndex",
                "listSearchIndexes",
                "updateSearchIndex"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.monicaCrm",
        "displayName": "Monica CRM",
        "description": "Consume the Monica CRM API",
        "group": "transform",
        "keywords": [
            "monica",
            "crm",
            "transform",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/MonicaCrm/monicaCrm.png"
        },
        "operations": {
            "activity": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "call": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "contact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "contactField": [
                "create",
                "delete",
                "get",
                "update"
            ],
            "contactTag": [
                "add",
                "remove"
            ],
            "conversation": [
                "create",
                "delete",
                "get",
                "update"
            ],
            "conversationMessage": [
                "add",
                "update"
            ],
            "journalEntry": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "note": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "reminder": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "tag": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.moveBinaryData",
        "displayName": "Convert to/from binary data",
        "description": "Move data between binary and JSON properties",
        "group": "transform",
        "keywords": [
            "convert",
            "to/from",
            "binary",
            "data",
            "transform",
            "core",
            "nodes",
            "move",
            "files"
        ],
        "icon": {
            "type": "fa",
            "value": "exchange-alt"
        }
    },
    {
        "name": "n8n-nodes-base.mqtt",
        "displayName": "MQTT",
        "description": "Push messages to MQTT",
        "group": "input",
        "keywords": [
            "mqtt",
            "input",
            "development",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/MQTT/mqtt.svg"
        }
    },
    {
        "name": "n8n-nodes-base.mqttTrigger",
        "displayName": "MQTT Trigger",
        "description": "Listens to MQTT events",
        "group": "trigger",
        "keywords": [
            "mqtt",
            "trigger",
            "communication",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/MQTT/mqtt.svg"
        }
    },
    {
        "name": "n8n-nodes-base.msg91",
        "displayName": "MSG91",
        "description": "Sends transactional SMS via MSG91",
        "group": "transform",
        "keywords": [
            "msg91",
            "transform",
            "communication",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Msg91/msg91.svg",
            "darkValue": "nodes/Msg91/msg91.dark.svg"
        },
        "operations": {
            "sms": [
                "send"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.mySql",
        "displayName": "MySQL",
        "description": "Get, add and update data in MySQL",
        "group": "input",
        "keywords": [
            "mysql",
            "input",
            "development",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/MySql/mysql.svg",
            "darkValue": "nodes/MySql/mysql.dark.svg"
        },
        "operations": {
            "_": [
                "deleteTable",
                "executeQuery",
                "insert",
                "upsert",
                "select",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.n8n",
        "displayName": "n8n",
        "description": "Handle events and perform actions on your n8n instance",
        "group": "transform",
        "keywords": [
            "n8n",
            "transform",
            "development",
            "core",
            "nodes",
            "workflow",
            "execution",
            "helpers",
            "other",
            "trigger"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/N8n/n8n.svg"
        },
        "operations": {
            "audit": [
                "generate",
                "__CUSTOM_API_CALL__"
            ],
            "credential": [
                "create",
                "delete",
                "getSchema",
                "__CUSTOM_API_CALL__"
            ],
            "execution": [
                "get",
                "getAll",
                "delete",
                "__CUSTOM_API_CALL__"
            ],
            "workflow": [
                "activate",
                "create",
                "deactivate",
                "delete",
                "get",
                "getAll",
                "getVersion",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.n8nTrainingCustomerDatastore",
        "displayName": "Customer Datastore (n8n training)",
        "description": "Dummy node used for n8n training",
        "group": "transform",
        "keywords": [
            "customer",
            "datastore",
            "n8n",
            "training",
            "transform"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/N8nTrainingCustomerDatastore/n8nTrainingCustomerDatastore.svg",
            "darkValue": "nodes/N8nTrainingCustomerDatastore/n8nTrainingCustomerDatastore.dark.svg"
        },
        "operations": {
            "_": [
                "getOnePerson",
                "getAllPeople"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.n8nTrainingCustomerMessenger",
        "displayName": "Customer Messenger (n8n training)",
        "description": "Dummy node used for n8n training",
        "group": "transform",
        "keywords": [
            "customer",
            "messenger",
            "n8n",
            "training",
            "transform"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/N8nTrainingCustomerMessenger/n8nTrainingCustomerMessenger.svg",
            "darkValue": "nodes/N8nTrainingCustomerMessenger/n8nTrainingCustomerMessenger.dark.svg"
        }
    },
    {
        "name": "n8n-nodes-base.n8nTrigger",
        "displayName": "n8n Trigger",
        "description": "Handle events and perform actions on your n8n instance",
        "group": "trigger",
        "keywords": [
            "n8n",
            "trigger",
            "core",
            "nodes",
            "flow",
            "other",
            "helpers"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/N8nTrigger/n8nTrigger.svg"
        }
    },
    {
        "name": "n8n-nodes-base.nasa",
        "displayName": "NASA",
        "description": "Retrieve data from the NASA API",
        "group": "transform",
        "keywords": [
            "nasa",
            "transform",
            "miscellaneous"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Nasa/nasa.png"
        },
        "operations": {
            "astronomyPictureOfTheDay": [
                "get"
            ],
            "asteroidNeoFeed": [
                "get"
            ],
            "asteroidNeoLookup": [
                "get"
            ],
            "asteroidNeoBrowse": [
                "getAll"
            ],
            "donkiCoronalMassEjection": [
                "get"
            ],
            "donkiGeomagneticStorm": [
                "get"
            ],
            "donkiInterplanetaryShock": [
                "get"
            ],
            "donkiSolarFlare": [
                "get"
            ],
            "donkiSolarEnergeticParticle": [
                "get"
            ],
            "donkiMagnetopauseCrossing": [
                "get"
            ],
            "donkiRadiationBeltEnhancement": [
                "get"
            ],
            "donkiHighSpeedStream": [
                "get"
            ],
            "donkiWsaEnlilSimulation": [
                "get"
            ],
            "donkiNotifications": [
                "get"
            ],
            "earthImagery": [
                "get"
            ],
            "earthAssets": [
                "get"
            ],
            "inSightMarsWeatherService": [
                "get"
            ],
            "imageAndVideoLibrary": [
                "get"
            ],
            "techTransfer": [
                "get"
            ],
            "twoLineElementSet": [
                "get"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.netlify",
        "displayName": "Netlify",
        "description": "Consume Netlify API",
        "group": "transform",
        "keywords": [
            "netlify",
            "transform",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Netlify/netlify.svg"
        },
        "operations": {
            "deploy": [
                "cancel",
                "create",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "site": [
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.netlifyTrigger",
        "displayName": "Netlify Trigger",
        "description": "Handle netlify events via webhooks",
        "group": "trigger",
        "keywords": [
            "netlify",
            "trigger",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Netlify/netlify.svg"
        }
    },
    {
        "name": "n8n-nodes-base.nextCloud",
        "displayName": "Nextcloud",
        "description": "Access data on Nextcloud",
        "group": "input",
        "keywords": [
            "nextcloud",
            "input",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/NextCloud/nextcloud.svg"
        },
        "operations": {
            "file": [
                "copy",
                "delete",
                "download",
                "move",
                "share",
                "upload",
                "__CUSTOM_API_CALL__"
            ],
            "folder": [
                "copy",
                "create",
                "delete",
                "list",
                "move",
                "share",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.nocoDb",
        "displayName": "NocoDB",
        "description": "Read, update, write and delete data from NocoDB",
        "group": "input",
        "keywords": [
            "nocodb",
            "input",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/NocoDB/nocodb.svg"
        },
        "operations": {
            "row": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.sendInBlue",
        "displayName": "Brevo",
        "description": "Consume Brevo API",
        "group": "transform",
        "keywords": [
            "brevo",
            "transform",
            "marketing",
            "communication",
            "sendinblue"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Brevo/brevo.svg"
        },
        "operations": {
            "attribute": [
                "create",
                "update",
                "delete",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "sender": [
                "create",
                "delete",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "contact": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "email": [
                "send",
                "sendTemplate",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.sendInBlueTrigger",
        "displayName": "Brevo Trigger",
        "description": "Starts the workflow when Brevo events occur",
        "group": "trigger",
        "keywords": [
            "brevo",
            "trigger",
            "marketing",
            "communication",
            "sendinblue"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Brevo/brevo.svg"
        }
    },
    {
        "name": "n8n-nodes-base.stickyNote",
        "displayName": "Sticky Note",
        "description": "Make your workflow easier to understand",
        "group": "input",
        "keywords": [
            "sticky",
            "note",
            "input"
        ],
        "icon": {
            "type": "fa",
            "value": "sticky-note"
        }
    },
    {
        "name": "n8n-nodes-base.noOp",
        "displayName": "No Operation, do nothing",
        "description": "No Operation",
        "group": "organization",
        "keywords": [
            "operation",
            "nothing",
            "organization",
            "core",
            "nodes",
            "helpers"
        ],
        "icon": {
            "type": "fa",
            "value": "arrow-right",
            "color": "gray"
        }
    },
    {
        "name": "n8n-nodes-base.onfleet",
        "displayName": "Onfleet",
        "description": "Consume Onfleet API",
        "group": "input",
        "keywords": [
            "onfleet",
            "input",
            "miscellaneous"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Onfleet/Onfleet.svg"
        },
        "operations": {
            "admin": [
                "create",
                "delete",
                "getAll",
                "update"
            ],
            "container": [
                "addTask",
                "get",
                "updateTask"
            ],
            "destination": [
                "create",
                "get"
            ],
            "hub": [
                "create",
                "getAll",
                "update"
            ],
            "organization": [
                "get",
                "getDelegatee"
            ],
            "recipient": [
                "create",
                "get",
                "update"
            ],
            "task": [
                "clone",
                "complete",
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "team": [
                "autoDispatch",
                "create",
                "delete",
                "get",
                "getAll",
                "getTimeEstimates",
                "update"
            ],
            "worker": [
                "create",
                "delete",
                "get",
                "getAll",
                "getSchedule",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.onfleetTrigger",
        "displayName": "Onfleet Trigger",
        "description": "Starts the workflow when Onfleet events occur",
        "group": "trigger",
        "keywords": [
            "onfleet",
            "trigger",
            "miscellaneous"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Onfleet/Onfleet.svg"
        }
    },
    {
        "name": "n8n-nodes-base.citrixAdc",
        "displayName": "Netscaler ADC",
        "description": "Consume Netscaler ADC API",
        "group": "output",
        "keywords": [
            "netscaler",
            "adc",
            "output",
            "development",
            "citrix"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Netscaler/ADC/netscaler.svg",
            "darkValue": "nodes/Netscaler/ADC/netscaler.dark.svg"
        },
        "operations": {
            "certificate": [
                "create",
                "install",
                "__CUSTOM_API_CALL__"
            ],
            "file": [
                "delete",
                "download",
                "upload",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.notion",
        "displayName": "Notion",
        "description": "Consume Notion API",
        "group": "output",
        "keywords": [
            "notion",
            "output",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Notion/notion.svg",
            "darkValue": "nodes/Notion/notion.dark.svg"
        },
        "operations": {
            "block": [
                "append",
                "getAll"
            ],
            "database": [
                "get",
                "getAll",
                "search"
            ],
            "databasePage": [
                "create",
                "get",
                "getAll",
                "update"
            ],
            "page": [
                "archive",
                "create",
                "search"
            ],
            "user": [
                "get",
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.notionTrigger",
        "displayName": "Notion Trigger",
        "description": "Starts the workflow when Notion events occur",
        "group": "trigger",
        "keywords": [
            "notion",
            "trigger",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Notion/notion.svg",
            "darkValue": "nodes/Notion/notion.dark.svg"
        }
    },
    {
        "name": "n8n-nodes-base.npm",
        "displayName": "Npm",
        "description": "Consume NPM registry API",
        "group": "input",
        "keywords": [
            "npm",
            "input",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Npm/npm.svg"
        },
        "operations": {
            "package": [
                "getMetadata",
                "getVersions",
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "distTag": [
                "getMany",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.odoo",
        "displayName": "Odoo",
        "description": "Consume Odoo API",
        "group": "transform",
        "keywords": [
            "odoo",
            "transform",
            "data",
            "storage",
            "erp"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Odoo/odoo.svg"
        },
        "operations": {
            "custom": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "opportunity": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "contact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "note": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.okta",
        "displayName": "Okta",
        "description": "Use the Okta API",
        "group": "transform",
        "keywords": [
            "okta",
            "transform",
            "development",
            "authentication",
            "users",
            "security"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Okta/Okta.svg",
            "darkValue": "nodes/Okta/Okta.dark.svg"
        },
        "operations": {
            "user": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.oneSimpleApi",
        "displayName": "One Simple API",
        "description": "A toolbox of no-code utilities",
        "group": "transform",
        "keywords": [
            "one",
            "simple",
            "api",
            "transform",
            "utility"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/OneSimpleApi/onesimpleapi.svg"
        },
        "operations": {
            "website": [
                "pdf",
                "seo",
                "screenshot"
            ],
            "socialProfile": [
                "instagramProfile",
                "spotifyArtistProfile"
            ],
            "information": [
                "exchangeRate",
                "imageMetadata"
            ],
            "utility": [
                "expandURL",
                "qrCode",
                "validateEmail"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.openAi",
        "displayName": "OpenAI",
        "description": "Consume Open AI",
        "group": "transform",
        "keywords": [
            "openai",
            "transform",
            "utility",
            "chatgpt",
            "dalle"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/OpenAi/openAi.svg",
            "darkValue": "nodes/OpenAi/openAi.dark.svg"
        },
        "operations": {
            "chat": [
                "complete",
                "__CUSTOM_API_CALL__"
            ],
            "image": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "text": [
                "complete",
                "edit",
                "moderate",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.openThesaurus",
        "displayName": "OpenThesaurus",
        "description": "Get synonmns for German words using the OpenThesaurus API",
        "group": "output",
        "keywords": [
            "openthesaurus",
            "output",
            "utility"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/OpenThesaurus/openthesaurus.png"
        },
        "operations": {
            "_": [
                "getSynonyms"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.openWeatherMap",
        "displayName": "OpenWeatherMap",
        "description": "Gets current and future weather information",
        "group": "input",
        "keywords": [
            "openweathermap",
            "input",
            "miscellaneous",
            "utility"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/OpenWeatherMap/openWeatherMap.svg"
        },
        "operations": {
            "_": [
                "currentWeather",
                "5DayForecast",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.oracleDatabase",
        "displayName": "Oracle Database",
        "description": "Get, add and update data in Oracle database",
        "group": "input",
        "keywords": [
            "oracle",
            "database",
            "input"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Oracle/Sql/oracle.svg"
        },
        "operations": {
            "_": [
                "deleteTable",
                "execute",
                "insert",
                "upsert",
                "select",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.orbit",
        "displayName": "Orbit",
        "description": "Consume Orbit API",
        "group": "output",
        "keywords": [
            "orbit",
            "output",
            "analytics"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Orbit/orbit.svg",
            "darkValue": "nodes/Orbit/orbit.dark.svg"
        },
        "operations": {
            "activity": [
                "create",
                "getAll"
            ],
            "member": [
                "upsert",
                "delete",
                "get",
                "getAll",
                "lookup",
                "update"
            ],
            "note": [
                "create",
                "getAll",
                "update"
            ],
            "post": [
                "create",
                "getAll",
                "delete"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.oura",
        "displayName": "Oura",
        "description": "Consume Oura API",
        "group": "output",
        "keywords": [
            "oura",
            "output",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Oura/oura.svg",
            "darkValue": "nodes/Oura/oura.dark.svg"
        },
        "operations": {
            "profile": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "summary": [
                "getActivity",
                "getReadiness",
                "getSleep",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.paddle",
        "displayName": "Paddle",
        "description": "Consume Paddle API",
        "group": "output",
        "keywords": [
            "paddle",
            "output",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Paddle/paddle.png"
        },
        "operations": {
            "coupon": [
                "create",
                "getAll",
                "update"
            ],
            "payment": [
                "getAll",
                "reschedule"
            ],
            "plan": [
                "get",
                "getAll"
            ],
            "product": [
                "getAll"
            ],
            "user": [
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.pagerDuty",
        "displayName": "PagerDuty",
        "description": "Consume PagerDuty API",
        "group": "output",
        "keywords": [
            "pagerduty",
            "output",
            "communication",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/PagerDuty/pagerDuty.svg"
        },
        "operations": {
            "incident": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "incidentNote": [
                "create",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "logEntry": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.payPal",
        "displayName": "PayPal",
        "description": "Consume PayPal API",
        "group": "output",
        "keywords": [
            "paypal",
            "output",
            "finance",
            "accounting",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/PayPal/paypal.svg"
        },
        "operations": {
            "payout": [
                "create",
                "get"
            ],
            "payoutItem": [
                "cancel",
                "get"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.payPalTrigger",
        "displayName": "PayPal Trigger",
        "description": "Handle PayPal events via webhooks",
        "group": "trigger",
        "keywords": [
            "paypal",
            "trigger",
            "finance",
            "accounting",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/PayPal/paypal.svg"
        }
    },
    {
        "name": "n8n-nodes-base.peekalink",
        "displayName": "Peekalink",
        "description": "Consume the Peekalink API",
        "group": "output",
        "keywords": [
            "peekalink",
            "output",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Peekalink/peekalink.png"
        },
        "operations": {
            "_": [
                "isAvailable",
                "preview"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.perplexity",
        "displayName": "Perplexity",
        "description": "AI-powered answer engine that provides accurate, trusted, and real-time answers to any question. Generates AI responses with citations",
        "group": "transform",
        "keywords": [
            "perplexity",
            "transform",
            "utility"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Perplexity/perplexity.svg",
            "darkValue": "nodes/Perplexity/perplexity.dark.svg"
        },
        "operations": {
            "_": [
                "complete",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.phantombuster",
        "displayName": "Phantombuster",
        "description": "Consume Phantombuster API",
        "group": "input",
        "keywords": [
            "phantombuster",
            "input",
            "sales",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Phantombuster/phantombuster.png"
        },
        "operations": {
            "agent": [
                "delete",
                "get",
                "getAll",
                "getOutput",
                "launch",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.philipsHue",
        "displayName": "Philips Hue",
        "description": "Consume Philips Hue API",
        "group": "input",
        "keywords": [
            "philips",
            "hue",
            "input",
            "miscellaneous"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/PhilipsHue/philipshue.png"
        },
        "operations": {
            "light": [
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.pipedrive",
        "displayName": "Pipedrive",
        "description": "Create and edit data in Pipedrive",
        "group": "transform",
        "keywords": [
            "pipedrive",
            "transform",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Pipedrive/pipedrive.svg"
        },
        "operations": {
            "activity": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "deal": [
                "create",
                "delete",
                "duplicate",
                "get",
                "getAll",
                "search",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "dealActivity": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "dealProduct": [
                "add",
                "getAll",
                "remove",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "file": [
                "create",
                "delete",
                "download",
                "get",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "lead": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "note": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "organization": [
                "create",
                "delete",
                "get",
                "getAll",
                "search",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "person": [
                "create",
                "delete",
                "get",
                "getAll",
                "search",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "product": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.pipedriveTrigger",
        "displayName": "Pipedrive Trigger",
        "description": "Starts the workflow when Pipedrive events occur",
        "group": "trigger",
        "keywords": [
            "pipedrive",
            "trigger",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Pipedrive/pipedrive.svg"
        }
    },
    {
        "name": "n8n-nodes-base.plivo",
        "displayName": "Plivo",
        "description": "Send SMS/MMS messages or make phone calls",
        "group": "transform",
        "keywords": [
            "plivo",
            "transform",
            "communication",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Plivo/plivo.svg"
        },
        "operations": {
            "sms": [
                "send"
            ],
            "mms": [
                "send"
            ],
            "call": [
                "make"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.postBin",
        "displayName": "PostBin",
        "description": "Consume PostBin API",
        "group": "transform",
        "keywords": [
            "postbin",
            "transform",
            "development",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/PostBin/postbin.svg"
        },
        "operations": {
            "bin": [
                "create",
                "get",
                "delete"
            ],
            "request": [
                "get",
                "removeFirst",
                "send"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.postgres",
        "displayName": "Postgres",
        "description": "Get, add and update data in Postgres",
        "group": "input",
        "keywords": [
            "postgres",
            "input",
            "development",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Postgres/postgres.svg"
        },
        "operations": {
            "_": [
                "deleteTable",
                "executeQuery",
                "insert",
                "upsert",
                "select",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.postgresTrigger",
        "displayName": "Postgres Trigger",
        "description": "Listens to Postgres messages",
        "group": "trigger",
        "keywords": [
            "postgres",
            "trigger",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Postgres/postgres.svg"
        }
    },
    {
        "name": "n8n-nodes-base.postHog",
        "displayName": "PostHog",
        "description": "Consume PostHog API",
        "group": "input",
        "keywords": [
            "posthog",
            "input",
            "analytics",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/PostHog/postHog.svg"
        },
        "operations": {
            "alias": [
                "create"
            ],
            "event": [
                "create"
            ],
            "identity": [
                "create"
            ],
            "track": [
                "page",
                "screen"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.postmarkTrigger",
        "displayName": "Postmark Trigger",
        "description": "Starts the workflow when Postmark events occur",
        "group": "trigger",
        "keywords": [
            "postmark",
            "trigger",
            "communication",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Postmark/postmark.png"
        }
    },
    {
        "name": "n8n-nodes-base.profitWell",
        "displayName": "ProfitWell",
        "description": "Consume ProfitWell API",
        "group": "output",
        "keywords": [
            "profitwell",
            "output",
            "analytics"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/ProfitWell/profitwell.svg",
            "darkValue": "nodes/ProfitWell/profitwell.dark.svg"
        },
        "operations": {
            "company": [
                "getSetting"
            ],
            "metric": [
                "get"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.pushbullet",
        "displayName": "Pushbullet",
        "description": "Consume Pushbullet API",
        "group": "input",
        "keywords": [
            "pushbullet",
            "input",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Pushbullet/pushbullet.svg"
        },
        "operations": {
            "push": [
                "create",
                "delete",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.pushcut",
        "displayName": "Pushcut",
        "description": "Consume Pushcut API",
        "group": "input",
        "keywords": [
            "pushcut",
            "input",
            "communication",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Pushcut/pushcut.png"
        },
        "operations": {
            "notification": [
                "send"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.pushcutTrigger",
        "displayName": "Pushcut Trigger",
        "description": "Starts the workflow when Pushcut events occur",
        "group": "trigger",
        "keywords": [
            "pushcut",
            "trigger",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Pushcut/pushcut.png"
        }
    },
    {
        "name": "n8n-nodes-base.pushover",
        "displayName": "Pushover",
        "description": "Consume Pushover API",
        "group": "input",
        "keywords": [
            "pushover",
            "input",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Pushover/pushover.svg"
        },
        "operations": {
            "message": [
                "push",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.questDb",
        "displayName": "QuestDB",
        "description": "Get, add and update data in QuestDB",
        "group": "input",
        "keywords": [
            "questdb",
            "input",
            "data",
            "storage",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/QuestDb/questdb.png"
        },
        "operations": {
            "_": [
                "executeQuery",
                "insert"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.quickbase",
        "displayName": "Quick Base",
        "description": "Integrate with the Quick Base RESTful API",
        "group": "input",
        "keywords": [
            "quick",
            "base",
            "input",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/QuickBase/quickbase.png"
        },
        "operations": {
            "field": [
                "getAll"
            ],
            "file": [
                "delete",
                "download"
            ],
            "record": [
                "create",
                "upsert",
                "delete",
                "getAll",
                "update"
            ],
            "report": [
                "get",
                "run"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.quickbooks",
        "displayName": "QuickBooks Online",
        "description": "Consume the QuickBooks Online API",
        "group": "transform",
        "keywords": [
            "quickbooks",
            "online",
            "transform",
            "finance",
            "accounting"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/QuickBooks/quickbooks.svg"
        },
        "operations": {
            "bill": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "customer": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "employee": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "estimate": [
                "create",
                "delete",
                "get",
                "getAll",
                "send",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "invoice": [
                "create",
                "delete",
                "get",
                "getAll",
                "send",
                "update",
                "void",
                "__CUSTOM_API_CALL__"
            ],
            "item": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "payment": [
                "create",
                "delete",
                "get",
                "getAll",
                "send",
                "update",
                "void",
                "__CUSTOM_API_CALL__"
            ],
            "purchase": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "transaction": [
                "getReport",
                "__CUSTOM_API_CALL__"
            ],
            "vendor": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.quickChart",
        "displayName": "QuickChart",
        "description": "Create a chart via QuickChart",
        "group": "output",
        "keywords": [
            "quickchart",
            "output",
            "marketing",
            "image",
            "graph",
            "report",
            "chart",
            "diagram",
            "data",
            "visualize"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/QuickChart/quickChart.svg"
        }
    },
    {
        "name": "n8n-nodes-base.rabbitmq",
        "displayName": "RabbitMQ",
        "description": "Sends messages to a RabbitMQ topic",
        "group": "transform",
        "keywords": [
            "rabbitmq",
            "transform",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/RabbitMQ/rabbitmq.svg"
        },
        "operations": {
            "_": [
                "sendMessage",
                "deleteMessage"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.rabbitmqTrigger",
        "displayName": "RabbitMQ Trigger",
        "description": "Listens to RabbitMQ messages",
        "group": "trigger",
        "keywords": [
            "rabbitmq",
            "trigger",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/RabbitMQ/rabbitmq.svg"
        }
    },
    {
        "name": "n8n-nodes-base.raindrop",
        "displayName": "Raindrop",
        "description": "Consume the Raindrop API",
        "group": "transform",
        "keywords": [
            "raindrop",
            "transform",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Raindrop/raindrop.svg"
        },
        "operations": {
            "bookmark": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "collection": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "tag": [
                "delete",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.readBinaryFile",
        "displayName": "Read Binary File",
        "description": "Reads a binary file from disk",
        "group": "input",
        "keywords": [
            "read",
            "binary",
            "file",
            "input",
            "core",
            "nodes",
            "text",
            "open",
            "import",
            "files"
        ],
        "icon": {
            "type": "fa",
            "value": "file-import"
        }
    },
    {
        "name": "n8n-nodes-base.readBinaryFiles",
        "displayName": "Read Binary Files",
        "description": "Reads binary files from disk",
        "group": "input",
        "keywords": [
            "read",
            "binary",
            "files",
            "input",
            "core",
            "nodes",
            "text",
            "open",
            "import"
        ],
        "icon": {
            "type": "fa",
            "value": "file-import"
        }
    },
    {
        "name": "n8n-nodes-base.readPDF",
        "displayName": "Read PDF",
        "description": "Reads a PDF and extracts its content",
        "group": "input",
        "keywords": [
            "read",
            "pdf",
            "input",
            "core",
            "nodes",
            "files"
        ],
        "icon": {
            "type": "fa",
            "value": "file-pdf"
        }
    },
    {
        "name": "n8n-nodes-base.reddit",
        "displayName": "Reddit",
        "description": "Consume the Reddit API",
        "group": "transform",
        "keywords": [
            "reddit",
            "transform",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Reddit/reddit.svg"
        },
        "operations": {
            "postComment": [
                "create",
                "getAll",
                "delete",
                "reply",
                "__CUSTOM_API_CALL__"
            ],
            "profile": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "subreddit": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "post": [
                "create",
                "delete",
                "get",
                "getAll",
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.redis",
        "displayName": "Redis",
        "description": "Get, send and update data in Redis",
        "group": "input",
        "keywords": [
            "redis",
            "input",
            "development",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Redis/redis.svg"
        },
        "operations": {
            "_": [
                "delete",
                "get",
                "incr",
                "info",
                "keys",
                "llen",
                "pop",
                "publish",
                "push",
                "set"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.redisTrigger",
        "displayName": "Redis Trigger",
        "description": "Subscribe to redis channel",
        "group": "trigger",
        "keywords": [
            "redis",
            "trigger",
            "communication",
            "development",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Redis/redis.svg"
        }
    },
    {
        "name": "n8n-nodes-base.renameKeys",
        "displayName": "Rename Keys",
        "description": "Update item field names",
        "group": "transform",
        "keywords": [
            "rename",
            "keys",
            "transform",
            "core",
            "nodes",
            "data",
            "transformation"
        ],
        "icon": {
            "type": "fa",
            "value": "edit",
            "color": "crimson"
        }
    },
    {
        "name": "n8n-nodes-base.respondToWebhook",
        "displayName": "Respond to Webhook",
        "description": "Returns data for Webhook",
        "group": "transform",
        "keywords": [
            "respond",
            "webhook",
            "transform",
            "core",
            "nodes",
            "utility",
            "helpers"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/RespondToWebhook/webhook.svg",
            "darkValue": "nodes/RespondToWebhook/webhook.dark.svg"
        }
    },
    {
        "name": "n8n-nodes-base.rocketchat",
        "displayName": "RocketChat",
        "description": "Consume RocketChat API",
        "group": "output",
        "keywords": [
            "rocketchat",
            "output",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Rocketchat/rocketchat.svg"
        },
        "operations": {
            "chat": [
                "postMessage",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.rssFeedRead",
        "displayName": "RSS Read",
        "description": "Reads data from an RSS Feed",
        "group": "input",
        "keywords": [
            "rss",
            "read",
            "input",
            "core",
            "nodes"
        ],
        "icon": {
            "type": "fa",
            "value": "rss",
            "color": "orange-red"
        }
    },
    {
        "name": "n8n-nodes-base.rssFeedReadTrigger",
        "displayName": "RSS Feed Trigger",
        "description": "Starts a workflow when an RSS feed is updated",
        "group": "trigger",
        "keywords": [
            "rss",
            "feed",
            "trigger",
            "core",
            "nodes"
        ],
        "icon": {
            "type": "fa",
            "value": "rss",
            "color": "orange-red"
        }
    },
    {
        "name": "n8n-nodes-base.rundeck",
        "displayName": "Rundeck",
        "description": "Manage Rundeck API",
        "group": "transform",
        "keywords": [
            "rundeck",
            "transform",
            "communication",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Rundeck/rundeck.png"
        },
        "operations": {
            "job": [
                "execute",
                "getMetadata",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": [
                "execute",
                "getMetadata",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.s3",
        "displayName": "S3",
        "description": "Sends data to any S3-compatible service",
        "group": "output",
        "keywords": [
            "output",
            "development",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/S3/s3.png"
        },
        "operations": {
            "bucket": [
                "create",
                "delete",
                "getAll",
                "search"
            ],
            "folder": [
                "create",
                "delete",
                "getAll"
            ],
            "file": [
                "copy",
                "delete",
                "download",
                "getAll",
                "upload"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.salesforce",
        "displayName": "Salesforce",
        "description": "Consume Salesforce API",
        "group": "output",
        "keywords": [
            "salesforce",
            "output",
            "sales",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Salesforce/salesforce.svg"
        },
        "operations": {
            "lead": [
                "addToCampaign",
                "addNote",
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "getSummary",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "contact": [
                "addToCampaign",
                "addNote",
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "getSummary",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "customObject": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "document": [
                "upload",
                "__CUSTOM_API_CALL__"
            ],
            "opportunity": [
                "addNote",
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "getSummary",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "account": [
                "addNote",
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "getSummary",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "search": [
                "query",
                "__CUSTOM_API_CALL__"
            ],
            "case": [
                "addComment",
                "create",
                "delete",
                "get",
                "getAll",
                "getSummary",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "getSummary",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "attachment": [
                "create",
                "delete",
                "get",
                "getAll",
                "getSummary",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "flow": [
                "getAll",
                "invoke",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.salesforceTrigger",
        "displayName": "Salesforce Trigger",
        "description": "Fetches data from Salesforce and starts the workflow on specified polling intervals.",
        "group": "trigger",
        "keywords": [
            "salesforce",
            "trigger",
            "sales",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Salesforce/salesforce.svg"
        }
    },
    {
        "name": "n8n-nodes-base.salesmate",
        "displayName": "Salesmate",
        "description": "Consume Salesmate API",
        "group": "output",
        "keywords": [
            "salesmate",
            "output",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Salesmate/salesmate.png"
        },
        "operations": {
            "company": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "activity": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "deal": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.scheduleTrigger",
        "displayName": "Schedule Trigger",
        "description": "Triggers the workflow on a given schedule",
        "group": "trigger",
        "keywords": [
            "schedule",
            "trigger",
            "core",
            "nodes",
            "time",
            "scheduler",
            "polling",
            "cron",
            "interval"
        ],
        "icon": {
            "type": "fa",
            "value": "clock"
        }
    },
    {
        "name": "n8n-nodes-base.seaTable",
        "displayName": "SeaTable",
        "description": "Consume the SeaTable API",
        "group": "output",
        "keywords": [
            "seatable",
            "output",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/SeaTable/seaTable.svg"
        },
        "operations": {
            "row": [
                "create",
                "remove",
                "get",
                "list",
                "lock",
                "search",
                "unlock",
                "update"
            ],
            "base": [
                "snapshot",
                "metadata",
                "collaborator"
            ],
            "link": [
                "add",
                "list",
                "remove"
            ],
            "asset": [
                "getPublicURL",
                "upload"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.seaTableTrigger",
        "displayName": "SeaTable Trigger",
        "description": "Starts the workflow when SeaTable events occur",
        "group": "trigger",
        "keywords": [
            "seatable",
            "trigger",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/SeaTable/seaTable.svg"
        }
    },
    {
        "name": "n8n-nodes-base.securityScorecard",
        "displayName": "SecurityScorecard",
        "description": "Consume SecurityScorecard API",
        "group": "transform",
        "keywords": [
            "securityscorecard",
            "transform",
            "analytics"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/SecurityScorecard/securityScorecard.svg"
        },
        "operations": {
            "company": [
                "getFactor",
                "getFactorHistorical",
                "getHistoricalScore",
                "getScorecard",
                "getScorePlan"
            ],
            "industry": [
                "getFactor",
                "getFactorHistorical",
                "getScore"
            ],
            "invite": [
                "create"
            ],
            "portfolio": [
                "create",
                "delete",
                "getAll",
                "update"
            ],
            "portfolioCompany": [
                "add",
                "getAll",
                "remove"
            ],
            "report": [
                "download",
                "generate",
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.segment",
        "displayName": "Segment",
        "description": "Consume Segment API",
        "group": "output",
        "keywords": [
            "segment",
            "output",
            "analytics",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Segment/segment.svg"
        },
        "operations": {
            "group": [
                "add",
                "__CUSTOM_API_CALL__"
            ],
            "identify": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "track": [
                "event",
                "page",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.sendGrid",
        "displayName": "SendGrid",
        "description": "Consume SendGrid API",
        "group": "transform",
        "keywords": [
            "sendgrid",
            "transform",
            "marketing",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/SendGrid/sendGrid.svg"
        },
        "operations": {
            "list": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "contact": [
                "upsert",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "mail": [
                "send",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.sendy",
        "displayName": "Sendy",
        "description": "Consume Sendy API",
        "group": "input",
        "keywords": [
            "sendy",
            "input",
            "communication",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Sendy/sendy.png"
        },
        "operations": {
            "campaign": [
                "create"
            ],
            "subscriber": [
                "add",
                "count",
                "delete",
                "remove",
                "status"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.sentryIo",
        "displayName": "Sentry.io",
        "description": "Consume Sentry.io API",
        "group": "output",
        "keywords": [
            "sentry.io",
            "output",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/SentryIo/sentryio.svg",
            "darkValue": "nodes/SentryIo/sentryio.dark.svg"
        },
        "operations": {
            "event": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "issue": [
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "organization": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "project": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "release": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "team": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.serviceNow",
        "displayName": "ServiceNow",
        "description": "Consume ServiceNow API",
        "group": "output",
        "keywords": [
            "servicenow",
            "output",
            "productivity",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/ServiceNow/servicenow.svg"
        },
        "operations": {
            "attachment": [
                "upload",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "businessService": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "configurationItems": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "department": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "dictionary": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "incident": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "tableRecord": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "userGroup": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "userRole": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.set",
        "displayName": "Edit Fields (Set)",
        "description": "Modify, add, or remove item fields",
        "group": "input",
        "keywords": [
            "edit",
            "fields",
            "set",
            "input",
            "core",
            "nodes",
            "json",
            "filter",
            "transform",
            "map",
            "data",
            "transformation"
        ],
        "icon": {
            "type": "fa",
            "value": "pen",
            "color": "blue"
        }
    },
    {
        "name": "n8n-nodes-base.shopify",
        "displayName": "Shopify",
        "description": "Consume Shopify API",
        "group": "output",
        "keywords": [
            "shopify",
            "output",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Shopify/shopify.svg"
        },
        "operations": {
            "order": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "product": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.shopifyTrigger",
        "displayName": "Shopify Trigger",
        "description": "Handle Shopify events via webhooks",
        "group": "trigger",
        "keywords": [
            "shopify",
            "trigger",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Shopify/shopify.svg"
        }
    },
    {
        "name": "n8n-nodes-base.signl4",
        "displayName": "SIGNL4",
        "description": "Consume SIGNL4 API",
        "group": "transform",
        "keywords": [
            "signl4",
            "transform",
            "communication",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Signl4/signl4.png"
        },
        "operations": {
            "alert": [
                "send",
                "resolve"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.simulate",
        "displayName": "Simulate",
        "description": "Simulate a node",
        "group": "organization",
        "keywords": [
            "simulate",
            "organization",
            "core",
            "nodes",
            "placeholder",
            "stub",
            "dummy",
            "helpers"
        ],
        "icon": {
            "type": "fa",
            "value": "arrow-right"
        }
    },
    {
        "name": "n8n-nodes-base.simulateTrigger",
        "displayName": "Simulate Trigger",
        "description": "Simulate a trigger node",
        "group": "trigger",
        "keywords": [
            "simulate",
            "trigger",
            "core",
            "nodes",
            "placeholder",
            "stub",
            "dummy",
            "helpers"
        ],
        "icon": {
            "type": "fa",
            "value": "arrow-right"
        }
    },
    {
        "name": "n8n-nodes-base.slack",
        "displayName": "Slack",
        "description": "Consume Slack API",
        "group": "output",
        "keywords": [
            "slack",
            "output",
            "communication",
            "hitl",
            "human",
            "form",
            "wait",
            "approval",
            "the",
            "loop"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Slack/slack.svg"
        },
        "operations": {
            "channel": [
                "archive",
                "close",
                "create",
                "get",
                "getAll",
                "history",
                "invite",
                "join",
                "kick",
                "leave",
                "member",
                "open",
                "rename",
                "replies",
                "setPurpose",
                "setTopic",
                "unarchive"
            ],
            "message": [
                "delete",
                "getPermalink",
                "search",
                "post",
                "sendAndWait",
                "update"
            ],
            "star": [
                "add",
                "delete",
                "getAll"
            ],
            "file": [
                "get",
                "getAll",
                "upload"
            ],
            "reaction": [
                "add",
                "get",
                "remove"
            ],
            "user": [
                "info",
                "getAll",
                "getProfile",
                "getPresence",
                "updateProfile"
            ],
            "userGroup": [
                "updateUsers",
                "create",
                "disable",
                "enable",
                "getAll",
                "getUsers",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.slackTrigger",
        "displayName": "Slack Trigger",
        "description": "Handle Slack events via webhooks",
        "group": "trigger",
        "keywords": [
            "slack",
            "trigger",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Slack/slack.svg"
        }
    },
    {
        "name": "n8n-nodes-base.sms77",
        "displayName": "seven",
        "description": "Send SMS and make text-to-speech calls",
        "group": "transform",
        "keywords": [
            "seven",
            "transform",
            "communication",
            "sms",
            "sms77"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Sms77/seven.svg"
        },
        "operations": {
            "sms": [
                "send",
                "__CUSTOM_API_CALL__"
            ],
            "voice": [
                "send",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.snowflake",
        "displayName": "Snowflake",
        "description": "Get, add and update data in Snowflake",
        "group": "input",
        "keywords": [
            "snowflake",
            "input",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Snowflake/snowflake.svg"
        },
        "operations": {
            "_": [
                "executeQuery",
                "insert",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.splitInBatches",
        "displayName": "Loop Over Items (Split in Batches)",
        "description": "Split data into batches and iterate over each batch",
        "group": "organization",
        "keywords": [
            "loop",
            "over",
            "items",
            "split",
            "batches",
            "organization",
            "core",
            "nodes",
            "concatenate",
            "batch",
            "flow"
        ],
        "icon": {
            "type": "fa",
            "value": "sync",
            "color": "dark-green"
        }
    },
    {
        "name": "n8n-nodes-base.splunk",
        "displayName": "Splunk",
        "description": "Consume the Splunk Enterprise API",
        "group": "transform",
        "keywords": [
            "splunk",
            "transform",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Splunk/splunk.svg"
        },
        "operations": {
            "alert": [
                "getReport",
                "getMetrics",
                "__CUSTOM_API_CALL__"
            ],
            "report": [
                "create",
                "deleteReport",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "search": [
                "create",
                "deleteJob",
                "get",
                "getAll",
                "getResult",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "create",
                "deleteUser",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.spotify",
        "displayName": "Spotify",
        "description": "Access public song data via the Spotify API",
        "group": "input",
        "keywords": [
            "spotify",
            "input",
            "miscellaneous",
            "music",
            "song"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Spotify/spotify.svg"
        },
        "operations": {
            "player": [
                "addSongToQueue",
                "currentlyPlaying",
                "nextSong",
                "pause",
                "previousSong",
                "recentlyPlayed",
                "resume",
                "volume",
                "startMusic",
                "__CUSTOM_API_CALL__"
            ],
            "album": [
                "get",
                "getNewReleases",
                "getTracks",
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "artist": [
                "get",
                "getAlbums",
                "getRelatedArtists",
                "getTopTracks",
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "playlist": [
                "add",
                "create",
                "get",
                "getUserPlaylists",
                "getTracks",
                "delete",
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "track": [
                "get",
                "getAudioFeatures",
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "library": [
                "getLikedTracks",
                "__CUSTOM_API_CALL__"
            ],
            "myData": [
                "getFollowingArtists",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.spreadsheetFile",
        "displayName": "Spreadsheet File",
        "description": "Reads and writes data from a spreadsheet file like CSV, XLS, ODS, etc",
        "group": "transform",
        "keywords": [
            "spreadsheet",
            "file",
            "transform",
            "data",
            "storage",
            "core",
            "nodes",
            "excel",
            "csv",
            "sheet",
            "xls",
            "xlsx",
            "ods",
            "files"
        ],
        "icon": {
            "type": "fa",
            "value": "table"
        },
        "operations": {
            "_": [
                "fromFile",
                "toFile"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.sseTrigger",
        "displayName": "SSE Trigger",
        "description": "Triggers the workflow when Server-Sent Events occur",
        "group": "trigger",
        "keywords": [
            "sse",
            "trigger",
            "development",
            "core",
            "nodes",
            "other"
        ],
        "icon": {
            "type": "fa",
            "value": "cloud-download-alt",
            "color": "dark-blue"
        }
    },
    {
        "name": "n8n-nodes-base.ssh",
        "displayName": "SSH",
        "description": "Execute commands via SSH",
        "group": "input",
        "keywords": [
            "ssh",
            "input",
            "core",
            "nodes",
            "development",
            "remote",
            "helpers"
        ],
        "icon": {
            "type": "fa",
            "value": "terminal",
            "color": "black"
        },
        "operations": {
            "command": [
                "execute"
            ],
            "file": [
                "download",
                "upload"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.stackby",
        "displayName": "Stackby",
        "description": "Read, write, and delete data in Stackby",
        "group": "transform",
        "keywords": [
            "stackby",
            "transform",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Stackby/stackby.png"
        },
        "operations": {
            "_": [
                "append",
                "delete",
                "list",
                "read"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.stopAndError",
        "displayName": "Stop and Error",
        "description": "Throw an error in the workflow",
        "group": "input",
        "keywords": [
            "stop",
            "and",
            "error",
            "input",
            "core",
            "nodes",
            "utility",
            "throw",
            "exception",
            "flow"
        ],
        "icon": {
            "type": "fa",
            "value": "exclamation-triangle",
            "color": "red"
        }
    },
    {
        "name": "n8n-nodes-base.storyblok",
        "displayName": "Storyblok",
        "description": "Consume Storyblok API",
        "group": "output",
        "keywords": [
            "storyblok",
            "output",
            "data",
            "storage",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Storyblok/storyblok.svg"
        },
        "operations": {
            "story": [
                "delete",
                "get",
                "getAll",
                "publish",
                "unpublish"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.strapi",
        "displayName": "Strapi",
        "description": "Consume Strapi API",
        "group": "input",
        "keywords": [
            "strapi",
            "input",
            "data",
            "storage",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Strapi/strapi.svg"
        },
        "operations": {
            "entry": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.strava",
        "displayName": "Strava",
        "description": "Consume Strava API",
        "group": "input",
        "keywords": [
            "strava",
            "input",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Strava/strava.svg"
        },
        "operations": {
            "activity": [
                "create",
                "get",
                "getComments",
                "getKudos",
                "getLaps",
                "getAll",
                "getStreams",
                "getZones",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.stravaTrigger",
        "displayName": "Strava Trigger",
        "description": "Starts the workflow when Strava events occur",
        "group": "trigger",
        "keywords": [
            "strava",
            "trigger",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Strava/strava.svg"
        }
    },
    {
        "name": "n8n-nodes-base.stripe",
        "displayName": "Stripe",
        "description": "Consume the Stripe API",
        "group": "transform",
        "keywords": [
            "stripe",
            "transform",
            "finance",
            "accounting",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Stripe/stripe.svg"
        },
        "operations": {
            "balance": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "customerCard": [
                "add",
                "get",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "charge": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "coupon": [
                "create",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "customer": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "meterEvent": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "source": [
                "create",
                "delete",
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "token": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.stripeTrigger",
        "displayName": "Stripe Trigger",
        "description": "Handle Stripe events via webhooks",
        "group": "trigger",
        "keywords": [
            "stripe",
            "trigger",
            "finance",
            "accounting",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Stripe/stripe.svg"
        }
    },
    {
        "name": "n8n-nodes-base.supabase",
        "displayName": "Supabase",
        "description": "Add, get, delete and update data in a table",
        "group": "input",
        "keywords": [
            "supabase",
            "input",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Supabase/supabase.svg"
        },
        "operations": {
            "row": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.surveyMonkeyTrigger",
        "displayName": "SurveyMonkey Trigger",
        "description": "Starts the workflow when Survey Monkey events occur",
        "group": "trigger",
        "keywords": [
            "surveymonkey",
            "trigger",
            "marketing",
            "communication",
            "form"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/SurveyMonkey/surveyMonkey.svg"
        }
    },
    {
        "name": "n8n-nodes-base.switch",
        "displayName": "Switch",
        "description": "Route items depending on defined expression or rules",
        "group": "transform",
        "keywords": [
            "switch",
            "transform",
            "core",
            "nodes",
            "router",
            "path",
            "filter",
            "condition",
            "logic",
            "branch",
            "case",
            "flow"
        ],
        "icon": {
            "type": "fa",
            "value": "map-signs",
            "color": "light-blue"
        }
    },
    {
        "name": "n8n-nodes-base.syncroMsp",
        "displayName": "SyncroMSP",
        "description": "Gets data from SyncroMSP",
        "group": "output",
        "keywords": [
            "syncromsp",
            "output",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/SyncroMSP/syncromsp.png"
        },
        "operations": {
            "customer": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "ticket": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "contact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "rmm": [
                "create",
                "delete",
                "get",
                "getAll",
                "mute"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.taiga",
        "displayName": "Taiga",
        "description": "Consume Taiga API",
        "group": "transform",
        "keywords": [
            "taiga",
            "transform",
            "development",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Taiga/taiga.svg"
        },
        "operations": {
            "epic": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "issue": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "userStory": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.taigaTrigger",
        "displayName": "Taiga Trigger",
        "description": "Handle Taiga events via webhook",
        "group": "trigger",
        "keywords": [
            "taiga",
            "trigger",
            "development",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Taiga/taiga.svg"
        }
    },
    {
        "name": "n8n-nodes-base.tapfiliate",
        "displayName": "Tapfiliate",
        "description": "Consume Tapfiliate API",
        "group": "transform",
        "keywords": [
            "tapfiliate",
            "transform",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Tapfiliate/tapfiliate.svg"
        },
        "operations": {
            "affiliate": [
                "create",
                "delete",
                "get",
                "getAll"
            ],
            "affiliateMetadata": [
                "add",
                "remove",
                "update"
            ],
            "programAffiliate": [
                "add",
                "approve",
                "disapprove",
                "get",
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.telegram",
        "displayName": "Telegram",
        "description": "Sends data to Telegram",
        "group": "output",
        "keywords": [
            "telegram",
            "output",
            "communication",
            "hitl",
            "human",
            "form",
            "wait",
            "approval",
            "the",
            "loop"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Telegram/telegram.svg"
        },
        "operations": {
            "chat": [
                "get",
                "administrators",
                "member",
                "leave",
                "setDescription",
                "setTitle"
            ],
            "callback": [
                "answerQuery",
                "answerInlineQuery"
            ],
            "file": [
                "get"
            ],
            "message": [
                "deleteMessage",
                "editMessageText",
                "pinChatMessage",
                "sendAnimation",
                "sendAudio",
                "sendChatAction",
                "sendDocument",
                "sendLocation",
                "sendMediaGroup",
                "sendMessage",
                "sendAndWait",
                "sendPhoto",
                "sendSticker",
                "sendVideo",
                "unpinChatMessage"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.telegramTrigger",
        "displayName": "Telegram Trigger",
        "description": "Starts the workflow on a Telegram update",
        "group": "trigger",
        "keywords": [
            "telegram",
            "trigger",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Telegram/telegram.svg"
        }
    },
    {
        "name": "n8n-nodes-base.theHiveProject",
        "displayName": "TheHive 5",
        "description": "Consume TheHive 5 API",
        "group": "transform",
        "keywords": [
            "thehive",
            "transform",
            "development",
            "security",
            "monitoring",
            "incident",
            "response",
            "alert"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/TheHiveProject/thehiveproject.svg"
        },
        "operations": {
            "alert": [
                "create",
                "deleteAlert",
                "executeResponder",
                "get",
                "merge",
                "promote",
                "search",
                "update",
                "status",
                "__CUSTOM_API_CALL__"
            ],
            "case": [
                "addAttachment",
                "create",
                "deleteAttachment",
                "deleteCase",
                "executeResponder",
                "get",
                "getAttachment",
                "getTimeline",
                "search",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "comment": [
                "add",
                "deleteComment",
                "search",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "log": [
                "addAttachment",
                "create",
                "deleteLog",
                "deleteAttachment",
                "executeResponder",
                "get",
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "observable": [
                "create",
                "deleteObservable",
                "executeAnalyzer",
                "executeResponder",
                "get",
                "search",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "page": [
                "create",
                "deletePage",
                "search",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "query": [
                "executeQuery",
                "__CUSTOM_API_CALL__"
            ],
            "task": [
                "create",
                "deleteTask",
                "executeResponder",
                "get",
                "search",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.theHiveProjectTrigger",
        "displayName": "TheHive 5 Trigger",
        "description": "Starts the workflow when TheHive events occur",
        "group": "trigger",
        "keywords": [
            "thehive",
            "trigger",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/TheHiveProject/thehiveproject.svg"
        }
    },
    {
        "name": "n8n-nodes-base.theHive",
        "displayName": "TheHive",
        "description": "Consume TheHive API",
        "group": "transform",
        "keywords": [
            "thehive",
            "transform",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/TheHive/thehive.svg"
        },
        "operations": {
            "log": [
                "create",
                "executeResponder",
                "getAll",
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "alert": [],
            "case": [],
            "observable": [],
            "task": [],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.theHiveTrigger",
        "displayName": "TheHive Trigger",
        "description": "Starts the workflow when TheHive events occur",
        "group": "trigger",
        "keywords": [
            "thehive",
            "trigger",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/TheHive/thehive.svg"
        }
    },
    {
        "name": "n8n-nodes-base.timescaleDb",
        "displayName": "TimescaleDB",
        "description": "Add and update data in TimescaleDB",
        "group": "input",
        "keywords": [
            "timescaledb",
            "input",
            "data",
            "storage",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/TimescaleDb/timescaleDb.svg",
            "darkValue": "nodes/TimescaleDb/timescaleDb.dark.svg"
        },
        "operations": {
            "_": [
                "executeQuery",
                "insert",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.todoist",
        "displayName": "Todoist",
        "description": "Consume Todoist API",
        "group": "output",
        "keywords": [
            "todoist",
            "output",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Todoist/todoist.svg"
        },
        "operations": {
            "task": [
                "close",
                "create",
                "delete",
                "get",
                "getAll",
                "move",
                "quickAdd",
                "reopen",
                "update"
            ],
            "project": [
                "archive",
                "create",
                "delete",
                "get",
                "getCollaborators",
                "getAll",
                "unarchive",
                "update"
            ],
            "section": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "comment": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "label": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "reminder": [
                "create",
                "delete",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.togglTrigger",
        "displayName": "Toggl Trigger",
        "description": "Starts the workflow when Toggl events occur",
        "group": "trigger",
        "keywords": [
            "toggl",
            "trigger",
            "productivity",
            "utility"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Toggl/toggl.png"
        }
    },
    {
        "name": "n8n-nodes-base.totp",
        "displayName": "TOTP",
        "description": "Generate a time-based one-time password",
        "group": "transform",
        "keywords": [
            "totp",
            "transform",
            "core",
            "nodes",
            "2fa",
            "mfa",
            "authentication",
            "security",
            "otp",
            "password",
            "multi",
            "factor",
            "helpers"
        ],
        "icon": {
            "type": "fa",
            "value": "fingerprint"
        },
        "operations": {
            "_": [
                "generateSecret"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.travisCi",
        "displayName": "TravisCI",
        "description": "Consume TravisCI API",
        "group": "output",
        "keywords": [
            "travisci",
            "output",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/TravisCi/travisci.png"
        },
        "operations": {
            "build": [
                "cancel",
                "get",
                "getAll",
                "restart",
                "trigger"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.trello",
        "displayName": "Trello",
        "description": "Create, change and delete boards and cards",
        "group": "transform",
        "keywords": [
            "trello",
            "transform",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Trello/trello.svg"
        },
        "operations": {
            "attachment": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "board": [
                "create",
                "delete",
                "get",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "boardMember": [
                "add",
                "getAll",
                "invite",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "card": [
                "create",
                "delete",
                "get",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "cardComment": [
                "create",
                "delete",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "checklist": [
                "create",
                "createCheckItem",
                "delete",
                "deleteCheckItem",
                "get",
                "getCheckItem",
                "completedCheckItems",
                "getAll",
                "updateCheckItem",
                "__CUSTOM_API_CALL__"
            ],
            "label": [
                "addLabel",
                "create",
                "delete",
                "get",
                "getAll",
                "removeLabel",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "list": [
                "archive",
                "create",
                "get",
                "getCards",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.trelloTrigger",
        "displayName": "Trello Trigger",
        "description": "Starts the workflow when Trello events occur",
        "group": "trigger",
        "keywords": [
            "trello",
            "trigger",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Trello/trello.svg"
        }
    },
    {
        "name": "n8n-nodes-base.timeSaved",
        "displayName": "Track Time Saved",
        "description": "Dynamically track time saved based on the workflow’s execution path and the number of items processed",
        "group": "organization",
        "keywords": [
            "track",
            "time",
            "saved",
            "organization",
            "core",
            "nodes",
            "development",
            "helpers"
        ],
        "icon": {
            "type": "fa",
            "value": "timer"
        }
    },
    {
        "name": "n8n-nodes-base.twake",
        "displayName": "Twake",
        "description": "Consume Twake API",
        "group": "transform",
        "keywords": [
            "twake",
            "transform",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Twake/twake.png"
        },
        "operations": {
            "message": [
                "send",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.twilio",
        "displayName": "Twilio",
        "description": "Send SMS and WhatsApp messages or make phone calls",
        "group": "transform",
        "keywords": [
            "twilio",
            "transform",
            "communication",
            "development",
            "sms",
            "phone",
            "voice"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Twilio/twilio.svg"
        },
        "operations": {
            "sms": [
                "send",
                "__CUSTOM_API_CALL__"
            ],
            "call": [
                "make",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.twilioTrigger",
        "displayName": "Twilio Trigger",
        "description": "Starts the workflow on a Twilio update",
        "group": "trigger",
        "keywords": [
            "twilio",
            "trigger",
            "communication",
            "development",
            "sms",
            "phone",
            "voice"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Twilio/twilio.svg"
        }
    },
    {
        "name": "n8n-nodes-base.twist",
        "displayName": "Twist",
        "description": "Consume Twist API",
        "group": "input",
        "keywords": [
            "twist",
            "input",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Twist/twist.png"
        },
        "operations": {
            "channel": [
                "archive",
                "create",
                "delete",
                "get",
                "getAll",
                "unarchive",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "comment": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "messageConversation": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "thread": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.twitter",
        "displayName": "X (Formerly Twitter)",
        "description": "Post, like, and search tweets, send messages, search users, and add users to lists",
        "group": "output",
        "keywords": [
            "formerly",
            "twitter",
            "output",
            "marketing",
            "tweet",
            "api"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Twitter/x.svg",
            "darkValue": "nodes/Twitter/x.dark.svg"
        },
        "operations": {
            "directMessage": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "list": [
                "add",
                "__CUSTOM_API_CALL__"
            ],
            "tweet": [
                "create",
                "delete",
                "like",
                "retweet",
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "searchUser",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.typeformTrigger",
        "displayName": "Typeform Trigger",
        "description": "Starts the workflow on a Typeform form submission",
        "group": "trigger",
        "keywords": [
            "typeform",
            "trigger",
            "communication",
            "form"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Typeform/typeform.svg",
            "darkValue": "nodes/Typeform/typeform.dark.svg"
        }
    },
    {
        "name": "n8n-nodes-base.unleashedSoftware",
        "displayName": "Unleashed Software",
        "description": "Consume Unleashed Software API",
        "group": "transform",
        "keywords": [
            "unleashed",
            "software",
            "transform",
            "sales",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/UnleashedSoftware/unleashedSoftware.png"
        },
        "operations": {
            "salesOrder": [
                "getAll"
            ],
            "stockOnHand": [
                "get",
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.uplead",
        "displayName": "Uplead",
        "description": "Consume Uplead API",
        "group": "output",
        "keywords": [
            "uplead",
            "output",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Uplead/uplead.png"
        },
        "operations": {
            "company": [
                "enrich"
            ],
            "person": [
                "enrich"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.uproc",
        "displayName": "uProc",
        "description": "Consume uProc API",
        "group": "output",
        "keywords": [
            "uproc",
            "output",
            "data",
            "storage"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/UProc/uproc.png"
        }
    },
    {
        "name": "n8n-nodes-base.uptimeRobot",
        "displayName": "UptimeRobot",
        "description": "Consume UptimeRobot API",
        "group": "output",
        "keywords": [
            "uptimerobot",
            "output",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/UptimeRobot/uptimerobot.svg"
        },
        "operations": {
            "account": [
                "get"
            ],
            "monitor": [
                "create",
                "delete",
                "get",
                "getAll",
                "reset",
                "update"
            ],
            "alertContact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "maintenanceWindow": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "publicStatusPage": [
                "create",
                "delete",
                "get",
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.urlScanIo",
        "displayName": "urlscan.io",
        "description": "Provides various utilities for monitoring websites like health checks or screenshots",
        "group": "transform",
        "keywords": [
            "urlscan.io",
            "transform",
            "development",
            "utility",
            "scrape"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/UrlScanIo/urlScanIo.svg"
        },
        "operations": {
            "scan": [
                "get",
                "getAll",
                "perform",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.vero",
        "displayName": "Vero",
        "description": "Consume Vero API",
        "group": "output",
        "keywords": [
            "vero",
            "output",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Vero/vero.svg"
        },
        "operations": {
            "user": [
                "addTags",
                "alias",
                "create",
                "delete",
                "resubscribe",
                "removeTags",
                "unsubscribe"
            ],
            "event": [
                "track"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.venafiTlsProtectCloud",
        "displayName": "Venafi TLS Protect Cloud",
        "description": "Consume Venafi TLS Protect Cloud API",
        "group": "input",
        "keywords": [
            "venafi",
            "tls",
            "protect",
            "cloud",
            "input",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Venafi/venafi.svg"
        },
        "operations": {
            "certificate": [
                "delete",
                "download",
                "get",
                "getMany",
                "renew",
                "__CUSTOM_API_CALL__"
            ],
            "certificateRequest": [
                "create",
                "get",
                "getMany",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.venafiTlsProtectCloudTrigger",
        "displayName": "Venafi TLS Protect Cloud Trigger",
        "description": "Starts the workflow when Venafi events occur",
        "group": "trigger",
        "keywords": [
            "venafi",
            "tls",
            "protect",
            "cloud",
            "trigger",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Venafi/venafi.svg"
        }
    },
    {
        "name": "n8n-nodes-base.venafiTlsProtectDatacenter",
        "displayName": "Venafi TLS Protect Datacenter",
        "description": "Consume Venafi TLS Protect Datacenter",
        "group": "input",
        "keywords": [
            "venafi",
            "tls",
            "protect",
            "datacenter",
            "input",
            "development"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Venafi/venafi.svg"
        },
        "operations": {
            "certificate": [
                "create",
                "delete",
                "download",
                "get",
                "getMany",
                "renew",
                "__CUSTOM_API_CALL__"
            ],
            "policy": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.vonage",
        "displayName": "Vonage",
        "description": "Consume Vonage API",
        "group": "input",
        "keywords": [
            "vonage",
            "input",
            "communication",
            "sms"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Vonage/vonage.svg",
            "darkValue": "nodes/Vonage/vonage.dark.svg"
        },
        "operations": {
            "sms": [
                "send"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.wait",
        "displayName": "Wait",
        "description": "Wait before continue with execution",
        "group": "organization",
        "keywords": [
            "wait",
            "organization",
            "core",
            "nodes",
            "pause",
            "sleep",
            "delay",
            "timeout",
            "helpers",
            "flow"
        ],
        "icon": {
            "type": "fa",
            "value": "pause-circle",
            "color": "crimson"
        }
    },
    {
        "name": "n8n-nodes-base.webflow",
        "displayName": "Webflow",
        "description": "Consume the Webflow API",
        "group": "transform",
        "keywords": [
            "webflow",
            "transform",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Webflow/webflow.svg"
        },
        "operations": {
            "item": [
                "create",
                "deleteItem",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.webflowTrigger",
        "displayName": "Webflow Trigger",
        "description": "Handle Webflow events via webhooks",
        "group": "trigger",
        "keywords": [
            "webflow",
            "trigger",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Webflow/webflow.svg"
        }
    },
    {
        "name": "n8n-nodes-base.webhook",
        "displayName": "Webhook",
        "description": "Starts the workflow when a webhook is called",
        "group": "trigger",
        "keywords": [
            "webhook",
            "trigger",
            "development",
            "core",
            "nodes",
            "http",
            "api",
            "build",
            "helpers"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Webhook/webhook.svg",
            "darkValue": "nodes/Webhook/webhook.dark.svg"
        }
    },
    {
        "name": "n8n-nodes-base.wekan",
        "displayName": "Wekan",
        "description": "Consume Wekan API",
        "group": "transform",
        "keywords": [
            "wekan",
            "transform",
            "productivity"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Wekan/wekan.svg"
        },
        "operations": {
            "board": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "card": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "cardComment": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "checklist": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "checklistItem": [
                "delete",
                "get",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "list": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.whatsAppTrigger",
        "displayName": "WhatsApp Trigger",
        "description": "Handle WhatsApp events via webhooks",
        "group": "trigger",
        "keywords": [
            "whatsapp",
            "trigger",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/WhatsApp/whatsapp.svg"
        }
    },
    {
        "name": "n8n-nodes-base.whatsApp",
        "displayName": "WhatsApp Business Cloud",
        "description": "Access WhatsApp API",
        "group": "output",
        "keywords": [
            "whatsapp",
            "business",
            "cloud",
            "output",
            "communication",
            "hitl",
            "human",
            "the",
            "loop"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/WhatsApp/whatsapp.svg"
        },
        "operations": {
            "message": [
                "send",
                "sendAndWait",
                "sendTemplate"
            ],
            "media": [
                "mediaUpload",
                "mediaUrlGet",
                "mediaDelete"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.wise",
        "displayName": "Wise",
        "description": "Consume the Wise API",
        "group": "transform",
        "keywords": [
            "wise",
            "transform",
            "finance",
            "accounting",
            "currency"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Wise/wise.svg"
        },
        "operations": {
            "account": [
                "getBalances",
                "getCurrencies",
                "getStatement"
            ],
            "exchangeRate": [
                "get"
            ],
            "profile": [
                "get",
                "getAll"
            ],
            "quote": [
                "create",
                "get"
            ],
            "recipient": [
                "getAll"
            ],
            "transfer": [
                "create",
                "delete",
                "execute",
                "get",
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.wiseTrigger",
        "displayName": "Wise Trigger",
        "description": "Handle Wise events via webhooks",
        "group": "trigger",
        "keywords": [
            "wise",
            "trigger",
            "finance",
            "accounting"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Wise/wise.svg"
        }
    },
    {
        "name": "n8n-nodes-base.wooCommerce",
        "displayName": "WooCommerce",
        "description": "Consume WooCommerce API",
        "group": "output",
        "keywords": [
            "woocommerce",
            "output",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/WooCommerce/wooCommerce.svg"
        },
        "operations": {
            "customer": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "product": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "order": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.wooCommerceTrigger",
        "displayName": "WooCommerce Trigger",
        "description": "Handle WooCommerce events via webhooks",
        "group": "trigger",
        "keywords": [
            "woocommerce",
            "trigger",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/WooCommerce/wooCommerce.svg"
        }
    },
    {
        "name": "n8n-nodes-base.wordpress",
        "displayName": "Wordpress",
        "description": "Consume Wordpress API",
        "group": "output",
        "keywords": [
            "wordpress",
            "output",
            "marketing"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Wordpress/wordpress.svg"
        },
        "operations": {
            "post": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "page": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.workableTrigger",
        "displayName": "Workable Trigger",
        "description": "Starts the workflow when Workable events occur",
        "group": "trigger",
        "keywords": [
            "workable",
            "trigger",
            "miscellaneous"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Workable/workable.png"
        }
    },
    {
        "name": "n8n-nodes-base.workflowTrigger",
        "displayName": "Workflow Trigger",
        "description": "Triggers based on various lifecycle events, like when a workflow is activated",
        "group": "trigger",
        "keywords": [
            "workflow",
            "trigger",
            "core",
            "nodes",
            "flow",
            "other"
        ],
        "icon": {
            "type": "fa",
            "value": "network-wired",
            "color": "orange-red"
        }
    },
    {
        "name": "n8n-nodes-base.writeBinaryFile",
        "displayName": "Write Binary File",
        "description": "Writes a binary file to disk",
        "group": "output",
        "keywords": [
            "write",
            "binary",
            "file",
            "output",
            "core",
            "nodes",
            "text",
            "save",
            "export",
            "files"
        ],
        "icon": {
            "type": "fa",
            "value": "file-export"
        }
    },
    {
        "name": "n8n-nodes-base.wufooTrigger",
        "displayName": "Wufoo Trigger",
        "description": "Handle Wufoo events via webhooks",
        "group": "trigger",
        "keywords": [
            "wufoo",
            "trigger",
            "communication",
            "form"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Wufoo/wufoo.png"
        }
    },
    {
        "name": "n8n-nodes-base.xero",
        "displayName": "Xero",
        "description": "Consume Xero API",
        "group": "output",
        "keywords": [
            "xero",
            "output",
            "finance",
            "accounting"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Xero/xero.svg"
        },
        "operations": {
            "contact": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "invoice": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.xml",
        "displayName": "XML",
        "description": "Convert data from and to XML",
        "group": "transform",
        "keywords": [
            "xml",
            "transform",
            "core",
            "nodes",
            "parse",
            "data",
            "transformation"
        ],
        "icon": {
            "type": "fa",
            "value": "file-code",
            "color": "purple"
        }
    },
    {
        "name": "n8n-nodes-base.yourls",
        "displayName": "Yourls",
        "description": "Consume Yourls API",
        "group": "input",
        "keywords": [
            "yourls",
            "input",
            "utility"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Yourls/yourls.png"
        },
        "operations": {
            "url": [
                "expand",
                "shorten",
                "stats"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.zammad",
        "displayName": "Zammad",
        "description": "Consume the Zammad API",
        "group": "input",
        "keywords": [
            "zammad",
            "input",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Zammad/zammad.svg"
        },
        "operations": {
            "group": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "organization": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "ticket": [
                "create",
                "delete",
                "get",
                "getAll"
            ],
            "user": [
                "create",
                "delete",
                "get",
                "getAll",
                "getSelf",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.zendesk",
        "displayName": "Zendesk",
        "description": "Consume Zendesk API",
        "group": "output",
        "keywords": [
            "zendesk",
            "output",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Zendesk/zendesk.svg"
        },
        "operations": {
            "ticket": [
                "create",
                "delete",
                "get",
                "getAll",
                "recover",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "ticketField": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "create",
                "delete",
                "get",
                "getAll",
                "getOrganizations",
                "getRelatedData",
                "search",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "organization": [
                "count",
                "create",
                "delete",
                "get",
                "getAll",
                "getRelatedData",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.zendeskTrigger",
        "displayName": "Zendesk Trigger",
        "description": "Handle Zendesk events via webhooks",
        "group": "trigger",
        "keywords": [
            "zendesk",
            "trigger",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Zendesk/zendesk.svg"
        }
    },
    {
        "name": "n8n-nodes-base.zohoCrm",
        "displayName": "Zoho CRM",
        "description": "Consume Zoho CRM API",
        "group": "transform",
        "keywords": [
            "zoho",
            "crm",
            "transform",
            "communication",
            "sales"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Zoho/zoho.svg"
        },
        "operations": {
            "account": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "contact": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "deal": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "invoice": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "lead": [
                "create",
                "upsert",
                "delete",
                "get",
                "getFields",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "product": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "purchaseOrder": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "quote": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "salesOrder": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "vendor": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.zoom",
        "displayName": "Zoom",
        "description": "Consume Zoom API",
        "group": "input",
        "keywords": [
            "zoom",
            "input",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Zoom/zoom.svg"
        },
        "operations": {
            "meeting": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.zulip",
        "displayName": "Zulip",
        "description": "Consume Zulip API",
        "group": "output",
        "keywords": [
            "zulip",
            "output",
            "communication"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Zulip/zulip.svg"
        },
        "operations": {
            "message": [
                "delete",
                "get",
                "sendPrivate",
                "sendStream",
                "update",
                "updateFile"
            ],
            "stream": [
                "create",
                "delete",
                "getAll",
                "getSubscribed",
                "update"
            ],
            "user": [
                "create",
                "deactivate",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.aggregate",
        "displayName": "Aggregate",
        "description": "Combine a field from many items into a list in a single item",
        "group": "transform",
        "keywords": [
            "aggregate",
            "transform",
            "core",
            "nodes",
            "combine",
            "flatten",
            "array",
            "list",
            "item",
            "data",
            "transformation"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Transform/Aggregate/aggregate.svg"
        }
    },
    {
        "name": "n8n-nodes-base.limit",
        "displayName": "Limit",
        "description": "Restrict the number of items",
        "group": "transform",
        "keywords": [
            "limit",
            "transform",
            "core",
            "nodes",
            "remove",
            "slice",
            "array",
            "list",
            "item",
            "data",
            "transformation"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Transform/Limit/limit.svg"
        }
    },
    {
        "name": "n8n-nodes-base.removeDuplicates",
        "displayName": "Remove Duplicates",
        "description": "Delete items with matching field values",
        "group": "transform",
        "keywords": [
            "remove",
            "duplicates",
            "transform",
            "core",
            "nodes",
            "dedupe",
            "deduplicate",
            "unique",
            "array",
            "list",
            "item",
            "data",
            "transformation"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Transform/RemoveDuplicates/removeDuplicates.svg"
        },
        "operations": {
            "_": [
                "removeDuplicateInputItems",
                "removeItemsSeenInPreviousExecutions",
                "clearDeduplicationHistory"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.splitOut",
        "displayName": "Split Out",
        "description": "Turn a list inside item(s) into separate items",
        "group": "transform",
        "keywords": [
            "split",
            "out",
            "transform",
            "core",
            "nodes",
            "nested",
            "array",
            "list",
            "item",
            "data",
            "transformation"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Transform/SplitOut/splitOut.svg"
        }
    },
    {
        "name": "n8n-nodes-base.sort",
        "displayName": "Sort",
        "description": "Change items order",
        "group": "transform",
        "keywords": [
            "sort",
            "transform",
            "core",
            "nodes",
            "order",
            "array",
            "list",
            "item",
            "random",
            "data",
            "transformation"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Transform/Sort/sort.svg"
        }
    },
    {
        "name": "n8n-nodes-base.summarize",
        "displayName": "Summarize",
        "description": "Sum, count, max, etc. across items",
        "group": "transform",
        "keywords": [
            "summarize",
            "transform",
            "core",
            "nodes",
            "append",
            "array",
            "average",
            "concatenate",
            "count",
            "group",
            "item",
            "list",
            "max",
            "min",
            "pivot",
            "sum",
            "summarise",
            "unique",
            "data",
            "transformation"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Transform/Summarize/summarize.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.anthropic",
        "displayName": "Anthropic",
        "description": "Interact with Anthropic AI models",
        "group": "transform",
        "keywords": [
            "anthropic",
            "transform",
            "langchain",
            "document",
            "image",
            "assistant",
            "claude",
            "agents",
            "miscellaneous",
            "root",
            "nodes"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vendors/Anthropic/anthropic.svg"
        },
        "operations": {
            "document": [
                "analyze",
                "__CUSTOM_API_CALL__"
            ],
            "file": [
                "upload",
                "get",
                "list",
                "deleteFile",
                "__CUSTOM_API_CALL__"
            ],
            "image": [
                "analyze",
                "__CUSTOM_API_CALL__"
            ],
            "prompt": [
                "generate",
                "improve",
                "templatize",
                "__CUSTOM_API_CALL__"
            ],
            "text": [
                "message",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.googleGemini",
        "displayName": "Google Gemini",
        "description": "Interact with Google Gemini AI models",
        "group": "transform",
        "keywords": [
            "google",
            "gemini",
            "transform",
            "langchain",
            "video",
            "document",
            "audio",
            "transcribe",
            "assistant",
            "agents",
            "miscellaneous",
            "root",
            "nodes"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vendors/GoogleGemini/gemini.svg"
        },
        "operations": {
            "audio": [
                "analyze",
                "transcribe"
            ],
            "document": [
                "analyze"
            ],
            "file": [
                "upload"
            ],
            "fileSearch": [
                "createStore",
                "deleteStore",
                "listStores",
                "uploadToStore"
            ],
            "image": [
                "analyze",
                "generate",
                "edit"
            ],
            "text": [
                "message"
            ],
            "video": [
                "analyze",
                "generate",
                "download"
            ]
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.ollama",
        "displayName": "Ollama",
        "description": "Interact with Ollama AI models",
        "group": "transform",
        "keywords": [
            "ollama",
            "transform",
            "langchain",
            "image",
            "vision",
            "local",
            "agents",
            "miscellaneous",
            "root",
            "nodes"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vendors/Ollama/ollama.svg"
        },
        "operations": {
            "image": [
                "analyze",
                "__CUSTOM_API_CALL__"
            ],
            "text": [
                "message",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.openAi",
        "displayName": "OpenAI",
        "description": "Message an assistant or GPT, analyze images, generate audio, etc.",
        "group": "transform",
        "keywords": [
            "openai",
            "transform",
            "langchain",
            "chatgpt",
            "sora",
            "dalle",
            "whisper",
            "audio",
            "transcribe",
            "tts",
            "assistant",
            "agents",
            "miscellaneous",
            "root",
            "nodes"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vendors/OpenAi/openAi.svg",
            "darkValue": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vendors/OpenAi/openAi.dark.svg"
        },
        "operations": {
            "audio": [
                "generate",
                "transcribe",
                "translate"
            ],
            "file": [
                "deleteFile",
                "list",
                "upload"
            ],
            "image": [
                "analyze",
                "generate",
                "edit"
            ],
            "text": [
                "response",
                "classify"
            ],
            "conversation": [
                "create",
                "get",
                "remove",
                "update"
            ],
            "video": [
                "generate"
            ]
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.microsoftAgent365Trigger",
        "displayName": "Microsoft Agent 365 Trigger",
        "description": "Trigger for Microsoft Agent 365",
        "group": "trigger",
        "keywords": [
            "microsoft",
            "agent",
            "365",
            "trigger",
            "core",
            "nodes"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vendors/Microsoft/Agent365.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.agent",
        "displayName": "AI Agent",
        "description": "Generates an action plan and executes it. Can use external tools.",
        "group": "transform",
        "keywords": [
            "agent",
            "transform",
            "langchain",
            "chat",
            "conversational",
            "plan",
            "and",
            "execute",
            "react",
            "tools",
            "agents",
            "root",
            "nodes"
        ],
        "icon": {
            "type": "fa",
            "value": "robot",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.agentTool",
        "displayName": "AI Agent Tool",
        "description": "Generates an action plan and executes it. Can use external tools.",
        "group": "transform",
        "keywords": [
            "agent",
            "tool",
            "transform",
            "langchain",
            "chat",
            "conversational",
            "plan",
            "and",
            "execute",
            "react",
            "tools",
            "recommended"
        ],
        "icon": {
            "type": "fa",
            "value": "robot",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.openAiAssistant",
        "displayName": "OpenAI Assistant",
        "description": "Utilizes Assistant API from Open AI.",
        "group": "transform",
        "keywords": [
            "openai",
            "assistant",
            "transform",
            "langchain",
            "agents",
            "root",
            "nodes"
        ],
        "icon": {
            "type": "fa",
            "value": "robot"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.chainSummarization",
        "displayName": "Summarization Chain",
        "description": "Transforms text into a concise summary",
        "group": "transform",
        "keywords": [
            "summarization",
            "chain",
            "transform",
            "langchain",
            "chains",
            "root",
            "nodes"
        ],
        "icon": {
            "type": "fa",
            "value": "link",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.chainLlm",
        "displayName": "Basic LLM Chain",
        "description": "A simple chain to prompt a large language model",
        "group": "transform",
        "keywords": [
            "basic",
            "llm",
            "chain",
            "transform",
            "langchain",
            "chains",
            "root",
            "nodes"
        ],
        "icon": {
            "type": "fa",
            "value": "link",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.chainRetrievalQa",
        "displayName": "Question and Answer Chain",
        "description": "Answer questions about retrieved documents",
        "group": "transform",
        "keywords": [
            "question",
            "and",
            "answer",
            "chain",
            "transform",
            "langchain",
            "chains",
            "root",
            "nodes"
        ],
        "icon": {
            "type": "fa",
            "value": "link",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.sentimentAnalysis",
        "displayName": "Sentiment Analysis",
        "description": "Analyze the sentiment of your text",
        "group": "transform",
        "keywords": [
            "sentiment",
            "analysis",
            "transform",
            "chains",
            "root",
            "nodes"
        ],
        "icon": {
            "type": "fa",
            "value": "balance-scale-left",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.informationExtractor",
        "displayName": "Information Extractor",
        "description": "Extract information from text in a structured format",
        "group": "transform",
        "keywords": [
            "information",
            "extractor",
            "transform",
            "ner",
            "parse",
            "parsing",
            "json",
            "data",
            "extraction",
            "structured",
            "chains",
            "root",
            "nodes"
        ],
        "icon": {
            "type": "fa",
            "value": "project-diagram",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.textClassifier",
        "displayName": "Text Classifier",
        "description": "Classify your text into distinct categories",
        "group": "transform",
        "keywords": [
            "text",
            "classifier",
            "transform",
            "chains",
            "root",
            "nodes"
        ],
        "icon": {
            "type": "fa",
            "value": "tags",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.code",
        "displayName": "LangChain Code",
        "description": "LangChain Code Node",
        "group": "transform",
        "keywords": [
            "langchain",
            "code",
            "transform",
            "miscellaneous"
        ],
        "icon": {
            "type": "fa",
            "value": "code",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.documentDefaultDataLoader",
        "displayName": "Default Data Loader",
        "description": "Load data from previous step in the workflow",
        "group": "transform",
        "keywords": [
            "default",
            "data",
            "loader",
            "transform",
            "document",
            "loaders"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/document_loaders/DocumentDefaultDataLoader/binary.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.documentBinaryInputLoader",
        "displayName": "Binary Input Loader",
        "description": "Use binary data from a previous step in the workflow",
        "group": "transform",
        "keywords": [
            "binary",
            "input",
            "loader",
            "transform",
            "document",
            "loaders"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/document_loaders/DocumentBinaryInputLoader/binary.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.documentGithubLoader",
        "displayName": "GitHub Document Loader",
        "description": "Use GitHub data as input to this chain",
        "group": "transform",
        "keywords": [
            "github",
            "document",
            "loader",
            "transform",
            "loaders"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/document_loaders/DocumentGithubLoader/github.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.documentJsonInputLoader",
        "displayName": "JSON Input Loader",
        "description": "Use JSON data from a previous step in the workflow",
        "group": "transform",
        "keywords": [
            "json",
            "input",
            "loader",
            "transform",
            "document",
            "loaders"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/document_loaders/DocumentJSONInputLoader/json.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.embeddingsCohere",
        "displayName": "Embeddings Cohere",
        "description": "Use Cohere Embeddings",
        "group": "transform",
        "keywords": [
            "embeddings",
            "cohere",
            "transform"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/embeddings/EmbeddingsCohere/cohere.svg",
            "darkValue": "icons/@n8n/n8n-nodes-langchain/dist/nodes/embeddings/EmbeddingsCohere/cohere.dark.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.embeddingsAwsBedrock",
        "displayName": "Embeddings AWS Bedrock",
        "description": "Use Embeddings AWS Bedrock",
        "group": "transform",
        "keywords": [
            "embeddings",
            "aws",
            "bedrock",
            "transform"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/embeddings/EmbeddingsAwsBedrock/bedrock.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.embeddingsAzureOpenAi",
        "displayName": "Embeddings Azure OpenAI",
        "description": "Use Embeddings Azure OpenAI",
        "group": "transform",
        "keywords": [
            "embeddings",
            "azure",
            "openai",
            "transform"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/embeddings/EmbeddingsAzureOpenAi/azure.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.embeddingsGoogleGemini",
        "displayName": "Embeddings Google Gemini",
        "description": "Use Google Gemini Embeddings",
        "group": "transform",
        "keywords": [
            "embeddings",
            "google",
            "gemini",
            "transform"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/embeddings/EmbeddingsGoogleGemini/google.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.embeddingsGoogleVertex",
        "displayName": "Embeddings Google Vertex",
        "description": "Use Google Vertex Embeddings",
        "group": "transform",
        "keywords": [
            "embeddings",
            "google",
            "vertex",
            "transform"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/embeddings/EmbeddingsGoogleVertex/google.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.embeddingsHuggingFaceInference",
        "displayName": "Embeddings Hugging Face Inference",
        "description": "Use HuggingFace Inference Embeddings",
        "group": "transform",
        "keywords": [
            "embeddings",
            "hugging",
            "face",
            "inference",
            "transform",
            "huggingface"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/embeddings/EmbeddingsHuggingFaceInference/huggingface.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.embeddingsMistralCloud",
        "displayName": "Embeddings Mistral Cloud",
        "description": "Use Embeddings Mistral Cloud",
        "group": "transform",
        "keywords": [
            "embeddings",
            "mistral",
            "cloud",
            "transform"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/embeddings/EmbeddingsMistralCloud/mistral.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.embeddingsOpenAi",
        "displayName": "Embeddings OpenAI",
        "description": "Use Embeddings OpenAI",
        "group": "transform",
        "keywords": [
            "embeddings",
            "openai",
            "transform"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/embeddings/EmbeddingsOpenAI/openAiLight.svg",
            "darkValue": "icons/@n8n/n8n-nodes-langchain/dist/nodes/embeddings/EmbeddingsOpenAI/openAiLight.dark.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.embeddingsLemonade",
        "displayName": "Embeddings Lemonade",
        "description": "Use Lemonade Embeddings",
        "group": "transform",
        "keywords": [
            "embeddings",
            "lemonade",
            "transform"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/embeddings/EmbeddingsLemonade/lemonade.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.embeddingsOllama",
        "displayName": "Embeddings Ollama",
        "description": "Use Ollama Embeddings",
        "group": "transform",
        "keywords": [
            "embeddings",
            "ollama",
            "transform"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/embeddings/EmbeddingsOllama/ollama.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.lmChatAnthropic",
        "displayName": "Anthropic Chat Model",
        "description": "Language Model Anthropic",
        "group": "transform",
        "keywords": [
            "anthropic",
            "chat",
            "model",
            "transform",
            "claude",
            "sonnet",
            "opus",
            "language",
            "models",
            "root",
            "nodes",
            "recommended"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LMChatAnthropic/anthropic.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.lmChatAzureOpenAi",
        "displayName": "Azure OpenAI Chat Model",
        "description": "For advanced usage with an AI chain",
        "group": "transform",
        "keywords": [
            "azure",
            "openai",
            "chat",
            "model",
            "transform",
            "language",
            "models",
            "root",
            "nodes",
            "recommended"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LmChatAzureOpenAi/azure.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.lmChatAwsBedrock",
        "displayName": "AWS Bedrock Chat Model",
        "description": "Language Model AWS Bedrock",
        "group": "transform",
        "keywords": [
            "aws",
            "bedrock",
            "chat",
            "model",
            "transform",
            "language",
            "models",
            "root",
            "nodes",
            "recommended"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LmChatAwsBedrock/bedrock.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.lmChatCohere",
        "displayName": "Cohere Chat Model",
        "description": "For advanced usage with an AI chain",
        "group": "transform",
        "keywords": [
            "cohere",
            "chat",
            "model",
            "transform",
            "language",
            "models",
            "root",
            "nodes",
            "recommended"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LmChatCohere/cohere.svg",
            "darkValue": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LmChatCohere/cohere.dark.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.lmChatDeepSeek",
        "displayName": "DeepSeek Chat Model",
        "description": "For advanced usage with an AI chain",
        "group": "transform",
        "keywords": [
            "deepseek",
            "chat",
            "model",
            "transform",
            "language",
            "models",
            "root",
            "nodes",
            "recommended"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LmChatDeepSeek/deepseek.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.lmChatGoogleGemini",
        "displayName": "Google Gemini Chat Model",
        "description": "Chat Model Google Gemini",
        "group": "transform",
        "keywords": [
            "google",
            "gemini",
            "chat",
            "model",
            "transform",
            "language",
            "models",
            "root",
            "nodes",
            "recommended"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LmChatGoogleGemini/google.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.lmChatGoogleVertex",
        "displayName": "Google Vertex Chat Model",
        "description": "Chat Model Google Vertex",
        "group": "transform",
        "keywords": [
            "google",
            "vertex",
            "chat",
            "model",
            "transform",
            "language",
            "models",
            "root",
            "nodes",
            "recommended"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LmChatGoogleVertex/google.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.lmChatGroq",
        "displayName": "Groq Chat Model",
        "description": "Language Model Groq",
        "group": "transform",
        "keywords": [
            "groq",
            "chat",
            "model",
            "transform",
            "language",
            "models",
            "root",
            "nodes",
            "recommended"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LmChatGroq/groq.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.lmChatMistralCloud",
        "displayName": "Mistral Cloud Chat Model",
        "description": "For advanced usage with an AI chain",
        "group": "transform",
        "keywords": [
            "mistral",
            "cloud",
            "chat",
            "model",
            "transform",
            "language",
            "models",
            "root",
            "nodes",
            "recommended"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LmChatMistralCloud/mistral.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.lmChatLemonade",
        "displayName": "Lemonade Chat Model",
        "description": "Language Model Lemonade Chat",
        "group": "transform",
        "keywords": [
            "lemonade",
            "chat",
            "model",
            "transform",
            "language",
            "models",
            "root",
            "nodes",
            "recommended"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LMChatLemonade/lemonade.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.lmChatOllama",
        "displayName": "Ollama Chat Model",
        "description": "Language Model Ollama",
        "group": "transform",
        "keywords": [
            "ollama",
            "chat",
            "model",
            "transform",
            "language",
            "models",
            "root",
            "nodes",
            "recommended"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LMChatOllama/ollama.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.lmChatOpenRouter",
        "displayName": "OpenRouter Chat Model",
        "description": "For advanced usage with an AI chain",
        "group": "transform",
        "keywords": [
            "openrouter",
            "chat",
            "model",
            "transform",
            "language",
            "models",
            "root",
            "nodes",
            "recommended"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LmChatOpenRouter/openrouter.svg",
            "darkValue": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LmChatOpenRouter/openrouter.dark.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.lmChatVercelAiGateway",
        "displayName": "Vercel AI Gateway Chat Model",
        "description": "For advanced usage with an AI chain via Vercel AI Gateway",
        "group": "transform",
        "keywords": [
            "vercel",
            "gateway",
            "chat",
            "model",
            "transform",
            "language",
            "models",
            "root",
            "nodes",
            "recommended"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LmChatVercelAiGateway/vercel.dark.svg",
            "darkValue": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LmChatVercelAiGateway/vercel.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.lmChatXAiGrok",
        "displayName": "xAI Grok Chat Model",
        "description": "For advanced usage with an AI chain",
        "group": "transform",
        "keywords": [
            "xai",
            "grok",
            "chat",
            "model",
            "transform",
            "language",
            "models",
            "root",
            "nodes",
            "recommended"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LmChatXAiGrok/logo.dark.svg",
            "darkValue": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LmChatXAiGrok/logo.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.lmChatOpenAi",
        "displayName": "OpenAI Chat Model",
        "description": "For advanced usage with an AI chain",
        "group": "transform",
        "keywords": [
            "openai",
            "chat",
            "model",
            "transform",
            "language",
            "models",
            "root",
            "nodes",
            "recommended"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LMChatOpenAi/openAiLight.svg",
            "darkValue": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LMChatOpenAi/openAiLight.dark.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.lmOpenAi",
        "displayName": "OpenAI Model",
        "description": "For advanced usage with an AI chain",
        "group": "transform",
        "keywords": [
            "openai",
            "model",
            "transform",
            "language",
            "models",
            "root",
            "nodes",
            "text",
            "completion"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LMOpenAi/openAiLight.svg",
            "darkValue": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LMOpenAi/openAiLight.dark.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.lmCohere",
        "displayName": "Cohere Model",
        "description": "Language Model Cohere",
        "group": "transform",
        "keywords": [
            "cohere",
            "model",
            "transform",
            "language",
            "models",
            "root",
            "nodes",
            "text",
            "completion"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LMCohere/cohere.svg",
            "darkValue": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LMCohere/cohere.dark.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.lmLemonade",
        "displayName": "Lemonade Model",
        "description": "Language Model Lemonade",
        "group": "transform",
        "keywords": [
            "lemonade",
            "model",
            "transform",
            "language",
            "models",
            "root",
            "nodes",
            "text",
            "completion"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LMLemonade/lemonade.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.lmOllama",
        "displayName": "Ollama Model",
        "description": "Language Model Ollama",
        "group": "transform",
        "keywords": [
            "ollama",
            "model",
            "transform",
            "language",
            "models",
            "root",
            "nodes",
            "text",
            "completion"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LMOllama/ollama.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.lmOpenHuggingFaceInference",
        "displayName": "Hugging Face Inference Model",
        "description": "Language Model HuggingFaceInference",
        "group": "transform",
        "keywords": [
            "hugging",
            "face",
            "inference",
            "model",
            "transform",
            "language",
            "models",
            "root",
            "nodes",
            "text",
            "completion"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/llms/LMOpenHuggingFaceInference/huggingface.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.mcpClient",
        "displayName": "MCP Client",
        "description": "Standalone MCP Client",
        "group": "transform",
        "keywords": [
            "mcp",
            "client",
            "transform"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/mcp/mcp.svg",
            "darkValue": "icons/@n8n/n8n-nodes-langchain/dist/nodes/mcp/mcp.dark.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.mcpClientTool",
        "displayName": "MCP Client Tool",
        "description": "Connect tools from an MCP Server",
        "group": "output",
        "keywords": [
            "mcp",
            "client",
            "tool",
            "output",
            "model",
            "context",
            "protocol",
            "tools",
            "recommended"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/mcp/mcp.svg",
            "darkValue": "icons/@n8n/n8n-nodes-langchain/dist/nodes/mcp/mcp.dark.svg"
        },
        "isToolVariant": true
    },
    {
        "name": "@n8n/n8n-nodes-langchain.mcpTrigger",
        "displayName": "MCP Server Trigger",
        "description": "Expose n8n tools as an MCP Server endpoint",
        "group": "trigger",
        "keywords": [
            "mcp",
            "server",
            "trigger",
            "core",
            "nodes",
            "model",
            "context",
            "protocol",
            "root",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/mcp/mcp.svg",
            "darkValue": "icons/@n8n/n8n-nodes-langchain/dist/nodes/mcp/mcp.dark.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.memoryBufferWindow",
        "displayName": "Simple Memory",
        "description": "Stores in n8n memory, so no credentials required",
        "group": "transform",
        "keywords": [
            "simple",
            "memory",
            "transform",
            "for",
            "beginners"
        ],
        "icon": {
            "type": "fa",
            "value": "database",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.memoryMotorhead",
        "displayName": "Motorhead",
        "description": "Use Motorhead Memory",
        "group": "transform",
        "keywords": [
            "motorhead",
            "transform",
            "memory",
            "other",
            "memories"
        ],
        "icon": {
            "type": "fa",
            "value": "file-export",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.memoryPostgresChat",
        "displayName": "Postgres Chat Memory",
        "description": "Stores the chat history in Postgres table.",
        "group": "transform",
        "keywords": [
            "postgres",
            "chat",
            "memory",
            "transform",
            "other",
            "memories"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/memory/MemoryPostgresChat/postgres.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.memoryMongoDbChat",
        "displayName": "MongoDB Chat Memory",
        "description": "Stores the chat history in MongoDB collection.",
        "group": "transform",
        "keywords": [
            "mongodb",
            "chat",
            "memory",
            "transform",
            "other",
            "memories"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/memory/MemoryMongoDbChat/mongodb.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.memoryRedisChat",
        "displayName": "Redis Chat Memory",
        "description": "Stores the chat history in Redis.",
        "group": "transform",
        "keywords": [
            "redis",
            "chat",
            "memory",
            "transform",
            "other",
            "memories"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/memory/MemoryRedisChat/redis.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.memoryManager",
        "displayName": "Chat Memory Manager",
        "description": "Manage chat messages memory and use it in the workflow",
        "group": "transform",
        "keywords": [
            "chat",
            "memory",
            "manager",
            "transform",
            "miscellaneous",
            "root",
            "nodes"
        ],
        "icon": {
            "type": "fa",
            "value": "database",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.memoryChatRetriever",
        "displayName": "Chat Messages Retriever",
        "description": "Retrieve chat messages from memory and use them in the workflow",
        "group": "transform",
        "keywords": [
            "chat",
            "messages",
            "retriever",
            "transform",
            "miscellaneous"
        ],
        "icon": {
            "type": "fa",
            "value": "database",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.memoryXata",
        "displayName": "Xata",
        "description": "Use Xata Memory",
        "group": "transform",
        "keywords": [
            "xata",
            "transform",
            "memory",
            "other",
            "memories"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/memory/MemoryXata/xata.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.memoryZep",
        "displayName": "Zep",
        "description": "Use Zep Memory",
        "group": "transform",
        "keywords": [
            "zep",
            "transform",
            "memory",
            "other",
            "memories"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/memory/MemoryZep/zep.png"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.outputParserAutofixing",
        "displayName": "Auto-fixing Output Parser",
        "description": "Deprecated, use structured output parser",
        "group": "transform",
        "keywords": [
            "auto-fixing",
            "output",
            "parser",
            "transform",
            "parsers"
        ],
        "icon": {
            "type": "fa",
            "value": "tools",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.outputParserItemList",
        "displayName": "Item List Output Parser",
        "description": "Return the results as separate items",
        "group": "transform",
        "keywords": [
            "item",
            "list",
            "output",
            "parser",
            "transform",
            "parsers"
        ],
        "icon": {
            "type": "fa",
            "value": "bars",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.outputParserStructured",
        "displayName": "Structured Output Parser",
        "description": "Return data in a defined JSON format",
        "group": "transform",
        "keywords": [
            "structured",
            "output",
            "parser",
            "transform",
            "json",
            "zod",
            "parsers"
        ],
        "icon": {
            "type": "fa",
            "value": "code",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.rerankerCohere",
        "displayName": "Reranker Cohere",
        "description": "Use Cohere Reranker to reorder documents after retrieval from a vector store by relevance to the given query.",
        "group": "transform",
        "keywords": [
            "reranker",
            "cohere",
            "transform",
            "rerankers"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/rerankers/RerankerCohere/cohere.svg",
            "darkValue": "icons/@n8n/n8n-nodes-langchain/dist/nodes/rerankers/RerankerCohere/cohere.dark.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.retrieverContextualCompression",
        "displayName": "Contextual Compression Retriever",
        "description": "Enhances document similarity search by contextual compression.",
        "group": "transform",
        "keywords": [
            "contextual",
            "compression",
            "retriever",
            "transform",
            "retrievers"
        ],
        "icon": {
            "type": "fa",
            "value": "box-open",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.retrieverVectorStore",
        "displayName": "Vector Store Retriever",
        "description": "Use a Vector Store as Retriever",
        "group": "transform",
        "keywords": [
            "vector",
            "store",
            "retriever",
            "transform",
            "retrievers"
        ],
        "icon": {
            "type": "fa",
            "value": "box-open",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.retrieverMultiQuery",
        "displayName": "MultiQuery Retriever",
        "description": "Automates prompt tuning, generates diverse queries and expands document pool for enhanced retrieval.",
        "group": "transform",
        "keywords": [
            "multiquery",
            "retriever",
            "transform",
            "retrievers"
        ],
        "icon": {
            "type": "fa",
            "value": "box-open",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.retrieverWorkflow",
        "displayName": "Workflow Retriever",
        "description": "Use an n8n Workflow as Retriever",
        "group": "transform",
        "keywords": [
            "workflow",
            "retriever",
            "transform",
            "retrievers"
        ],
        "icon": {
            "type": "fa",
            "value": "box-open",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.textSplitterCharacterTextSplitter",
        "displayName": "Character Text Splitter",
        "description": "Split text into chunks by characters",
        "group": "transform",
        "keywords": [
            "character",
            "text",
            "splitter",
            "transform",
            "splitters"
        ],
        "icon": {
            "type": "fa",
            "value": "grip-lines-vertical",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.textSplitterRecursiveCharacterTextSplitter",
        "displayName": "Recursive Character Text Splitter",
        "description": "Split text into chunks by characters recursively, recommended for most use cases",
        "group": "transform",
        "keywords": [
            "recursive",
            "character",
            "text",
            "splitter",
            "transform",
            "splitters"
        ],
        "icon": {
            "type": "fa",
            "value": "grip-lines-vertical",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.textSplitterTokenSplitter",
        "displayName": "Token Splitter",
        "description": "Split text into chunks by tokens",
        "group": "transform",
        "keywords": [
            "token",
            "splitter",
            "transform",
            "text",
            "splitters"
        ],
        "icon": {
            "type": "fa",
            "value": "grip-lines-vertical",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.toolCalculator",
        "displayName": "Calculator",
        "description": "Make it easier for AI agents to perform arithmetic",
        "group": "transform",
        "keywords": [
            "calculator",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "fa",
            "value": "calculator",
            "color": "black"
        },
        "isToolVariant": true
    },
    {
        "name": "@n8n/n8n-nodes-langchain.toolCode",
        "displayName": "Code Tool",
        "description": "Write a tool in JS or Python",
        "group": "transform",
        "keywords": [
            "code",
            "tool",
            "transform",
            "tools",
            "recommended"
        ],
        "icon": {
            "type": "fa",
            "value": "code",
            "color": "black"
        },
        "isToolVariant": true
    },
    {
        "name": "@n8n/n8n-nodes-langchain.toolHttpRequest",
        "displayName": "HTTP Request Tool",
        "description": "Makes an HTTP request and returns the response data",
        "group": "output",
        "keywords": [
            "http",
            "request",
            "tool",
            "output",
            "tools",
            "recommended"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/tools/ToolHttpRequest/httprequest.svg",
            "darkValue": "icons/@n8n/n8n-nodes-langchain/dist/nodes/tools/ToolHttpRequest/httprequest.dark.svg"
        },
        "isToolVariant": true
    },
    {
        "name": "@n8n/n8n-nodes-langchain.toolSearXng",
        "displayName": "SearXNG",
        "description": "Search in SearXNG",
        "group": "transform",
        "keywords": [
            "searxng",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/tools/ToolSearXng/searXng.svg"
        },
        "isToolVariant": true
    },
    {
        "name": "@n8n/n8n-nodes-langchain.toolSerpApi",
        "displayName": "SerpApi (Google Search)",
        "description": "Search in Google using SerpAPI",
        "group": "transform",
        "keywords": [
            "serpapi",
            "google",
            "search",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/tools/ToolSerpApi/serpApi.svg"
        },
        "isToolVariant": true
    },
    {
        "name": "@n8n/n8n-nodes-langchain.toolThink",
        "displayName": "Think Tool",
        "description": "Invite the AI agent to do some thinking",
        "group": "transform",
        "keywords": [
            "think",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "fa",
            "value": "brain",
            "color": "black"
        },
        "isToolVariant": true
    },
    {
        "name": "@n8n/n8n-nodes-langchain.toolVectorStore",
        "displayName": "Vector Store Question Answer Tool",
        "description": "Answer questions with a vector store",
        "group": "transform",
        "keywords": [
            "vector",
            "store",
            "question",
            "answer",
            "tool",
            "transform",
            "tools",
            "other",
            "questions",
            "with"
        ],
        "icon": {
            "type": "fa",
            "value": "database",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.toolWikipedia",
        "displayName": "Wikipedia",
        "description": "Search in Wikipedia",
        "group": "transform",
        "keywords": [
            "wikipedia",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/tools/ToolWikipedia/wikipedia.svg"
        },
        "isToolVariant": true
    },
    {
        "name": "@n8n/n8n-nodes-langchain.toolWolframAlpha",
        "displayName": "Wolfram|Alpha",
        "description": "Connects to WolframAlpha's computational intelligence engine.",
        "group": "transform",
        "keywords": [
            "wolfram|alpha",
            "transform",
            "tools",
            "other",
            "wolfram",
            "alpha"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/tools/ToolWolframAlpha/wolfram-alpha.svg"
        },
        "isToolVariant": true
    },
    {
        "name": "@n8n/n8n-nodes-langchain.toolWorkflow",
        "displayName": "Call n8n Workflow Tool",
        "description": "Uses another n8n workflow as a tool. Allows packaging any n8n node(s) as a tool.",
        "group": "transform",
        "keywords": [
            "call",
            "n8n",
            "workflow",
            "tool",
            "transform",
            "tools",
            "recommended"
        ],
        "icon": {
            "type": "fa",
            "value": "network-wired",
            "color": "black"
        },
        "isToolVariant": true
    },
    {
        "name": "@n8n/n8n-nodes-langchain.manualChatTrigger",
        "displayName": "Manual Chat Trigger",
        "description": "Runs the flow on new manual chat message",
        "group": "trigger",
        "keywords": [
            "manual",
            "chat",
            "trigger",
            "core",
            "nodes",
            "other",
            "when",
            "message",
            "received"
        ],
        "icon": {
            "type": "fa",
            "value": "comments"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.chatTrigger",
        "displayName": "Chat Trigger",
        "description": "Runs the workflow when an n8n generated webchat is submitted",
        "group": "trigger",
        "keywords": [
            "chat",
            "trigger",
            "core",
            "nodes",
            "when",
            "message",
            "received"
        ],
        "icon": {
            "type": "fa",
            "value": "comments",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.chat",
        "displayName": "Chat",
        "description": "Send a message into the chat",
        "group": "input",
        "keywords": [
            "chat",
            "input",
            "core",
            "nodes",
            "hitl",
            "human",
            "wait",
            "respond",
            "approve",
            "confirm",
            "send",
            "message",
            "the",
            "loop"
        ],
        "icon": {
            "type": "fa",
            "value": "comments",
            "color": "black"
        },
        "operations": {
            "_": [
                "send",
                "sendAndWait"
            ]
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.vectorStoreAzureAISearch",
        "displayName": "Azure AI Search Vector Store",
        "description": "Work with your data in Azure AI Search Vector Store",
        "group": "transform",
        "keywords": [
            "azure",
            "search",
            "vector",
            "store",
            "transform",
            "stores",
            "tools",
            "root",
            "nodes",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vector_store/VectorStoreAzureAISearch/azure-aisearch.svg",
            "darkValue": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vector_store/VectorStoreAzureAISearch/azure-aisearch.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.vectorStoreInMemory",
        "displayName": "Simple Vector Store",
        "description": "The easiest way to experiment with vector stores, without external setup.",
        "group": "transform",
        "keywords": [
            "simple",
            "vector",
            "store",
            "transform",
            "stores",
            "tools",
            "root",
            "nodes",
            "for",
            "beginners",
            "other"
        ],
        "icon": {
            "type": "fa",
            "value": "database",
            "color": "black"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.vectorStoreInMemoryInsert",
        "displayName": "In Memory Vector Store Insert",
        "description": "Insert data into an in-memory vector store",
        "group": "transform",
        "keywords": [
            "memory",
            "vector",
            "store",
            "insert",
            "transform",
            "stores"
        ],
        "icon": {
            "type": "fa",
            "value": "database"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.vectorStoreInMemoryLoad",
        "displayName": "In Memory Vector Store Load",
        "description": "Load embedded data from an in-memory vector store",
        "group": "transform",
        "keywords": [
            "memory",
            "vector",
            "store",
            "load",
            "transform",
            "stores"
        ],
        "icon": {
            "type": "fa",
            "value": "database"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.vectorStoreMilvus",
        "displayName": "Milvus Vector Store",
        "description": "Work with your data in Milvus Vector Store",
        "group": "transform",
        "keywords": [
            "milvus",
            "vector",
            "store",
            "transform",
            "stores",
            "tools",
            "root",
            "nodes",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vector_store/VectorStoreMilvus/milvus-icon-black.svg",
            "darkValue": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vector_store/VectorStoreMilvus/milvus-icon-white.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.vectorStoreMongoDBAtlas",
        "displayName": "MongoDB Atlas Vector Store",
        "description": "Work with your data in MongoDB Atlas Vector Store",
        "group": "transform",
        "keywords": [
            "mongodb",
            "atlas",
            "vector",
            "store",
            "transform",
            "stores",
            "tools",
            "root",
            "nodes",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vector_store/VectorStoreMongoDBAtlas/mongodb.svg",
            "darkValue": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vector_store/VectorStoreMongoDBAtlas/mongodb.dark.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.vectorStorePGVector",
        "displayName": "Postgres PGVector Store",
        "description": "Work with your data in Postgresql with the PGVector extension",
        "group": "transform",
        "keywords": [
            "postgres",
            "pgvector",
            "store",
            "transform",
            "vector",
            "stores",
            "tools",
            "root",
            "nodes",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vector_store/VectorStorePGVector/postgres.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.vectorStorePinecone",
        "displayName": "Pinecone Vector Store",
        "description": "Work with your data in Pinecone Vector Store",
        "group": "transform",
        "keywords": [
            "pinecone",
            "vector",
            "store",
            "transform",
            "stores",
            "tools",
            "root",
            "nodes",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vector_store/VectorStorePinecone/pinecone.svg",
            "darkValue": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vector_store/VectorStorePinecone/pinecone.dark.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.vectorStorePineconeInsert",
        "displayName": "Pinecone: Insert",
        "description": "Insert data into Pinecone Vector Store index",
        "group": "transform",
        "keywords": [
            "pinecone",
            "insert",
            "transform",
            "vector",
            "stores"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vector_store/VectorStorePineconeInsert/pinecone.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.vectorStorePineconeLoad",
        "displayName": "Pinecone: Load",
        "description": "Load data from Pinecone Vector Store index",
        "group": "transform",
        "keywords": [
            "pinecone",
            "load",
            "transform",
            "vector",
            "stores"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vector_store/VectorStorePineconeLoad/pinecone.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.vectorStoreRedis",
        "displayName": "Redis Vector Store",
        "description": "Work with your data in a Redis vector index",
        "group": "transform",
        "keywords": [
            "redis",
            "vector",
            "store",
            "transform",
            "stores",
            "tools",
            "root",
            "nodes",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vector_store/VectorStoreRedis/redis.svg",
            "darkValue": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vector_store/VectorStoreRedis/redis.dark.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.vectorStoreQdrant",
        "displayName": "Qdrant Vector Store",
        "description": "Work with your data in a Qdrant collection",
        "group": "transform",
        "keywords": [
            "qdrant",
            "vector",
            "store",
            "transform",
            "stores",
            "tools",
            "root",
            "nodes",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vector_store/VectorStoreQdrant/qdrant.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.vectorStoreSupabase",
        "displayName": "Supabase Vector Store",
        "description": "Work with your data in Supabase Vector Store",
        "group": "transform",
        "keywords": [
            "supabase",
            "vector",
            "store",
            "transform",
            "stores",
            "tools",
            "root",
            "nodes",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vector_store/VectorStoreSupabase/supabase.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.vectorStoreSupabaseInsert",
        "displayName": "Supabase: Insert",
        "description": "Insert data into Supabase Vector Store index [https://supabase.com/docs/guides/ai/langchain]",
        "group": "transform",
        "keywords": [
            "supabase",
            "insert",
            "transform",
            "vector",
            "stores"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vector_store/VectorStoreSupabaseInsert/supabase.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.vectorStoreSupabaseLoad",
        "displayName": "Supabase: Load",
        "description": "Load data from Supabase Vector Store index",
        "group": "transform",
        "keywords": [
            "supabase",
            "load",
            "transform",
            "vector",
            "stores"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vector_store/VectorStoreSupabaseLoad/supabase.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.vectorStoreWeaviate",
        "displayName": "Weaviate Vector Store",
        "description": "Work with your data in a Weaviate Cluster",
        "group": "transform",
        "keywords": [
            "weaviate",
            "vector",
            "store",
            "transform",
            "stores",
            "tools",
            "root",
            "nodes",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vector_store/VectorStoreWeaviate/weaviate.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.vectorStoreZep",
        "displayName": "Zep Vector Store",
        "description": "Work with your data in Zep Vector Store",
        "group": "transform",
        "keywords": [
            "zep",
            "vector",
            "store",
            "transform",
            "stores",
            "tools",
            "root",
            "nodes",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vector_store/VectorStoreZep/zep.png"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.vectorStoreZepInsert",
        "displayName": "Zep Vector Store: Insert",
        "description": "Insert data into Zep Vector Store index",
        "group": "transform",
        "keywords": [
            "zep",
            "vector",
            "store",
            "insert",
            "transform",
            "stores"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vector_store/VectorStoreZepInsert/zep.png"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.vectorStoreZepLoad",
        "displayName": "Zep Vector Store: Load",
        "description": "Load data from Zep Vector Store index",
        "group": "transform",
        "keywords": [
            "zep",
            "vector",
            "store",
            "load",
            "transform",
            "stores"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vector_store/VectorStoreZepLoad/zep.png"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.vectorStoreChromaDB",
        "displayName": "Chroma Vector Store",
        "description": "Work with your data in Chroma Vector Store",
        "group": "transform",
        "keywords": [
            "chroma",
            "vector",
            "store",
            "transform",
            "stores",
            "tools",
            "root",
            "nodes",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vector_store/VectorStoreChromaDB/chroma.svg",
            "darkValue": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vector_store/VectorStoreChromaDB/chroma.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.toolExecutor",
        "displayName": "Tool Executor",
        "description": "Node to execute tools without an AI Agent",
        "group": "transform",
        "keywords": [
            "tool",
            "executor",
            "transform",
            "core",
            "nodes",
            "helpers"
        ]
    },
    {
        "name": "@n8n/n8n-nodes-langchain.modelSelector",
        "displayName": "Model Selector",
        "description": "Use this node to select one of the connected models to this node based on workflow data",
        "group": "transform",
        "keywords": [
            "model",
            "selector",
            "transform",
            "language",
            "models"
        ],
        "icon": {
            "type": "fa",
            "value": "map-signs",
            "color": "green"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.guardrails",
        "displayName": "Guardrails",
        "description": "Safeguard AI models from malicious input or prevent them from generating undesirable responses",
        "group": "transform",
        "keywords": [
            "guardrails",
            "transform",
            "langchain",
            "pii",
            "secret",
            "injection",
            "sanitize",
            "agents",
            "miscellaneous",
            "root",
            "nodes"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/Guardrails/guardrails.svg"
        },
        "operations": {
            "_": [
                "classify",
                "sanitize"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.actionNetworkTool",
        "displayName": "Action Network Tool",
        "description": "Consume the Action Network API",
        "group": "transform",
        "keywords": [
            "action",
            "network",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/ActionNetwork/actionNetwork.svg"
        },
        "isToolVariant": true,
        "operations": {
            "attendance": [
                "create",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "event": [
                "create",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "person": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "petition": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "signature": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "tag": [
                "create",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "personTag": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.activeCampaignTool",
        "displayName": "ActiveCampaign Tool",
        "description": "Create and edit data in ActiveCampaign",
        "group": "transform",
        "keywords": [
            "activecampaign",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/ActiveCampaign/activeCampaign.svg",
            "darkValue": "nodes/ActiveCampaign/activeCampaign.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "account": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "contact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "accountContact": [
                "create",
                "delete",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "contactList": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "contactTag": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "list": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "tag": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "deal": [
                "create",
                "createNote",
                "delete",
                "get",
                "getAll",
                "update",
                "updateNote",
                "__CUSTOM_API_CALL__"
            ],
            "connection": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "ecommerceOrder": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "ecommerceCustomer": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "ecommerceOrderProducts": [
                "getAll",
                "getByProductId",
                "getByOrderId",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.adaloTool",
        "displayName": "Adalo Tool",
        "description": "Consume Adalo API",
        "group": "transform",
        "keywords": [
            "adalo",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Adalo/adalo.svg"
        },
        "isToolVariant": true,
        "operations": {
            "collection": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.affinityTool",
        "displayName": "Affinity Tool",
        "description": "Consume Affinity API",
        "group": "output",
        "keywords": [
            "affinity",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Affinity/affinity.svg",
            "darkValue": "nodes/Affinity/affinity.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "list": [
                "get",
                "getAll"
            ],
            "listEntry": [
                "create",
                "delete",
                "get",
                "getAll"
            ],
            "organization": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "person": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.agileCrmTool",
        "displayName": "Agile CRM Tool",
        "description": "Consume Agile CRM API",
        "group": "transform",
        "keywords": [
            "agile",
            "crm",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/AgileCrm/agilecrm.png"
        },
        "isToolVariant": true,
        "operations": {
            "contact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "company": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "deal": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.airtableTool",
        "displayName": "Airtable Tool",
        "description": "Read, update, write and delete data from Airtable",
        "group": "input",
        "keywords": [
            "airtable",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Airtable/airtable.svg"
        },
        "isToolVariant": true,
        "operations": {
            "record": [
                "create",
                "upsert",
                "deleteRecord",
                "get",
                "search",
                "update"
            ],
            "base": [
                "getMany",
                "getSchema"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.airtopTool",
        "displayName": "Airtop Tool",
        "description": "Scrape and control any site with Airtop",
        "group": "transform",
        "keywords": [
            "airtop",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Airtop/airtop.svg"
        },
        "isToolVariant": true,
        "operations": {
            "agent": [
                "run"
            ],
            "session": [
                "create",
                "save",
                "terminate",
                "waitForDownload"
            ],
            "window": [
                "close",
                "create",
                "getLiveView",
                "list",
                "load",
                "takeScreenshot"
            ],
            "file": [
                "deleteFile",
                "get",
                "getMany",
                "load",
                "upload"
            ],
            "extraction": [
                "query",
                "getPaginated",
                "scrape"
            ],
            "interaction": [
                "click",
                "fill",
                "hover",
                "scroll",
                "type"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.amqpTool",
        "displayName": "AMQP Sender Tool",
        "description": "Sends a raw-message via AMQP 1.0, executed once per item",
        "group": "transform",
        "keywords": [
            "amqp",
            "sender",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Amqp/amqp.svg"
        },
        "isToolVariant": true
    },
    {
        "name": "n8n-nodes-base.apiTemplateIoTool",
        "displayName": "APITemplate.io Tool",
        "description": "Consume the APITemplate.io API",
        "group": "transform",
        "keywords": [
            "apitemplate.io",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/ApiTemplateIo/apiTemplateIo.svg"
        },
        "isToolVariant": true,
        "operations": {
            "image": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "pdf": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "account": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.asanaTool",
        "displayName": "Asana Tool",
        "description": "Consume Asana REST API",
        "group": "input",
        "keywords": [
            "asana",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Asana/asana.svg"
        },
        "isToolVariant": true,
        "operations": {
            "subtask": [
                "create",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "move",
                "search",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "taskComment": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "taskProject": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "taskTag": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "project": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.autopilotTool",
        "displayName": "Autopilot Tool",
        "description": "Consume Autopilot API",
        "group": "input",
        "keywords": [
            "autopilot",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Autopilot/autopilot.svg"
        },
        "isToolVariant": true,
        "operations": {
            "contact": [
                "upsert",
                "delete",
                "get",
                "getAll"
            ],
            "contactJourney": [
                "add"
            ],
            "contactList": [
                "add",
                "exist",
                "getAll",
                "remove"
            ],
            "list": [
                "create",
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.awsLambdaTool",
        "displayName": "AWS Lambda Tool",
        "description": "Invoke functions on AWS Lambda",
        "group": "output",
        "keywords": [
            "aws",
            "lambda",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Aws/lambda.svg"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "invoke",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.awsSnsTool",
        "displayName": "AWS SNS Tool",
        "description": "Sends data to AWS SNS",
        "group": "output",
        "keywords": [
            "aws",
            "sns",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Aws/sns.svg"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "create",
                "delete",
                "publish",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.awsS3Tool",
        "displayName": "AWS S3 Tool",
        "description": "Sends data to AWS S3",
        "group": "output",
        "keywords": [
            "aws",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Aws/S3/s3.svg"
        },
        "isToolVariant": true,
        "operations": {
            "bucket": [
                "create",
                "delete",
                "getAll",
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "folder": [
                "create",
                "delete",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "file": [
                "copy",
                "delete",
                "download",
                "getAll",
                "upload",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.awsSesTool",
        "displayName": "AWS SES Tool",
        "description": "Sends data to AWS SES",
        "group": "output",
        "keywords": [
            "aws",
            "ses",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Aws/SES/ses.svg"
        },
        "isToolVariant": true,
        "operations": {
            "customVerificationEmail": [
                "create",
                "delete",
                "get",
                "getAll",
                "send",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "email": [
                "send",
                "sendTemplate",
                "__CUSTOM_API_CALL__"
            ],
            "template": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.awsTextractTool",
        "displayName": "AWS Textract Tool",
        "description": "Sends data to Amazon Textract",
        "group": "output",
        "keywords": [
            "aws",
            "textract",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Aws/Textract/textract.svg"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "analyzeExpense",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.awsTranscribeTool",
        "displayName": "AWS Transcribe Tool",
        "description": "Sends data to AWS Transcribe",
        "group": "output",
        "keywords": [
            "aws",
            "transcribe",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Aws/Transcribe/transcribe.svg"
        },
        "isToolVariant": true,
        "operations": {
            "transcriptionJob": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.bambooHrTool",
        "displayName": "BambooHR Tool",
        "description": "Consume BambooHR API",
        "group": "transform",
        "keywords": [
            "bamboohr",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/BambooHr/bambooHr.png"
        },
        "isToolVariant": true,
        "operations": {
            "employee": [
                "create",
                "get",
                "getAll",
                "update"
            ],
            "employeeDocument": [
                "delete",
                "download",
                "getAll",
                "update",
                "upload"
            ],
            "file": [
                "delete",
                "download",
                "getAll",
                "update",
                "upload"
            ],
            "companyReport": [
                "get"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.baserowTool",
        "displayName": "Baserow Tool",
        "description": "Consume the Baserow API",
        "group": "output",
        "keywords": [
            "baserow",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Baserow/baserow.svg"
        },
        "isToolVariant": true,
        "operations": {
            "row": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.beeminderTool",
        "displayName": "Beeminder Tool",
        "description": "Consume Beeminder API",
        "group": "output",
        "keywords": [
            "beeminder",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Beeminder/beeminder.png"
        },
        "isToolVariant": true,
        "operations": {
            "charge": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "datapoint": [
                "create",
                "createAll",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "goal": [
                "create",
                "get",
                "getAll",
                "getArchived",
                "update",
                "refresh",
                "shortCircuit",
                "stepDown",
                "cancelStepDown",
                "uncle",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.bitlyTool",
        "displayName": "Bitly Tool",
        "description": "Consume Bitly API",
        "group": "output",
        "keywords": [
            "bitly",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Bitly/bitly.svg"
        },
        "isToolVariant": true,
        "operations": {
            "link": [
                "create",
                "get",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.bitwardenTool",
        "displayName": "Bitwarden Tool",
        "description": "Consume the Bitwarden API",
        "group": "transform",
        "keywords": [
            "bitwarden",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Bitwarden/bitwarden.svg"
        },
        "isToolVariant": true,
        "operations": {
            "collection": [
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "event": [
                "getAll"
            ],
            "group": [
                "create",
                "delete",
                "get",
                "getAll",
                "getMembers",
                "update",
                "updateMembers"
            ],
            "member": [
                "create",
                "delete",
                "get",
                "getGroups",
                "getAll",
                "update",
                "updateGroups"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.BrandfetchTool",
        "displayName": "Brandfetch Tool",
        "description": "Consume Brandfetch API",
        "group": "output",
        "keywords": [
            "brandfetch",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Brandfetch/brandfetch.png"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "color",
                "company",
                "font",
                "industry",
                "logo",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.bubbleTool",
        "displayName": "Bubble Tool",
        "description": "Consume the Bubble Data API",
        "group": "transform",
        "keywords": [
            "bubble",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Bubble/bubble.svg",
            "darkValue": "nodes/Bubble/bubble.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "object": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.chargebeeTool",
        "displayName": "Chargebee Tool",
        "description": "Retrieve data from Chargebee API",
        "group": "input",
        "keywords": [
            "chargebee",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Chargebee/chargebee.png"
        },
        "isToolVariant": true,
        "operations": {
            "customer": [
                "create"
            ],
            "invoice": [
                "list",
                "pdfUrl"
            ],
            "subscription": [
                "cancel",
                "delete"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.circleCiTool",
        "displayName": "CircleCI Tool",
        "description": "Consume CircleCI API",
        "group": "output",
        "keywords": [
            "circleci",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/CircleCi/circleCi.svg",
            "darkValue": "nodes/CircleCi/circleCi.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "pipeline": [
                "get",
                "getAll",
                "trigger"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.ciscoWebexTool",
        "displayName": "Webex by Cisco Tool",
        "description": "Consume the Cisco Webex API",
        "group": "transform",
        "keywords": [
            "webex",
            "cisco",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Cisco/Webex/ciscoWebex.png"
        },
        "isToolVariant": true,
        "operations": {
            "meeting": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "message": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.cloudflareTool",
        "displayName": "Cloudflare Tool",
        "description": "Consume Cloudflare API",
        "group": "input",
        "keywords": [
            "cloudflare",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Cloudflare/cloudflare.svg"
        },
        "isToolVariant": true,
        "operations": {
            "zoneCertificate": [
                "delete",
                "get",
                "getMany",
                "upload",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.clearbitTool",
        "displayName": "Clearbit Tool",
        "description": "Consume Clearbit API",
        "group": "output",
        "keywords": [
            "clearbit",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Clearbit/clearbit.svg"
        },
        "isToolVariant": true,
        "operations": {
            "company": [
                "autocomplete",
                "enrich"
            ],
            "person": [
                "enrich"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.clickUpTool",
        "displayName": "ClickUp Tool",
        "description": "Consume ClickUp API (Beta)",
        "group": "output",
        "keywords": [
            "clickup",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/ClickUp/clickup.svg"
        },
        "isToolVariant": true,
        "operations": {
            "checklist": [
                "create",
                "delete",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "checklistItem": [
                "create",
                "delete",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "comment": [
                "create",
                "delete",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "folder": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "goal": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "goalKeyResult": [
                "create",
                "delete",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "taskTag": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "taskList": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "spaceTag": [
                "create",
                "delete",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "member",
                "setCustomField",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "taskDependency": [
                "create",
                "delete",
                "__CUSTOM_API_CALL__"
            ],
            "timeEntry": [
                "create",
                "delete",
                "get",
                "getAll",
                "start",
                "stop",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "timeEntryTag": [
                "add",
                "getAll",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "list": [
                "create",
                "customFields",
                "delete",
                "get",
                "getAll",
                "member",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.clockifyTool",
        "displayName": "Clockify Tool",
        "description": "Consume Clockify REST API",
        "group": "transform",
        "keywords": [
            "clockify",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Clockify/clockify.svg",
            "darkValue": "nodes/Clockify/clockify.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "client": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "project": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "tag": [
                "create",
                "delete",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "timeEntry": [
                "create",
                "delete",
                "get",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "workspace": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.cockpitTool",
        "displayName": "Cockpit Tool",
        "description": "Consume Cockpit API",
        "group": "output",
        "keywords": [
            "cockpit",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Cockpit/cockpit.svg",
            "darkValue": "nodes/Cockpit/cockpit.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "collection": [
                "create",
                "getAll",
                "update"
            ],
            "form": [
                "submit"
            ],
            "singleton": [
                "get"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.codaTool",
        "displayName": "Coda Tool",
        "description": "Consume Coda API",
        "group": "output",
        "keywords": [
            "coda",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Coda/coda.svg"
        },
        "isToolVariant": true,
        "operations": {
            "table": [
                "createRow",
                "deleteRow",
                "getAllColumns",
                "getAllRows",
                "getColumn",
                "getRow",
                "pushButton"
            ],
            "formula": [
                "get",
                "getAll"
            ],
            "control": [
                "get",
                "getAll"
            ],
            "view": [
                "deleteViewRow",
                "get",
                "getAllViewColumns",
                "getAll",
                "getAllViewRows",
                "pushViewButton",
                "updateViewRow"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.coinGeckoTool",
        "displayName": "CoinGecko Tool",
        "description": "Consume CoinGecko API",
        "group": "output",
        "keywords": [
            "coingecko",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/CoinGecko/coinGecko.svg"
        },
        "isToolVariant": true,
        "operations": {
            "coin": [
                "candlestick",
                "get",
                "getAll",
                "history",
                "market",
                "marketChart",
                "price",
                "ticker"
            ],
            "event": [
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.compressionTool",
        "displayName": "Compression Tool",
        "description": "Compress and decompress files",
        "group": "transform",
        "keywords": [
            "compression",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "fa",
            "value": "file-archive",
            "color": "green"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "compress",
                "decompress"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.contentfulTool",
        "displayName": "Contentful Tool",
        "description": "Consume Contentful API",
        "group": "input",
        "keywords": [
            "contentful",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Contentful/contentful.png"
        },
        "isToolVariant": true,
        "operations": {
            "space": [
                "get"
            ],
            "contentType": [
                "get"
            ],
            "entry": [
                "get",
                "getAll"
            ],
            "asset": [
                "get",
                "getAll"
            ],
            "locale": [
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.convertKitTool",
        "displayName": "ConvertKit Tool",
        "description": "Consume ConvertKit API",
        "group": "input",
        "keywords": [
            "convertkit",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/ConvertKit/convertKit.svg"
        },
        "isToolVariant": true,
        "operations": {
            "customField": [
                "create",
                "delete",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "form": [
                "addSubscriber",
                "getAll",
                "getSubscriptions",
                "__CUSTOM_API_CALL__"
            ],
            "sequence": [
                "addSubscriber",
                "getAll",
                "getSubscriptions",
                "__CUSTOM_API_CALL__"
            ],
            "tag": [
                "create",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "tagSubscriber": [
                "add",
                "getAll",
                "delete",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.copperTool",
        "displayName": "Copper Tool",
        "description": "Consume the Copper API",
        "group": "transform",
        "keywords": [
            "copper",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Copper/copper.svg"
        },
        "isToolVariant": true,
        "operations": {
            "company": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "customerSource": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "lead": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "opportunity": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "person": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "project": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.crateDbTool",
        "displayName": "CrateDB Tool",
        "description": "Add and update data in CrateDB",
        "group": "input",
        "keywords": [
            "cratedb",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/CrateDb/cratedb.png"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "executeQuery",
                "insert",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.cryptoTool",
        "displayName": "Crypto Tool",
        "description": "Provide cryptographic utilities",
        "group": "transform",
        "keywords": [
            "crypto",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "fa",
            "value": "key",
            "color": "green"
        },
        "isToolVariant": true
    },
    {
        "name": "n8n-nodes-base.currentsTool",
        "displayName": "Currents Tool",
        "description": "Interact with the Currents API for test orchestration and analytics",
        "group": "transform",
        "keywords": [
            "currents",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Currents/currents.svg"
        },
        "isToolVariant": true,
        "operations": {
            "action": [
                "create",
                "delete",
                "disable",
                "enable",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "instance": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "project": [
                "get",
                "getAll",
                "getInsights",
                "__CUSTOM_API_CALL__"
            ],
            "run": [
                "cancel",
                "cancelGithub",
                "delete",
                "find",
                "get",
                "getAll",
                "reset",
                "__CUSTOM_API_CALL__"
            ],
            "signature": [
                "generate",
                "__CUSTOM_API_CALL__"
            ],
            "specFile": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "test": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "testResult": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.customerIoTool",
        "displayName": "Customer.io Tool",
        "description": "Consume Customer.io API",
        "group": "output",
        "keywords": [
            "customer.io",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/CustomerIo/customerio.svg",
            "darkValue": "nodes/CustomerIo/customerio.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "campaign": [
                "get",
                "getAll",
                "getMetrics",
                "__CUSTOM_API_CALL__"
            ],
            "customer": [
                "upsert",
                "delete",
                "__CUSTOM_API_CALL__"
            ],
            "event": [
                "track",
                "trackAnonymous",
                "__CUSTOM_API_CALL__"
            ],
            "segment": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.dataTableTool",
        "displayName": "Data table Tool",
        "description": "Permanently save data across workflow executions in a table",
        "group": "input",
        "keywords": [
            "data",
            "table",
            "tool",
            "input",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "fa",
            "value": "table",
            "color": "orange-red"
        },
        "isToolVariant": true,
        "operations": {
            "row": [
                "deleteRows",
                "get",
                "rowExists",
                "rowNotExists",
                "insert",
                "update",
                "upsert"
            ],
            "table": [
                "create",
                "delete",
                "list",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.dateTimeTool",
        "displayName": "Date & Time Tool",
        "description": "Manipulate date and time values",
        "group": "transform",
        "keywords": [
            "date",
            "time",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "fa",
            "value": "clock",
            "color": "green"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "addToDate",
                "extractDate",
                "formatDate",
                "getCurrentDate",
                "getTimeBetweenDates",
                "roundDate",
                "subtractFromDate"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.deepLTool",
        "displayName": "DeepL Tool",
        "description": "Translate data using DeepL",
        "group": "input",
        "keywords": [
            "deepl",
            "tool",
            "input",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/DeepL/deepl.svg",
            "darkValue": "nodes/DeepL/deepL.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "language": [
                "translate",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.demioTool",
        "displayName": "Demio Tool",
        "description": "Consume the Demio API",
        "group": "output",
        "keywords": [
            "demio",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Demio/demio.svg"
        },
        "isToolVariant": true,
        "operations": {
            "event": [
                "get",
                "getAll",
                "register"
            ],
            "report": [
                "get"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.dhlTool",
        "displayName": "DHL Tool",
        "description": "Consume DHL API",
        "group": "input",
        "keywords": [
            "dhl",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Dhl/dhl.svg"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "get"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.discordTool",
        "displayName": "Discord Tool",
        "description": "Sends data to Discord",
        "group": "output",
        "keywords": [
            "discord",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Discord/discord.svg"
        },
        "isToolVariant": true,
        "operations": {
            "message": [
                "deleteMessage",
                "get",
                "getAll",
                "react",
                "send",
                "sendAndWait",
                "__CUSTOM_API_CALL__"
            ],
            "channel": [
                "create",
                "deleteChannel",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "member": [
                "getAll",
                "roleAdd",
                "roleRemove",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": [
                "sendLegacy",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.discourseTool",
        "displayName": "Discourse Tool",
        "description": "Consume Discourse API",
        "group": "input",
        "keywords": [
            "discourse",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Discourse/discourse.svg"
        },
        "isToolVariant": true,
        "operations": {
            "category": [
                "create",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "group": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "post": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "create",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "userGroup": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.driftTool",
        "displayName": "Drift Tool",
        "description": "Consume Drift API",
        "group": "output",
        "keywords": [
            "drift",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Drift/drift.svg",
            "darkValue": "nodes/Drift/drift.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "contact": [
                "create",
                "getCustomAttributes",
                "delete",
                "get",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.dropboxTool",
        "displayName": "Dropbox Tool",
        "description": "Access data on Dropbox",
        "group": "input",
        "keywords": [
            "dropbox",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Dropbox/dropbox.svg"
        },
        "isToolVariant": true,
        "operations": {
            "file": [
                "copy",
                "delete",
                "download",
                "move",
                "upload",
                "__CUSTOM_API_CALL__"
            ],
            "folder": [
                "copy",
                "create",
                "delete",
                "list",
                "move",
                "__CUSTOM_API_CALL__"
            ],
            "search": [
                "query",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.dropcontactTool",
        "displayName": "Dropcontact Tool",
        "description": "Find B2B emails and enrich contacts",
        "group": "transform",
        "keywords": [
            "dropcontact",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Dropcontact/dropcontact.svg"
        },
        "isToolVariant": true,
        "operations": {
            "contact": [
                "enrich",
                "fetchRequest",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": [
                "enrich",
                "fetchRequest",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.egoiTool",
        "displayName": "E-goi Tool",
        "description": "Consume E-goi API",
        "group": "output",
        "keywords": [
            "e-goi",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Egoi/egoi.svg"
        },
        "isToolVariant": true,
        "operations": {
            "contact": [
                "create",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.elasticsearchTool",
        "displayName": "Elasticsearch Tool",
        "description": "Consume the Elasticsearch API",
        "group": "transform",
        "keywords": [
            "elasticsearch",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Elastic/Elasticsearch/elasticsearch.svg"
        },
        "isToolVariant": true,
        "operations": {
            "document": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "index": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.elasticSecurityTool",
        "displayName": "Elastic Security Tool",
        "description": "Consume the Elastic Security API",
        "group": "transform",
        "keywords": [
            "elastic",
            "security",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Elastic/ElasticSecurity/elasticSecurity.svg"
        },
        "isToolVariant": true,
        "operations": {
            "case": [
                "create",
                "delete",
                "get",
                "getAll",
                "getStatus",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "caseComment": [
                "add",
                "get",
                "getAll",
                "remove",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "caseTag": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "connector": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.emailSendTool",
        "displayName": "Send Email Tool",
        "description": "Sends an email using SMTP protocol",
        "group": "output",
        "keywords": [
            "send",
            "email",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "fa",
            "value": "envelope"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "send",
                "sendAndWait"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.emeliaTool",
        "displayName": "Emelia Tool",
        "description": "Consume the Emelia API",
        "group": "input",
        "keywords": [
            "emelia",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Emelia/emelia.svg"
        },
        "isToolVariant": true,
        "operations": {
            "campaign": [
                "addContact",
                "create",
                "duplicate",
                "get",
                "getAll",
                "pause",
                "start"
            ],
            "contactList": [
                "add",
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.erpNextTool",
        "displayName": "ERPNext Tool",
        "description": "Consume ERPNext API",
        "group": "output",
        "keywords": [
            "erpnext",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/ERPNext/erpnext.svg"
        },
        "isToolVariant": true,
        "operations": {
            "document": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.facebookGraphApiTool",
        "displayName": "Facebook Graph API Tool",
        "description": "Interacts with Facebook using the Graph API",
        "group": "transform",
        "keywords": [
            "facebook",
            "graph",
            "api",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Facebook/facebook.svg"
        },
        "isToolVariant": true
    },
    {
        "name": "n8n-nodes-base.filemakerTool",
        "displayName": "FileMaker Tool",
        "description": "Retrieve data from the FileMaker data API",
        "group": "input",
        "keywords": [
            "filemaker",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/FileMaker/filemaker.png"
        },
        "isToolVariant": true
    },
    {
        "name": "n8n-nodes-base.freshdeskTool",
        "displayName": "Freshdesk Tool",
        "description": "Consume Freshdesk API",
        "group": "output",
        "keywords": [
            "freshdesk",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Freshdesk/freshdesk.svg"
        },
        "isToolVariant": true,
        "operations": {
            "ticket": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "contact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.freshserviceTool",
        "displayName": "Freshservice Tool",
        "description": "Consume the Freshservice API",
        "group": "transform",
        "keywords": [
            "freshservice",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Freshservice/freshservice.svg"
        },
        "isToolVariant": true,
        "operations": {
            "agent": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "agentGroup": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "agentRole": [
                "get",
                "getAll"
            ],
            "announcement": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "assetType": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "change": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "department": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "location": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "problem": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "product": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "release": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "requester": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "requesterGroup": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "software": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "ticket": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.freshworksCrmTool",
        "displayName": "Freshworks CRM Tool",
        "description": "Consume the Freshworks CRM API",
        "group": "transform",
        "keywords": [
            "freshworks",
            "crm",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/FreshworksCrm/freshworksCrm.svg"
        },
        "isToolVariant": true,
        "operations": {
            "account": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "appointment": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "contact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "deal": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "note": [
                "create",
                "delete",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "salesActivity": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "search": [
                "query",
                "lookup",
                "__CUSTOM_API_CALL__"
            ],
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.getResponseTool",
        "displayName": "GetResponse Tool",
        "description": "Consume GetResponse API",
        "group": "input",
        "keywords": [
            "getresponse",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/GetResponse/getResponse.png"
        },
        "isToolVariant": true,
        "operations": {
            "contact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.ghostTool",
        "displayName": "Ghost Tool",
        "description": "Consume Ghost API",
        "group": "input",
        "keywords": [
            "ghost",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Ghost/ghost.svg"
        },
        "isToolVariant": true,
        "operations": {
            "post": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.gitTool",
        "displayName": "Git Tool",
        "description": "Control git.",
        "group": "transform",
        "keywords": [
            "git",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Git/git.svg"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "add",
                "addConfig",
                "clone",
                "commit",
                "fetch",
                "listConfig",
                "log",
                "pull",
                "push",
                "pushTags",
                "reflog",
                "status",
                "switchBranch",
                "tag",
                "userSetup"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.githubTool",
        "displayName": "GitHub Tool",
        "description": "Consume GitHub API",
        "group": "input",
        "keywords": [
            "github",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Github/github.svg",
            "darkValue": "nodes/Github/github.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "organization": [
                "getRepositories",
                "__CUSTOM_API_CALL__"
            ],
            "issue": [
                "create",
                "createComment",
                "edit",
                "get",
                "lock",
                "__CUSTOM_API_CALL__"
            ],
            "file": [
                "create",
                "delete",
                "edit",
                "get",
                "list",
                "__CUSTOM_API_CALL__"
            ],
            "repository": [
                "get",
                "getIssues",
                "getLicense",
                "getProfile",
                "getPullRequests",
                "listPopularPaths",
                "listReferrers",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "getRepositories",
                "getUserIssues",
                "invite",
                "__CUSTOM_API_CALL__"
            ],
            "release": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "review": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "workflow": [
                "disable",
                "dispatch",
                "dispatchAndWait",
                "enable",
                "get",
                "getUsage",
                "list",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.gitlabTool",
        "displayName": "GitLab Tool",
        "description": "Retrieve data from GitLab API",
        "group": "input",
        "keywords": [
            "gitlab",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Gitlab/gitlab.svg"
        },
        "isToolVariant": true,
        "operations": {
            "issue": [
                "create",
                "createComment",
                "edit",
                "get",
                "lock",
                "__CUSTOM_API_CALL__"
            ],
            "repository": [
                "get",
                "getIssues",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "getRepositories",
                "__CUSTOM_API_CALL__"
            ],
            "release": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "file": [
                "create",
                "delete",
                "edit",
                "get",
                "list",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.gongTool",
        "displayName": "Gong Tool",
        "description": "Interact with Gong API",
        "group": "transform",
        "keywords": [
            "gong",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Gong/gong.svg"
        },
        "isToolVariant": true,
        "operations": {
            "call": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleAdsTool",
        "displayName": "Google Ads Tool",
        "description": "Use the Google Ads API",
        "group": "transform",
        "keywords": [
            "google",
            "ads",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Ads/googleAds.svg"
        },
        "isToolVariant": true,
        "operations": {
            "campaign": [
                "getAll",
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleAnalyticsTool",
        "displayName": "Google Analytics Tool",
        "description": "Use the Google Analytics API",
        "group": "transform",
        "keywords": [
            "google",
            "analytics",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Analytics/analytics.svg"
        },
        "isToolVariant": true,
        "operations": {
            "report": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "userActivity": [
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleBigQueryTool",
        "displayName": "Google BigQuery Tool",
        "description": "Consume Google BigQuery API",
        "group": "input",
        "keywords": [
            "google",
            "bigquery",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/BigQuery/googleBigQuery.svg"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "executeQuery",
                "insert"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.googleBooksTool",
        "displayName": "Google Books Tool",
        "description": "Read data from Google Books",
        "group": "input",
        "keywords": [
            "google",
            "books",
            "tool",
            "input",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Books/googlebooks.svg"
        },
        "isToolVariant": true,
        "operations": {
            "bookshelf": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "bookshelfVolume": [
                "add",
                "clear",
                "getAll",
                "move",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "volume": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleCalendarTool",
        "displayName": "Google Calendar Tool",
        "description": "Consume Google Calendar API",
        "group": "input",
        "keywords": [
            "google",
            "calendar",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Calendar/googleCalendar.svg"
        },
        "isToolVariant": true,
        "operations": {
            "calendar": [
                "availability",
                "__CUSTOM_API_CALL__"
            ],
            "event": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleChatTool",
        "displayName": "Google Chat Tool",
        "description": "Consume Google Chat API",
        "group": "input",
        "keywords": [
            "google",
            "chat",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Chat/googleChat.svg"
        },
        "isToolVariant": true,
        "operations": {
            "member": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "message": [
                "create",
                "delete",
                "get",
                "sendAndWait",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "space": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleCloudNaturalLanguageTool",
        "displayName": "Google Cloud Natural Language Tool",
        "description": "Consume Google Cloud Natural Language API",
        "group": "input",
        "keywords": [
            "google",
            "cloud",
            "natural",
            "language",
            "tool",
            "input",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/CloudNaturalLanguage/googlecloudnaturallanguage.png"
        },
        "isToolVariant": true,
        "operations": {
            "document": [
                "analyzeSentiment",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleCloudStorageTool",
        "displayName": "Google Cloud Storage Tool",
        "description": "Use the Google Cloud Storage API",
        "group": "transform",
        "keywords": [
            "google",
            "cloud",
            "storage",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/CloudStorage/googleCloudStorage.svg"
        },
        "isToolVariant": true,
        "operations": {
            "bucket": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "object": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleContactsTool",
        "displayName": "Google Contacts Tool",
        "description": "Consume Google Contacts API",
        "group": "input",
        "keywords": [
            "google",
            "contacts",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Contacts/googleContacts.png"
        },
        "isToolVariant": true,
        "operations": {
            "contact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleDocsTool",
        "displayName": "Google Docs Tool",
        "description": "Consume Google Docs API.",
        "group": "input",
        "keywords": [
            "google",
            "docs",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Docs/googleDocs.svg"
        },
        "isToolVariant": true,
        "operations": {
            "document": [
                "create",
                "get",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleDriveTool",
        "displayName": "Google Drive Tool",
        "description": "Access data on Google Drive",
        "group": "input",
        "keywords": [
            "google",
            "drive",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Drive/googleDrive.svg"
        },
        "isToolVariant": true,
        "operations": {
            "drive": [
                "create",
                "deleteDrive",
                "get",
                "list",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "file": [
                "copy",
                "createFromText",
                "deleteFile",
                "download",
                "move",
                "share",
                "update",
                "upload",
                "__CUSTOM_API_CALL__"
            ],
            "fileFolder": [
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "folder": [
                "create",
                "deleteFolder",
                "share",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleFirebaseCloudFirestoreTool",
        "displayName": "Google Cloud Firestore Tool",
        "description": "Interact with Google Firebase - Cloud Firestore API",
        "group": "input",
        "keywords": [
            "google",
            "cloud",
            "firestore",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Firebase/CloudFirestore/googleFirebaseCloudFirestore.png"
        },
        "isToolVariant": true,
        "operations": {
            "document": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "query",
                "__CUSTOM_API_CALL__"
            ],
            "collection": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleFirebaseRealtimeDatabaseTool",
        "displayName": "Google Cloud Realtime Database Tool",
        "description": "Interact with Google Firebase - Realtime Database API",
        "group": "input",
        "keywords": [
            "google",
            "cloud",
            "realtime",
            "database",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Firebase/RealtimeDatabase/googleFirebaseRealtimeDatabase.svg"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "create",
                "delete",
                "get",
                "push",
                "update",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.gmailTool",
        "displayName": "Gmail Tool",
        "description": "Consume the Gmail API",
        "group": "transform",
        "keywords": [
            "gmail",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Gmail/gmail.svg"
        },
        "isToolVariant": true,
        "operations": {
            "draft": [
                "create",
                "delete",
                "get",
                "getAll"
            ],
            "label": [
                "create",
                "delete",
                "get",
                "getAll"
            ],
            "message": [
                "addLabels",
                "delete",
                "get",
                "getAll",
                "markAsRead",
                "markAsUnread",
                "removeLabels",
                "reply",
                "send",
                "sendAndWait"
            ],
            "thread": [
                "addLabels",
                "delete",
                "get",
                "getAll",
                "removeLabels",
                "reply",
                "trash",
                "untrash"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.gSuiteAdminTool",
        "displayName": "Google Workspace Admin Tool",
        "description": "Consume Google Workspace Admin API",
        "group": "input",
        "keywords": [
            "google",
            "workspace",
            "admin",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/GSuiteAdmin/gSuiteAdmin.svg"
        },
        "isToolVariant": true,
        "operations": {
            "device": [
                "get",
                "getAll",
                "update",
                "changeStatus",
                "__CUSTOM_API_CALL__"
            ],
            "group": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "addToGroup",
                "create",
                "delete",
                "get",
                "getAll",
                "removeFromGroup",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleBusinessProfileTool",
        "displayName": "Google Business Profile Tool",
        "description": "Consume Google Business Profile API",
        "group": "input",
        "keywords": [
            "google",
            "business",
            "profile",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/BusinessProfile/googleBusinessProfile.svg"
        },
        "isToolVariant": true,
        "operations": {
            "post": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "review": [
                "delete",
                "get",
                "getAll",
                "reply",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googlePerspectiveTool",
        "displayName": "Google Perspective Tool",
        "description": "Consume Google Perspective API",
        "group": "transform",
        "keywords": [
            "google",
            "perspective",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Perspective/googlePerspective.svg",
            "darkValue": "nodes/Google/Perspective/googlePerspective.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "analyzeComment",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.googleSheetsTool",
        "displayName": "Google Sheets Tool",
        "description": "Read, update and write data to Google Sheets",
        "group": "input",
        "keywords": [
            "google",
            "sheets",
            "tool",
            "input",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Sheet/googleSheets.svg"
        },
        "isToolVariant": true,
        "operations": {
            "sheet": [
                "appendOrUpdate",
                "append",
                "clear",
                "create",
                "remove",
                "delete",
                "read",
                "update"
            ],
            "spreadsheet": [
                "create",
                "deleteSpreadsheet"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.googleSlidesTool",
        "displayName": "Google Slides Tool",
        "description": "Consume the Google Slides API",
        "group": "input",
        "keywords": [
            "google",
            "slides",
            "tool",
            "input",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Slides/googleslides.svg"
        },
        "isToolVariant": true,
        "operations": {
            "presentation": [
                "create",
                "get",
                "getSlides",
                "replaceText",
                "__CUSTOM_API_CALL__"
            ],
            "page": [
                "get",
                "getThumbnail",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleTasksTool",
        "displayName": "Google Tasks Tool",
        "description": "Consume Google Tasks API",
        "group": "input",
        "keywords": [
            "google",
            "tasks",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Task/googleTasks.svg"
        },
        "isToolVariant": true,
        "operations": {
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.googleTranslateTool",
        "displayName": "Google Translate Tool",
        "description": "Translate data using Google Translate",
        "group": "input",
        "keywords": [
            "google",
            "translate",
            "tool",
            "input",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Translate/googletranslate.png"
        },
        "isToolVariant": true,
        "operations": {
            "language": [
                "translate",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.youTubeTool",
        "displayName": "YouTube Tool",
        "description": "Consume YouTube API",
        "group": "input",
        "keywords": [
            "youtube",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/YouTube/youTube.png"
        },
        "isToolVariant": true,
        "operations": {
            "channel": [
                "get",
                "getAll",
                "update",
                "uploadBanner",
                "__CUSTOM_API_CALL__"
            ],
            "playlist": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "playlistItem": [
                "add",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "video": [
                "delete",
                "get",
                "getAll",
                "rate",
                "update",
                "upload",
                "__CUSTOM_API_CALL__"
            ],
            "videoCategory": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.gotifyTool",
        "displayName": "Gotify Tool",
        "description": "Consume Gotify API",
        "group": "input",
        "keywords": [
            "gotify",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Gotify/gotify.png"
        },
        "isToolVariant": true,
        "operations": {
            "message": [
                "create",
                "delete",
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.goToWebinarTool",
        "displayName": "GoToWebinar Tool",
        "description": "Consume the GoToWebinar API",
        "group": "transform",
        "keywords": [
            "gotowebinar",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/GoToWebinar/gotowebinar.svg"
        },
        "isToolVariant": true,
        "operations": {
            "attendee": [
                "get",
                "getAll",
                "getDetails",
                "__CUSTOM_API_CALL__"
            ],
            "coorganizer": [
                "create",
                "delete",
                "getAll",
                "reinvite",
                "__CUSTOM_API_CALL__"
            ],
            "panelist": [
                "create",
                "delete",
                "getAll",
                "reinvite",
                "__CUSTOM_API_CALL__"
            ],
            "registrant": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "session": [
                "get",
                "getAll",
                "getDetails",
                "__CUSTOM_API_CALL__"
            ],
            "webinar": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.grafanaTool",
        "displayName": "Grafana Tool",
        "description": "Consume the Grafana API",
        "group": "transform",
        "keywords": [
            "grafana",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Grafana/grafana.svg"
        },
        "isToolVariant": true,
        "operations": {
            "dashboard": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "team": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "teamMember": [
                "add",
                "getAll",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "delete",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.graphqlTool",
        "displayName": "GraphQL Tool",
        "description": "Makes a GraphQL request and returns the received data",
        "group": "input",
        "keywords": [
            "graphql",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/GraphQL/graphql.png"
        },
        "isToolVariant": true
    },
    {
        "name": "n8n-nodes-base.gristTool",
        "displayName": "Grist Tool",
        "description": "Consume the Grist API",
        "group": "input",
        "keywords": [
            "grist",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Grist/grist.svg"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "create",
                "delete",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.hackerNewsTool",
        "displayName": "Hacker News Tool",
        "description": "Consume Hacker News API",
        "group": "transform",
        "keywords": [
            "hacker",
            "news",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/HackerNews/hackernews.png"
        },
        "isToolVariant": true,
        "operations": {
            "all": [
                "getAll"
            ],
            "article": [
                "get"
            ],
            "user": [
                "get"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.haloPSATool",
        "displayName": "HaloPSA Tool",
        "description": "Consume HaloPSA API",
        "group": "input",
        "keywords": [
            "halopsa",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/HaloPSA/halopsa.svg"
        },
        "isToolVariant": true,
        "operations": {
            "client": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "ticket": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "site": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "user": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.harvestTool",
        "displayName": "Harvest Tool",
        "description": "Access data on Harvest",
        "group": "input",
        "keywords": [
            "harvest",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Harvest/harvest.png"
        },
        "isToolVariant": true,
        "operations": {
            "client": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "company": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "contact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "estimate": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "expense": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "invoice": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "project": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "timeEntry": [
                "createByDuration",
                "createByStartEnd",
                "delete",
                "deleteExternal",
                "get",
                "getAll",
                "restartTime",
                "stopTime",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "create",
                "delete",
                "get",
                "getAll",
                "me",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.helpScoutTool",
        "displayName": "Help Scout Tool",
        "description": "Consume Help Scout API",
        "group": "input",
        "keywords": [
            "help",
            "scout",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/HelpScout/helpScout.svg"
        },
        "isToolVariant": true,
        "operations": {
            "conversation": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "customer": [
                "create",
                "get",
                "getAll",
                "properties",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "mailbox": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "thread": [
                "create",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.highLevelTool",
        "displayName": "HighLevel Tool",
        "description": "Consume HighLevel API v2",
        "group": "transform",
        "keywords": [
            "highlevel",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/HighLevel/highLevel.svg"
        },
        "isToolVariant": true,
        "operations": {
            "contact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "opportunity": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "calendar": [
                "bookAppointment",
                "getFreeSlots",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.homeAssistantTool",
        "displayName": "Home Assistant Tool",
        "description": "Consume Home Assistant API",
        "group": "output",
        "keywords": [
            "home",
            "assistant",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/HomeAssistant/homeAssistant.svg"
        },
        "isToolVariant": true,
        "operations": {
            "cameraProxy": [
                "getScreenshot"
            ],
            "config": [
                "get",
                "check"
            ],
            "event": [
                "create",
                "getAll"
            ],
            "history": [
                "getAll"
            ],
            "log": [
                "getErroLogs",
                "getLogbookEntries"
            ],
            "service": [
                "call",
                "getAll"
            ],
            "state": [
                "upsert",
                "get",
                "getAll"
            ],
            "template": [
                "create"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.httpRequestTool",
        "displayName": "HTTP Request Tool",
        "description": "Makes an HTTP request and returns the response data",
        "group": "output",
        "keywords": [
            "http",
            "request",
            "tool",
            "output",
            "tools",
            "recommended"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/HttpRequest/httprequest.svg",
            "darkValue": "nodes/HttpRequest/httprequest.dark.svg"
        },
        "isToolVariant": true
    },
    {
        "name": "n8n-nodes-base.hubspotTool",
        "displayName": "HubSpot Tool",
        "description": "Consume HubSpot API",
        "group": "output",
        "keywords": [
            "hubspot",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Hubspot/hubspot.svg"
        },
        "isToolVariant": true,
        "operations": {
            "contact": [
                "upsert",
                "delete",
                "get",
                "getAll",
                "getRecentlyCreatedUpdated",
                "search"
            ],
            "contactList": [
                "add",
                "remove"
            ],
            "company": [
                "create",
                "delete",
                "get",
                "getAll",
                "getRecentlyCreatedUpdated",
                "searchByDomain",
                "update"
            ],
            "deal": [
                "create",
                "delete",
                "get",
                "getAll",
                "getRecentlyCreatedUpdated",
                "search",
                "update"
            ],
            "engagement": [
                "create",
                "delete",
                "get",
                "getAll"
            ],
            "ticket": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.humanticAiTool",
        "displayName": "Humantic AI Tool",
        "description": "Consume Humantic AI API",
        "group": "output",
        "keywords": [
            "humantic",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/HumanticAI/humanticai.svg"
        },
        "isToolVariant": true,
        "operations": {
            "profile": [
                "create",
                "get",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.hunterTool",
        "displayName": "Hunter Tool",
        "description": "Consume Hunter API",
        "group": "output",
        "keywords": [
            "hunter",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Hunter/hunter.png"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "domainSearch",
                "emailFinder",
                "emailVerifier"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.intercomTool",
        "displayName": "Intercom Tool",
        "description": "Consume Intercom API",
        "group": "output",
        "keywords": [
            "intercom",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Intercom/intercom.svg"
        },
        "isToolVariant": true,
        "operations": {
            "lead": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "company": [
                "create",
                "get",
                "getAll",
                "update",
                "users",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.invoiceNinjaTool",
        "displayName": "Invoice Ninja Tool",
        "description": "Consume Invoice Ninja API",
        "group": "output",
        "keywords": [
            "invoice",
            "ninja",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/InvoiceNinja/invoiceNinja.svg"
        },
        "isToolVariant": true,
        "operations": {
            "client": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "invoice": [
                "create",
                "delete",
                "email",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "payment": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "expense": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "quote": [
                "create",
                "delete",
                "email",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "bank_transaction": [
                "create",
                "delete",
                "get",
                "getAll",
                "matchPayment",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.iterableTool",
        "displayName": "Iterable Tool",
        "description": "Consume Iterable API",
        "group": "input",
        "keywords": [
            "iterable",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Iterable/iterable.png"
        },
        "isToolVariant": true,
        "operations": {
            "event": [
                "track",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "upsert",
                "delete",
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "userList": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.jenkinsTool",
        "displayName": "Jenkins Tool",
        "description": "Consume Jenkins API",
        "group": "output",
        "keywords": [
            "jenkins",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Jenkins/jenkins.svg"
        },
        "isToolVariant": true,
        "operations": {
            "job": [
                "copy",
                "create",
                "trigger",
                "triggerParams"
            ],
            "instance": [
                "cancelQuietDown",
                "quietDown",
                "restart",
                "safeRestart",
                "safeExit",
                "exit"
            ],
            "build": [
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.jinaAiTool",
        "displayName": "Jina AI Tool",
        "description": "Interact with Jina AI API",
        "group": "transform",
        "keywords": [
            "jina",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/JinaAI/jinaAi.svg",
            "darkValue": "nodes/JinaAI/jinaAi.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "reader": [
                "read",
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "research": [
                "deepResearch",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.jiraTool",
        "displayName": "Jira Software Tool",
        "description": "Consume Jira Software API",
        "group": "output",
        "keywords": [
            "jira",
            "software",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Jira/jira.svg"
        },
        "isToolVariant": true,
        "operations": {
            "issue": [
                "changelog",
                "create",
                "delete",
                "get",
                "getAll",
                "notify",
                "transitions",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "issueAttachment": [
                "add",
                "get",
                "getAll",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "issueComment": [
                "add",
                "get",
                "getAll",
                "remove",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "create",
                "delete",
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.jwtTool",
        "displayName": "JWT Tool",
        "description": "JWT",
        "group": "transform",
        "keywords": [
            "jwt",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Jwt/jwt.svg"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "decode",
                "sign",
                "verify"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.kafkaTool",
        "displayName": "Kafka Tool",
        "description": "Sends messages to a Kafka topic",
        "group": "transform",
        "keywords": [
            "kafka",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Kafka/kafka.svg",
            "darkValue": "nodes/Kafka/kafka.dark.svg"
        },
        "isToolVariant": true
    },
    {
        "name": "n8n-nodes-base.keapTool",
        "displayName": "Keap Tool",
        "description": "Consume Keap API",
        "group": "input",
        "keywords": [
            "keap",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Keap/keap.png"
        },
        "isToolVariant": true,
        "operations": {
            "company": [
                "create",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "contact": [
                "upsert",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "contactNote": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "contactTag": [
                "create",
                "delete",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "ecommerceOrder": [
                "create",
                "get",
                "delete",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "ecommerceProduct": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "email": [
                "createRecord",
                "getAll",
                "send",
                "__CUSTOM_API_CALL__"
            ],
            "file": [
                "delete",
                "getAll",
                "upload",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.koBoToolboxTool",
        "displayName": "KoBoToolbox Tool",
        "description": "Work with KoBoToolbox forms and submissions",
        "group": "transform",
        "keywords": [
            "kobotoolbox",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/KoBoToolbox/koBoToolbox.svg"
        },
        "isToolVariant": true,
        "operations": {
            "form": [
                "get",
                "getAll",
                "redeploy",
                "__CUSTOM_API_CALL__"
            ],
            "hook": [
                "get",
                "getAll",
                "getLogs",
                "retryAll",
                "retryOne",
                "__CUSTOM_API_CALL__"
            ],
            "submission": [
                "delete",
                "get",
                "getAll",
                "getValidation",
                "setValidation",
                "__CUSTOM_API_CALL__"
            ],
            "file": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.ldapTool",
        "displayName": "Ldap Tool",
        "description": "Interact with LDAP servers",
        "group": "transform",
        "keywords": [
            "ldap",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Ldap/ldap.svg",
            "darkValue": "nodes/Ldap/ldap.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "compare",
                "create",
                "delete",
                "rename",
                "search",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.lemlistTool",
        "displayName": "Lemlist Tool",
        "description": "Consume the Lemlist API",
        "group": "transform",
        "keywords": [
            "lemlist",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Lemlist/lemlist.svg"
        },
        "isToolVariant": true,
        "operations": {
            "activity": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "campaign": [
                "getAll",
                "getStats",
                "__CUSTOM_API_CALL__"
            ],
            "enrich": [
                "get",
                "enrichLead",
                "enrichPerson",
                "__CUSTOM_API_CALL__"
            ],
            "lead": [
                "create",
                "delete",
                "get",
                "unsubscribe",
                "__CUSTOM_API_CALL__"
            ],
            "team": [
                "get",
                "getCredits",
                "__CUSTOM_API_CALL__"
            ],
            "unsubscribe": [
                "add",
                "delete",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.lineTool",
        "displayName": "Line Tool",
        "description": "Consume Line API",
        "group": "input",
        "keywords": [
            "line",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Line/line.png"
        },
        "isToolVariant": true,
        "operations": {
            "notification": [
                "send",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.linearTool",
        "displayName": "Linear Tool",
        "description": "Consume Linear API",
        "group": "output",
        "keywords": [
            "linear",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Linear/linear.svg"
        },
        "isToolVariant": true,
        "operations": {
            "comment": [
                "addComment",
                "__CUSTOM_API_CALL__"
            ],
            "issue": [
                "addLink",
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.lingvaNexTool",
        "displayName": "LingvaNex Tool",
        "description": "Consume LingvaNex API",
        "group": "output",
        "keywords": [
            "lingvanex",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/LingvaNex/lingvanex.png"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "translate"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.linkedInTool",
        "displayName": "LinkedIn Tool",
        "description": "Consume LinkedIn API",
        "group": "input",
        "keywords": [
            "linkedin",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/LinkedIn/linkedin.svg"
        },
        "isToolVariant": true,
        "operations": {
            "post": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.loneScaleTool",
        "displayName": "LoneScale Tool",
        "description": "Create List, add / delete items",
        "group": "transform",
        "keywords": [
            "lonescale",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/LoneScale/loneScale.svg",
            "darkValue": "nodes/LoneScale/loneScale.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "list": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "item": [
                "add",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.magento2Tool",
        "displayName": "Magento 2 Tool",
        "description": "Consume Magento API",
        "group": "input",
        "keywords": [
            "magento",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Magento/magento.svg"
        },
        "isToolVariant": true,
        "operations": {
            "customer": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "invoice": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "order": [
                "cancel",
                "get",
                "getAll",
                "ship",
                "__CUSTOM_API_CALL__"
            ],
            "product": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.mailcheckTool",
        "displayName": "Mailcheck Tool",
        "description": "Consume Mailcheck API",
        "group": "transform",
        "keywords": [
            "mailcheck",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Mailcheck/mailcheck.svg"
        },
        "isToolVariant": true,
        "operations": {
            "email": [
                "check"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.mailchimpTool",
        "displayName": "Mailchimp Tool",
        "description": "Consume Mailchimp API",
        "group": "output",
        "keywords": [
            "mailchimp",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Mailchimp/mailchimp.svg",
            "darkValue": "nodes/Mailchimp/mailchimp.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "member": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "memberTag": [
                "create",
                "delete",
                "__CUSTOM_API_CALL__"
            ],
            "listGroup": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "campaign": [
                "delete",
                "get",
                "getAll",
                "replicate",
                "resend",
                "send",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.mailerLiteTool",
        "displayName": "MailerLite Tool",
        "description": "Consume Mailer Lite API",
        "group": "input",
        "keywords": [
            "mailerlite",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/MailerLite/MailerLite.svg"
        },
        "isToolVariant": true,
        "operations": {
            "subscriber": [
                "create",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.mailgunTool",
        "displayName": "Mailgun Tool",
        "description": "Sends an email via Mailgun",
        "group": "output",
        "keywords": [
            "mailgun",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Mailgun/mailgun.svg"
        },
        "isToolVariant": true
    },
    {
        "name": "n8n-nodes-base.mailjetTool",
        "displayName": "Mailjet Tool",
        "description": "Consume Mailjet API",
        "group": "output",
        "keywords": [
            "mailjet",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Mailjet/mailjet.svg"
        },
        "isToolVariant": true,
        "operations": {
            "email": [
                "send",
                "sendTemplate",
                "__CUSTOM_API_CALL__"
            ],
            "sms": [
                "send",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.mandrillTool",
        "displayName": "Mandrill Tool",
        "description": "Consume Mandrill API",
        "group": "output",
        "keywords": [
            "mandrill",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Mandrill/mandrill.svg"
        },
        "isToolVariant": true,
        "operations": {
            "message": [
                "sendTemplate",
                "sendHtml"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.marketstackTool",
        "displayName": "Marketstack Tool",
        "description": "Consume Marketstack API",
        "group": "transform",
        "keywords": [
            "marketstack",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Marketstack/marketstack.svg",
            "darkValue": "nodes/Marketstack/marketstack.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "endOfDayData": [
                "getAll"
            ],
            "exchange": [
                "get"
            ],
            "ticker": [
                "get"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.matrixTool",
        "displayName": "Matrix Tool",
        "description": "Consume Matrix API",
        "group": "output",
        "keywords": [
            "matrix",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Matrix/matrix.png"
        },
        "isToolVariant": true,
        "operations": {
            "account": [
                "me"
            ],
            "event": [
                "get"
            ],
            "media": [
                "upload"
            ],
            "message": [
                "create",
                "getAll"
            ],
            "room": [
                "create",
                "invite",
                "join",
                "kick",
                "leave"
            ],
            "roomMember": [
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.mattermostTool",
        "displayName": "Mattermost Tool",
        "description": "Sends data to Mattermost",
        "group": "output",
        "keywords": [
            "mattermost",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Mattermost/mattermost.svg"
        },
        "isToolVariant": true,
        "operations": {
            "channel": [
                "addUser",
                "create",
                "delete",
                "members",
                "restore",
                "search",
                "statistics",
                "__CUSTOM_API_CALL__"
            ],
            "message": [
                "delete",
                "post",
                "postEphemeral",
                "__CUSTOM_API_CALL__"
            ],
            "reaction": [
                "create",
                "delete",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "create",
                "deactive",
                "getByEmail",
                "getById",
                "getAll",
                "invite",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.mauticTool",
        "displayName": "Mautic Tool",
        "description": "Consume Mautic API",
        "group": "output",
        "keywords": [
            "mautic",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Mautic/mautic.svg"
        },
        "isToolVariant": true,
        "operations": {
            "company": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "contact": [
                "create",
                "delete",
                "editContactPoint",
                "editDoNotContactList",
                "get",
                "getAll",
                "sendEmail",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "contactSegment": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "campaignContact": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "companyContact": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "segmentEmail": [
                "send",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.mediumTool",
        "displayName": "Medium Tool",
        "description": "Consume Medium API",
        "group": "output",
        "keywords": [
            "medium",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Medium/medium.png"
        },
        "isToolVariant": true,
        "operations": {
            "post": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "publication": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.messageBirdTool",
        "displayName": "MessageBird Tool",
        "description": "Sends SMS via MessageBird",
        "group": "output",
        "keywords": [
            "messagebird",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/MessageBird/messagebird.svg"
        },
        "isToolVariant": true,
        "operations": {
            "sms": [
                "send"
            ],
            "balance": [
                "get"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.metabaseTool",
        "displayName": "Metabase Tool",
        "description": "Use the Metabase API",
        "group": "transform",
        "keywords": [
            "metabase",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Metabase/metabase.svg"
        },
        "isToolVariant": true,
        "operations": {
            "questions": [
                "get",
                "getAll",
                "resultData",
                "__CUSTOM_API_CALL__"
            ],
            "metrics": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "databases": [
                "addNewDatasource",
                "getAll",
                "getFields",
                "__CUSTOM_API_CALL__"
            ],
            "alerts": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.microsoftDynamicsCrmTool",
        "displayName": "Microsoft Dynamics CRM Tool",
        "description": "Consume Microsoft Dynamics CRM API",
        "group": "input",
        "keywords": [
            "microsoft",
            "dynamics",
            "crm",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/Dynamics/microsoftDynamicsCrm.svg",
            "darkValue": "nodes/Microsoft/Dynamics/microsoftDynamicsCrm.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "account": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.microsoftEntraTool",
        "displayName": "Microsoft Entra ID Tool",
        "description": "Interact with Microsoft Entra ID API",
        "group": "transform",
        "keywords": [
            "microsoft",
            "entra",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/Entra/microsoftEntra.svg",
            "darkValue": "nodes/Microsoft/Entra/microsoftEntra.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "group": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "user": [
                "addGroup",
                "create",
                "delete",
                "get",
                "getAll",
                "removeGroup",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.microsoftExcelTool",
        "displayName": "Microsoft Excel 365 Tool",
        "description": "Consume Microsoft Excel API",
        "group": "input",
        "keywords": [
            "microsoft",
            "excel",
            "365",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/Excel/excel.svg"
        },
        "isToolVariant": true,
        "operations": {
            "table": [
                "append",
                "convertToRange",
                "addTable",
                "deleteTable",
                "getColumns",
                "getRows",
                "lookup"
            ],
            "workbook": [
                "addWorksheet",
                "deleteWorkbook",
                "getAll"
            ],
            "worksheet": [
                "append",
                "upsert",
                "clear",
                "deleteWorksheet",
                "getAll",
                "readRows",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.microsoftGraphSecurityTool",
        "displayName": "Microsoft Graph Security Tool",
        "description": "Consume the Microsoft Graph Security API",
        "group": "transform",
        "keywords": [
            "microsoft",
            "graph",
            "security",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/GraphSecurity/microsoftGraph.svg"
        },
        "isToolVariant": true,
        "operations": {
            "secureScore": [
                "get",
                "getAll"
            ],
            "secureScoreControlProfile": [
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.microsoftOneDriveTool",
        "displayName": "Microsoft OneDrive Tool",
        "description": "Consume Microsoft OneDrive API",
        "group": "input",
        "keywords": [
            "microsoft",
            "onedrive",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/OneDrive/oneDrive.svg"
        },
        "isToolVariant": true,
        "operations": {
            "file": [
                "copy",
                "delete",
                "download",
                "get",
                "rename",
                "search",
                "share",
                "upload"
            ],
            "folder": [
                "create",
                "delete",
                "getChildren",
                "rename",
                "search",
                "share"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.microsoftOutlookTool",
        "displayName": "Microsoft Outlook Tool",
        "description": "Consume Microsoft Outlook API",
        "group": "transform",
        "keywords": [
            "microsoft",
            "outlook",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/Outlook/outlook.svg"
        },
        "isToolVariant": true,
        "operations": {
            "calendar": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "contact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "draft": [
                "create",
                "delete",
                "get",
                "send",
                "update"
            ],
            "event": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "folder": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "folderMessage": [
                "getAll"
            ],
            "message": [
                "delete",
                "get",
                "getAll",
                "move",
                "reply",
                "send",
                "sendAndWait",
                "update"
            ],
            "messageAttachment": [
                "add",
                "download",
                "get",
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.microsoftSharePointTool",
        "displayName": "Microsoft SharePoint Tool",
        "description": "Interact with Microsoft SharePoint API",
        "group": "transform",
        "keywords": [
            "microsoft",
            "sharepoint",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/SharePoint/microsoftSharePoint.svg",
            "darkValue": "nodes/Microsoft/SharePoint/microsoftSharePoint.svg"
        },
        "isToolVariant": true,
        "operations": {
            "file": [
                "download",
                "update",
                "upload"
            ],
            "item": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "list": [
                "get",
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.microsoftSqlTool",
        "displayName": "Microsoft SQL Tool",
        "description": "Get, add and update data in Microsoft SQL",
        "group": "input",
        "keywords": [
            "microsoft",
            "sql",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/Sql/mssql.svg"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "executeQuery",
                "insert",
                "update",
                "delete"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.microsoftTeamsTool",
        "displayName": "Microsoft Teams Tool",
        "description": "Consume Microsoft Teams API",
        "group": "input",
        "keywords": [
            "microsoft",
            "teams",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/Teams/teams.svg"
        },
        "isToolVariant": true,
        "operations": {
            "channel": [
                "create",
                "deleteChannel",
                "get",
                "getAll",
                "update"
            ],
            "channelMessage": [
                "create",
                "getAll"
            ],
            "chatMessage": [
                "create",
                "get",
                "getAll",
                "sendAndWait"
            ],
            "task": [
                "create",
                "deleteTask",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.microsoftToDoTool",
        "displayName": "Microsoft To Do Tool",
        "description": "Consume Microsoft To Do API.",
        "group": "input",
        "keywords": [
            "microsoft",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/ToDo/todo.svg"
        },
        "isToolVariant": true,
        "operations": {
            "linkedResource": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "list": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.mispTool",
        "displayName": "MISP Tool",
        "description": "Consume the MISP API",
        "group": "transform",
        "keywords": [
            "misp",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Misp/misp.svg"
        },
        "isToolVariant": true,
        "operations": {
            "attribute": [
                "create",
                "delete",
                "get",
                "getAll",
                "search",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "event": [
                "create",
                "delete",
                "get",
                "getAll",
                "publish",
                "search",
                "unpublish",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "eventTag": [
                "add",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "feed": [
                "create",
                "disable",
                "enable",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "galaxy": [
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "noticelist": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "object": [
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "organisation": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "tag": [
                "create",
                "delete",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "warninglist": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.mistralAiTool",
        "displayName": "Mistral AI Tool",
        "description": "Consume Mistral AI API",
        "group": "transform",
        "keywords": [
            "mistral",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/MistralAI/mistralAi.svg",
            "darkValue": "nodes/MistralAI/mistralAi.svg"
        },
        "isToolVariant": true,
        "operations": {
            "document": [
                "extractText",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.moceanTool",
        "displayName": "Mocean Tool",
        "description": "Send SMS and voice messages via Mocean",
        "group": "transform",
        "keywords": [
            "mocean",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Mocean/mocean.svg",
            "darkValue": "nodes/Mocean/mocean.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "sms": [
                "send"
            ],
            "voice": [
                "send"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.mondayComTool",
        "displayName": "Monday.com Tool",
        "description": "Consume Monday.com API",
        "group": "output",
        "keywords": [
            "monday.com",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/MondayCom/mondayCom.svg"
        },
        "isToolVariant": true,
        "operations": {
            "board": [
                "archive",
                "create",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "boardColumn": [
                "create",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "boardGroup": [
                "delete",
                "create",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "boardItem": [
                "addUpdate",
                "changeColumnValue",
                "changeMultipleColumnValues",
                "create",
                "delete",
                "get",
                "getByColumnValue",
                "getAll",
                "move",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.mongoDbTool",
        "displayName": "MongoDB Tool",
        "description": "Find, insert and update documents in MongoDB",
        "group": "input",
        "keywords": [
            "mongodb",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/MongoDb/mongodb.svg"
        },
        "isToolVariant": true,
        "operations": {
            "document": [
                "aggregate",
                "delete",
                "find",
                "findOneAndReplace",
                "findOneAndUpdate",
                "insert",
                "update"
            ],
            "searchIndexes": [
                "createSearchIndex",
                "dropSearchIndex",
                "listSearchIndexes",
                "updateSearchIndex"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.monicaCrmTool",
        "displayName": "Monica CRM Tool",
        "description": "Consume the Monica CRM API",
        "group": "transform",
        "keywords": [
            "monica",
            "crm",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/MonicaCrm/monicaCrm.png"
        },
        "isToolVariant": true,
        "operations": {
            "activity": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "call": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "contact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "contactField": [
                "create",
                "delete",
                "get",
                "update"
            ],
            "contactTag": [
                "add",
                "remove"
            ],
            "conversation": [
                "create",
                "delete",
                "get",
                "update"
            ],
            "conversationMessage": [
                "add",
                "update"
            ],
            "journalEntry": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "note": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "reminder": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "tag": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.mqttTool",
        "displayName": "MQTT Tool",
        "description": "Push messages to MQTT",
        "group": "input",
        "keywords": [
            "mqtt",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/MQTT/mqtt.svg"
        },
        "isToolVariant": true
    },
    {
        "name": "n8n-nodes-base.msg91Tool",
        "displayName": "MSG91 Tool",
        "description": "Sends transactional SMS via MSG91",
        "group": "transform",
        "keywords": [
            "msg91",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Msg91/msg91.svg",
            "darkValue": "nodes/Msg91/msg91.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "sms": [
                "send"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.mySqlTool",
        "displayName": "MySQL Tool",
        "description": "Get, add and update data in MySQL",
        "group": "input",
        "keywords": [
            "mysql",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/MySql/mysql.svg",
            "darkValue": "nodes/MySql/mysql.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "deleteTable",
                "executeQuery",
                "insert",
                "upsert",
                "select",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.nasaTool",
        "displayName": "NASA Tool",
        "description": "Retrieve data from the NASA API",
        "group": "transform",
        "keywords": [
            "nasa",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Nasa/nasa.png"
        },
        "isToolVariant": true,
        "operations": {
            "astronomyPictureOfTheDay": [
                "get"
            ],
            "asteroidNeoFeed": [
                "get"
            ],
            "asteroidNeoLookup": [
                "get"
            ],
            "asteroidNeoBrowse": [
                "getAll"
            ],
            "donkiCoronalMassEjection": [
                "get"
            ],
            "donkiGeomagneticStorm": [
                "get"
            ],
            "donkiInterplanetaryShock": [
                "get"
            ],
            "donkiSolarFlare": [
                "get"
            ],
            "donkiSolarEnergeticParticle": [
                "get"
            ],
            "donkiMagnetopauseCrossing": [
                "get"
            ],
            "donkiRadiationBeltEnhancement": [
                "get"
            ],
            "donkiHighSpeedStream": [
                "get"
            ],
            "donkiWsaEnlilSimulation": [
                "get"
            ],
            "donkiNotifications": [
                "get"
            ],
            "earthImagery": [
                "get"
            ],
            "earthAssets": [
                "get"
            ],
            "inSightMarsWeatherService": [
                "get"
            ],
            "imageAndVideoLibrary": [
                "get"
            ],
            "techTransfer": [
                "get"
            ],
            "twoLineElementSet": [
                "get"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.netlifyTool",
        "displayName": "Netlify Tool",
        "description": "Consume Netlify API",
        "group": "transform",
        "keywords": [
            "netlify",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Netlify/netlify.svg"
        },
        "isToolVariant": true,
        "operations": {
            "deploy": [
                "cancel",
                "create",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "site": [
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.nextCloudTool",
        "displayName": "Nextcloud Tool",
        "description": "Access data on Nextcloud",
        "group": "input",
        "keywords": [
            "nextcloud",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/NextCloud/nextcloud.svg"
        },
        "isToolVariant": true,
        "operations": {
            "file": [
                "copy",
                "delete",
                "download",
                "move",
                "share",
                "upload",
                "__CUSTOM_API_CALL__"
            ],
            "folder": [
                "copy",
                "create",
                "delete",
                "list",
                "move",
                "share",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.nocoDbTool",
        "displayName": "NocoDB Tool",
        "description": "Read, update, write and delete data from NocoDB",
        "group": "input",
        "keywords": [
            "nocodb",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/NocoDB/nocodb.svg"
        },
        "isToolVariant": true,
        "operations": {
            "row": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.sendInBlueTool",
        "displayName": "Brevo Tool",
        "description": "Consume Brevo API",
        "group": "transform",
        "keywords": [
            "brevo",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Brevo/brevo.svg"
        },
        "isToolVariant": true,
        "operations": {
            "attribute": [
                "create",
                "update",
                "delete",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "sender": [
                "create",
                "delete",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "contact": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "email": [
                "send",
                "sendTemplate",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.onfleetTool",
        "displayName": "Onfleet Tool",
        "description": "Consume Onfleet API",
        "group": "input",
        "keywords": [
            "onfleet",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Onfleet/Onfleet.svg"
        },
        "isToolVariant": true,
        "operations": {
            "admin": [
                "create",
                "delete",
                "getAll",
                "update"
            ],
            "container": [
                "addTask",
                "get",
                "updateTask"
            ],
            "destination": [
                "create",
                "get"
            ],
            "hub": [
                "create",
                "getAll",
                "update"
            ],
            "organization": [
                "get",
                "getDelegatee"
            ],
            "recipient": [
                "create",
                "get",
                "update"
            ],
            "task": [
                "clone",
                "complete",
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "team": [
                "autoDispatch",
                "create",
                "delete",
                "get",
                "getAll",
                "getTimeEstimates",
                "update"
            ],
            "worker": [
                "create",
                "delete",
                "get",
                "getAll",
                "getSchedule",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.notionTool",
        "displayName": "Notion Tool",
        "description": "Consume Notion API",
        "group": "output",
        "keywords": [
            "notion",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Notion/notion.svg",
            "darkValue": "nodes/Notion/notion.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "block": [
                "append",
                "getAll"
            ],
            "database": [
                "get",
                "getAll",
                "search"
            ],
            "databasePage": [
                "create",
                "get",
                "getAll",
                "update"
            ],
            "page": [
                "archive",
                "create",
                "search"
            ],
            "user": [
                "get",
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.npmTool",
        "displayName": "Npm Tool",
        "description": "Consume NPM registry API",
        "group": "input",
        "keywords": [
            "npm",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Npm/npm.svg"
        },
        "isToolVariant": true,
        "operations": {
            "package": [
                "getMetadata",
                "getVersions",
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "distTag": [
                "getMany",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.odooTool",
        "displayName": "Odoo Tool",
        "description": "Consume Odoo API",
        "group": "transform",
        "keywords": [
            "odoo",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Odoo/odoo.svg"
        },
        "isToolVariant": true,
        "operations": {
            "custom": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "opportunity": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "contact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "note": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.oktaTool",
        "displayName": "Okta Tool",
        "description": "Use the Okta API",
        "group": "transform",
        "keywords": [
            "okta",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Okta/Okta.svg",
            "darkValue": "nodes/Okta/Okta.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "user": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.oneSimpleApiTool",
        "displayName": "One Simple API Tool",
        "description": "A toolbox of no-code utilities",
        "group": "transform",
        "keywords": [
            "one",
            "simple",
            "api",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/OneSimpleApi/onesimpleapi.svg"
        },
        "isToolVariant": true,
        "operations": {
            "website": [
                "pdf",
                "seo",
                "screenshot"
            ],
            "socialProfile": [
                "instagramProfile",
                "spotifyArtistProfile"
            ],
            "information": [
                "exchangeRate",
                "imageMetadata"
            ],
            "utility": [
                "expandURL",
                "qrCode",
                "validateEmail"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.openThesaurusTool",
        "displayName": "OpenThesaurus Tool",
        "description": "Get synonmns for German words using the OpenThesaurus API",
        "group": "output",
        "keywords": [
            "openthesaurus",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/OpenThesaurus/openthesaurus.png"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "getSynonyms"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.openWeatherMapTool",
        "displayName": "OpenWeatherMap Tool",
        "description": "Gets current and future weather information",
        "group": "input",
        "keywords": [
            "openweathermap",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/OpenWeatherMap/openWeatherMap.svg"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "currentWeather",
                "5DayForecast",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.oracleDatabaseTool",
        "displayName": "Oracle Database Tool",
        "description": "Get, add and update data in Oracle database",
        "group": "input",
        "keywords": [
            "oracle",
            "database",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Oracle/Sql/oracle.svg"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "deleteTable",
                "execute",
                "insert",
                "upsert",
                "select",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.ouraTool",
        "displayName": "Oura Tool",
        "description": "Consume Oura API",
        "group": "output",
        "keywords": [
            "oura",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Oura/oura.svg",
            "darkValue": "nodes/Oura/oura.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "profile": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "summary": [
                "getActivity",
                "getReadiness",
                "getSleep",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.paddleTool",
        "displayName": "Paddle Tool",
        "description": "Consume Paddle API",
        "group": "output",
        "keywords": [
            "paddle",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Paddle/paddle.png"
        },
        "isToolVariant": true,
        "operations": {
            "coupon": [
                "create",
                "getAll",
                "update"
            ],
            "payment": [
                "getAll",
                "reschedule"
            ],
            "plan": [
                "get",
                "getAll"
            ],
            "product": [
                "getAll"
            ],
            "user": [
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.pagerDutyTool",
        "displayName": "PagerDuty Tool",
        "description": "Consume PagerDuty API",
        "group": "output",
        "keywords": [
            "pagerduty",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/PagerDuty/pagerDuty.svg"
        },
        "isToolVariant": true,
        "operations": {
            "incident": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "incidentNote": [
                "create",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "logEntry": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.peekalinkTool",
        "displayName": "Peekalink Tool",
        "description": "Consume the Peekalink API",
        "group": "output",
        "keywords": [
            "peekalink",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Peekalink/peekalink.png"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "isAvailable",
                "preview"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.perplexityTool",
        "displayName": "Perplexity Tool",
        "description": "AI-powered answer engine that provides accurate, trusted, and real-time answers to any question. Generates AI responses with citations",
        "group": "transform",
        "keywords": [
            "perplexity",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Perplexity/perplexity.svg",
            "darkValue": "nodes/Perplexity/perplexity.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "complete",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.phantombusterTool",
        "displayName": "Phantombuster Tool",
        "description": "Consume Phantombuster API",
        "group": "input",
        "keywords": [
            "phantombuster",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Phantombuster/phantombuster.png"
        },
        "isToolVariant": true,
        "operations": {
            "agent": [
                "delete",
                "get",
                "getAll",
                "getOutput",
                "launch",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.philipsHueTool",
        "displayName": "Philips Hue Tool",
        "description": "Consume Philips Hue API",
        "group": "input",
        "keywords": [
            "philips",
            "hue",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/PhilipsHue/philipshue.png"
        },
        "isToolVariant": true,
        "operations": {
            "light": [
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.pipedriveTool",
        "displayName": "Pipedrive Tool",
        "description": "Create and edit data in Pipedrive",
        "group": "transform",
        "keywords": [
            "pipedrive",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Pipedrive/pipedrive.svg"
        },
        "isToolVariant": true,
        "operations": {
            "activity": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "deal": [
                "create",
                "delete",
                "duplicate",
                "get",
                "getAll",
                "search",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "dealActivity": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "dealProduct": [
                "add",
                "getAll",
                "remove",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "file": [
                "create",
                "delete",
                "download",
                "get",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "lead": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "note": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "organization": [
                "create",
                "delete",
                "get",
                "getAll",
                "search",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "person": [
                "create",
                "delete",
                "get",
                "getAll",
                "search",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "product": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.plivoTool",
        "displayName": "Plivo Tool",
        "description": "Send SMS/MMS messages or make phone calls",
        "group": "transform",
        "keywords": [
            "plivo",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Plivo/plivo.svg"
        },
        "isToolVariant": true,
        "operations": {
            "sms": [
                "send"
            ],
            "mms": [
                "send"
            ],
            "call": [
                "make"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.postBinTool",
        "displayName": "PostBin Tool",
        "description": "Consume PostBin API",
        "group": "transform",
        "keywords": [
            "postbin",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/PostBin/postbin.svg"
        },
        "isToolVariant": true,
        "operations": {
            "bin": [
                "create",
                "get",
                "delete"
            ],
            "request": [
                "get",
                "removeFirst",
                "send"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.postgresTool",
        "displayName": "Postgres Tool",
        "description": "Get, add and update data in Postgres",
        "group": "input",
        "keywords": [
            "postgres",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Postgres/postgres.svg"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "deleteTable",
                "executeQuery",
                "insert",
                "upsert",
                "select",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.postHogTool",
        "displayName": "PostHog Tool",
        "description": "Consume PostHog API",
        "group": "input",
        "keywords": [
            "posthog",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/PostHog/postHog.svg"
        },
        "isToolVariant": true,
        "operations": {
            "alias": [
                "create"
            ],
            "event": [
                "create"
            ],
            "identity": [
                "create"
            ],
            "track": [
                "page",
                "screen"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.profitWellTool",
        "displayName": "ProfitWell Tool",
        "description": "Consume ProfitWell API",
        "group": "output",
        "keywords": [
            "profitwell",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/ProfitWell/profitwell.svg",
            "darkValue": "nodes/ProfitWell/profitwell.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "company": [
                "getSetting"
            ],
            "metric": [
                "get"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.pushbulletTool",
        "displayName": "Pushbullet Tool",
        "description": "Consume Pushbullet API",
        "group": "input",
        "keywords": [
            "pushbullet",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Pushbullet/pushbullet.svg"
        },
        "isToolVariant": true,
        "operations": {
            "push": [
                "create",
                "delete",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.pushcutTool",
        "displayName": "Pushcut Tool",
        "description": "Consume Pushcut API",
        "group": "input",
        "keywords": [
            "pushcut",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Pushcut/pushcut.png"
        },
        "isToolVariant": true,
        "operations": {
            "notification": [
                "send"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.pushoverTool",
        "displayName": "Pushover Tool",
        "description": "Consume Pushover API",
        "group": "input",
        "keywords": [
            "pushover",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Pushover/pushover.svg"
        },
        "isToolVariant": true,
        "operations": {
            "message": [
                "push",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.questDbTool",
        "displayName": "QuestDB Tool",
        "description": "Get, add and update data in QuestDB",
        "group": "input",
        "keywords": [
            "questdb",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/QuestDb/questdb.png"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "executeQuery",
                "insert"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.quickbaseTool",
        "displayName": "Quick Base Tool",
        "description": "Integrate with the Quick Base RESTful API",
        "group": "input",
        "keywords": [
            "quick",
            "base",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/QuickBase/quickbase.png"
        },
        "isToolVariant": true,
        "operations": {
            "field": [
                "getAll"
            ],
            "file": [
                "delete",
                "download"
            ],
            "record": [
                "create",
                "upsert",
                "delete",
                "getAll",
                "update"
            ],
            "report": [
                "get",
                "run"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.quickbooksTool",
        "displayName": "QuickBooks Online Tool",
        "description": "Consume the QuickBooks Online API",
        "group": "transform",
        "keywords": [
            "quickbooks",
            "online",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/QuickBooks/quickbooks.svg"
        },
        "isToolVariant": true,
        "operations": {
            "bill": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "customer": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "employee": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "estimate": [
                "create",
                "delete",
                "get",
                "getAll",
                "send",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "invoice": [
                "create",
                "delete",
                "get",
                "getAll",
                "send",
                "update",
                "void",
                "__CUSTOM_API_CALL__"
            ],
            "item": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "payment": [
                "create",
                "delete",
                "get",
                "getAll",
                "send",
                "update",
                "void",
                "__CUSTOM_API_CALL__"
            ],
            "purchase": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "transaction": [
                "getReport",
                "__CUSTOM_API_CALL__"
            ],
            "vendor": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.quickChartTool",
        "displayName": "QuickChart Tool",
        "description": "Create a chart via QuickChart",
        "group": "output",
        "keywords": [
            "quickchart",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/QuickChart/quickChart.svg"
        },
        "isToolVariant": true
    },
    {
        "name": "n8n-nodes-base.rabbitmqTool",
        "displayName": "RabbitMQ Tool",
        "description": "Sends messages to a RabbitMQ topic",
        "group": "transform",
        "keywords": [
            "rabbitmq",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/RabbitMQ/rabbitmq.svg"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "sendMessage",
                "deleteMessage"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.raindropTool",
        "displayName": "Raindrop Tool",
        "description": "Consume the Raindrop API",
        "group": "transform",
        "keywords": [
            "raindrop",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Raindrop/raindrop.svg"
        },
        "isToolVariant": true,
        "operations": {
            "bookmark": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "collection": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "tag": [
                "delete",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.redditTool",
        "displayName": "Reddit Tool",
        "description": "Consume the Reddit API",
        "group": "transform",
        "keywords": [
            "reddit",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Reddit/reddit.svg"
        },
        "isToolVariant": true,
        "operations": {
            "postComment": [
                "create",
                "getAll",
                "delete",
                "reply",
                "__CUSTOM_API_CALL__"
            ],
            "profile": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "subreddit": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "post": [
                "create",
                "delete",
                "get",
                "getAll",
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.redisTool",
        "displayName": "Redis Tool",
        "description": "Get, send and update data in Redis",
        "group": "input",
        "keywords": [
            "redis",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Redis/redis.svg"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "delete",
                "get",
                "incr",
                "info",
                "keys",
                "llen",
                "pop",
                "publish",
                "push",
                "set"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.rocketchatTool",
        "displayName": "RocketChat Tool",
        "description": "Consume RocketChat API",
        "group": "output",
        "keywords": [
            "rocketchat",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Rocketchat/rocketchat.svg"
        },
        "isToolVariant": true,
        "operations": {
            "chat": [
                "postMessage",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.rssFeedReadTool",
        "displayName": "RSS Read Tool",
        "description": "Reads data from an RSS Feed",
        "group": "input",
        "keywords": [
            "rss",
            "read",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "fa",
            "value": "rss",
            "color": "orange-red"
        },
        "isToolVariant": true
    },
    {
        "name": "n8n-nodes-base.rundeckTool",
        "displayName": "Rundeck Tool",
        "description": "Manage Rundeck API",
        "group": "transform",
        "keywords": [
            "rundeck",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Rundeck/rundeck.png"
        },
        "isToolVariant": true,
        "operations": {
            "job": [
                "execute",
                "getMetadata",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": [
                "execute",
                "getMetadata",
                "__CUSTOM_API_CALL__"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.s3Tool",
        "displayName": "S3 Tool",
        "description": "Sends data to any S3-compatible service",
        "group": "output",
        "keywords": [
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/S3/s3.png"
        },
        "isToolVariant": true,
        "operations": {
            "bucket": [
                "create",
                "delete",
                "getAll",
                "search"
            ],
            "folder": [
                "create",
                "delete",
                "getAll"
            ],
            "file": [
                "copy",
                "delete",
                "download",
                "getAll",
                "upload"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.salesforceTool",
        "displayName": "Salesforce Tool",
        "description": "Consume Salesforce API",
        "group": "output",
        "keywords": [
            "salesforce",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Salesforce/salesforce.svg"
        },
        "isToolVariant": true,
        "operations": {
            "lead": [
                "addToCampaign",
                "addNote",
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "getSummary",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "contact": [
                "addToCampaign",
                "addNote",
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "getSummary",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "customObject": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "document": [
                "upload",
                "__CUSTOM_API_CALL__"
            ],
            "opportunity": [
                "addNote",
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "getSummary",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "account": [
                "addNote",
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "getSummary",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "search": [
                "query",
                "__CUSTOM_API_CALL__"
            ],
            "case": [
                "addComment",
                "create",
                "delete",
                "get",
                "getAll",
                "getSummary",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "getSummary",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "attachment": [
                "create",
                "delete",
                "get",
                "getAll",
                "getSummary",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "flow": [
                "getAll",
                "invoke",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.salesmateTool",
        "displayName": "Salesmate Tool",
        "description": "Consume Salesmate API",
        "group": "output",
        "keywords": [
            "salesmate",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Salesmate/salesmate.png"
        },
        "isToolVariant": true,
        "operations": {
            "company": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "activity": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "deal": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.seaTableTool",
        "displayName": "SeaTable Tool",
        "description": "Consume the SeaTable API",
        "group": "output",
        "keywords": [
            "seatable",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/SeaTable/seaTable.svg"
        },
        "isToolVariant": true,
        "operations": {
            "row": [
                "create",
                "remove",
                "get",
                "list",
                "lock",
                "search",
                "unlock",
                "update"
            ],
            "base": [
                "snapshot",
                "metadata",
                "collaborator"
            ],
            "link": [
                "add",
                "list",
                "remove"
            ],
            "asset": [
                "getPublicURL",
                "upload"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.securityScorecardTool",
        "displayName": "SecurityScorecard Tool",
        "description": "Consume SecurityScorecard API",
        "group": "transform",
        "keywords": [
            "securityscorecard",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/SecurityScorecard/securityScorecard.svg"
        },
        "isToolVariant": true,
        "operations": {
            "company": [
                "getFactor",
                "getFactorHistorical",
                "getHistoricalScore",
                "getScorecard",
                "getScorePlan"
            ],
            "industry": [
                "getFactor",
                "getFactorHistorical",
                "getScore"
            ],
            "invite": [
                "create"
            ],
            "portfolio": [
                "create",
                "delete",
                "getAll",
                "update"
            ],
            "portfolioCompany": [
                "add",
                "getAll",
                "remove"
            ],
            "report": [
                "download",
                "generate",
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.segmentTool",
        "displayName": "Segment Tool",
        "description": "Consume Segment API",
        "group": "output",
        "keywords": [
            "segment",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Segment/segment.svg"
        },
        "isToolVariant": true,
        "operations": {
            "group": [
                "add",
                "__CUSTOM_API_CALL__"
            ],
            "identify": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "track": [
                "event",
                "page",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.sendGridTool",
        "displayName": "SendGrid Tool",
        "description": "Consume SendGrid API",
        "group": "transform",
        "keywords": [
            "sendgrid",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/SendGrid/sendGrid.svg"
        },
        "isToolVariant": true,
        "operations": {
            "list": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "contact": [
                "upsert",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "mail": [
                "send",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.sendyTool",
        "displayName": "Sendy Tool",
        "description": "Consume Sendy API",
        "group": "input",
        "keywords": [
            "sendy",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Sendy/sendy.png"
        },
        "isToolVariant": true,
        "operations": {
            "campaign": [
                "create"
            ],
            "subscriber": [
                "add",
                "count",
                "delete",
                "remove",
                "status"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.sentryIoTool",
        "displayName": "Sentry.io Tool",
        "description": "Consume Sentry.io API",
        "group": "output",
        "keywords": [
            "sentry.io",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/SentryIo/sentryio.svg",
            "darkValue": "nodes/SentryIo/sentryio.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "event": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "issue": [
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "organization": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "project": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "release": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "team": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.serviceNowTool",
        "displayName": "ServiceNow Tool",
        "description": "Consume ServiceNow API",
        "group": "output",
        "keywords": [
            "servicenow",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/ServiceNow/servicenow.svg"
        },
        "isToolVariant": true,
        "operations": {
            "attachment": [
                "upload",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "businessService": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "configurationItems": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "department": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "dictionary": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "incident": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "tableRecord": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "userGroup": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "userRole": [
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.shopifyTool",
        "displayName": "Shopify Tool",
        "description": "Consume Shopify API",
        "group": "output",
        "keywords": [
            "shopify",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Shopify/shopify.svg"
        },
        "isToolVariant": true,
        "operations": {
            "order": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "product": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.signl4Tool",
        "displayName": "SIGNL4 Tool",
        "description": "Consume SIGNL4 API",
        "group": "transform",
        "keywords": [
            "signl4",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Signl4/signl4.png"
        },
        "isToolVariant": true,
        "operations": {
            "alert": [
                "send",
                "resolve"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.slackTool",
        "displayName": "Slack Tool",
        "description": "Consume Slack API",
        "group": "output",
        "keywords": [
            "slack",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Slack/slack.svg"
        },
        "isToolVariant": true,
        "operations": {
            "channel": [
                "archive",
                "close",
                "create",
                "get",
                "getAll",
                "history",
                "invite",
                "join",
                "kick",
                "leave",
                "member",
                "open",
                "rename",
                "replies",
                "setPurpose",
                "setTopic",
                "unarchive"
            ],
            "message": [
                "delete",
                "getPermalink",
                "search",
                "post",
                "sendAndWait",
                "update"
            ],
            "star": [
                "add",
                "delete",
                "getAll"
            ],
            "file": [
                "get",
                "getAll",
                "upload"
            ],
            "reaction": [
                "add",
                "get",
                "remove"
            ],
            "user": [
                "info",
                "getAll",
                "getProfile",
                "getPresence",
                "updateProfile"
            ],
            "userGroup": [
                "updateUsers",
                "create",
                "disable",
                "enable",
                "getAll",
                "getUsers",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.sms77Tool",
        "displayName": "seven Tool",
        "description": "Send SMS and make text-to-speech calls",
        "group": "transform",
        "keywords": [
            "seven",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Sms77/seven.svg"
        },
        "isToolVariant": true,
        "operations": {
            "sms": [
                "send",
                "__CUSTOM_API_CALL__"
            ],
            "voice": [
                "send",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.snowflakeTool",
        "displayName": "Snowflake Tool",
        "description": "Get, add and update data in Snowflake",
        "group": "input",
        "keywords": [
            "snowflake",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Snowflake/snowflake.svg"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "executeQuery",
                "insert",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.splunkTool",
        "displayName": "Splunk Tool",
        "description": "Consume the Splunk Enterprise API",
        "group": "transform",
        "keywords": [
            "splunk",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Splunk/splunk.svg"
        },
        "isToolVariant": true,
        "operations": {
            "alert": [
                "getReport",
                "getMetrics",
                "__CUSTOM_API_CALL__"
            ],
            "report": [
                "create",
                "deleteReport",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "search": [
                "create",
                "deleteJob",
                "get",
                "getAll",
                "getResult",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "create",
                "deleteUser",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.spotifyTool",
        "displayName": "Spotify Tool",
        "description": "Access public song data via the Spotify API",
        "group": "input",
        "keywords": [
            "spotify",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Spotify/spotify.svg"
        },
        "isToolVariant": true,
        "operations": {
            "player": [
                "addSongToQueue",
                "currentlyPlaying",
                "nextSong",
                "pause",
                "previousSong",
                "recentlyPlayed",
                "resume",
                "volume",
                "startMusic",
                "__CUSTOM_API_CALL__"
            ],
            "album": [
                "get",
                "getNewReleases",
                "getTracks",
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "artist": [
                "get",
                "getAlbums",
                "getRelatedArtists",
                "getTopTracks",
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "playlist": [
                "add",
                "create",
                "get",
                "getUserPlaylists",
                "getTracks",
                "delete",
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "track": [
                "get",
                "getAudioFeatures",
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "library": [
                "getLikedTracks",
                "__CUSTOM_API_CALL__"
            ],
            "myData": [
                "getFollowingArtists",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.stackbyTool",
        "displayName": "Stackby Tool",
        "description": "Read, write, and delete data in Stackby",
        "group": "transform",
        "keywords": [
            "stackby",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Stackby/stackby.png"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "append",
                "delete",
                "list",
                "read"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.storyblokTool",
        "displayName": "Storyblok Tool",
        "description": "Consume Storyblok API",
        "group": "output",
        "keywords": [
            "storyblok",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Storyblok/storyblok.svg"
        },
        "isToolVariant": true,
        "operations": {
            "story": [
                "delete",
                "get",
                "getAll",
                "publish",
                "unpublish"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.strapiTool",
        "displayName": "Strapi Tool",
        "description": "Consume Strapi API",
        "group": "input",
        "keywords": [
            "strapi",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Strapi/strapi.svg"
        },
        "isToolVariant": true,
        "operations": {
            "entry": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.stravaTool",
        "displayName": "Strava Tool",
        "description": "Consume Strava API",
        "group": "input",
        "keywords": [
            "strava",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Strava/strava.svg"
        },
        "isToolVariant": true,
        "operations": {
            "activity": [
                "create",
                "get",
                "getComments",
                "getKudos",
                "getLaps",
                "getAll",
                "getStreams",
                "getZones",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.stripeTool",
        "displayName": "Stripe Tool",
        "description": "Consume the Stripe API",
        "group": "transform",
        "keywords": [
            "stripe",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Stripe/stripe.svg"
        },
        "isToolVariant": true,
        "operations": {
            "balance": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "customerCard": [
                "add",
                "get",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "charge": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "coupon": [
                "create",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "customer": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "meterEvent": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "source": [
                "create",
                "delete",
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "token": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.supabaseTool",
        "displayName": "Supabase Tool",
        "description": "Add, get, delete and update data in a table",
        "group": "input",
        "keywords": [
            "supabase",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Supabase/supabase.svg"
        },
        "isToolVariant": true,
        "operations": {
            "row": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.syncroMspTool",
        "displayName": "SyncroMSP Tool",
        "description": "Gets data from SyncroMSP",
        "group": "output",
        "keywords": [
            "syncromsp",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/SyncroMSP/syncromsp.png"
        },
        "isToolVariant": true,
        "operations": {
            "customer": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "ticket": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "contact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "rmm": [
                "create",
                "delete",
                "get",
                "getAll",
                "mute"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.taigaTool",
        "displayName": "Taiga Tool",
        "description": "Consume Taiga API",
        "group": "transform",
        "keywords": [
            "taiga",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Taiga/taiga.svg"
        },
        "isToolVariant": true,
        "operations": {
            "epic": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "issue": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "task": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "userStory": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.tapfiliateTool",
        "displayName": "Tapfiliate Tool",
        "description": "Consume Tapfiliate API",
        "group": "transform",
        "keywords": [
            "tapfiliate",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Tapfiliate/tapfiliate.svg"
        },
        "isToolVariant": true,
        "operations": {
            "affiliate": [
                "create",
                "delete",
                "get",
                "getAll"
            ],
            "affiliateMetadata": [
                "add",
                "remove",
                "update"
            ],
            "programAffiliate": [
                "add",
                "approve",
                "disapprove",
                "get",
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.telegramTool",
        "displayName": "Telegram Tool",
        "description": "Sends data to Telegram",
        "group": "output",
        "keywords": [
            "telegram",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Telegram/telegram.svg"
        },
        "isToolVariant": true,
        "operations": {
            "chat": [
                "get",
                "administrators",
                "member",
                "leave",
                "setDescription",
                "setTitle"
            ],
            "callback": [
                "answerQuery",
                "answerInlineQuery"
            ],
            "file": [
                "get"
            ],
            "message": [
                "deleteMessage",
                "editMessageText",
                "pinChatMessage",
                "sendAnimation",
                "sendAudio",
                "sendChatAction",
                "sendDocument",
                "sendLocation",
                "sendMediaGroup",
                "sendMessage",
                "sendAndWait",
                "sendPhoto",
                "sendSticker",
                "sendVideo",
                "unpinChatMessage"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.theHiveProjectTool",
        "displayName": "TheHive 5 Tool",
        "description": "Consume TheHive 5 API",
        "group": "transform",
        "keywords": [
            "thehive",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/TheHiveProject/thehiveproject.svg"
        },
        "isToolVariant": true,
        "operations": {
            "alert": [
                "create",
                "deleteAlert",
                "executeResponder",
                "get",
                "merge",
                "promote",
                "search",
                "update",
                "status",
                "__CUSTOM_API_CALL__"
            ],
            "case": [
                "addAttachment",
                "create",
                "deleteAttachment",
                "deleteCase",
                "executeResponder",
                "get",
                "getAttachment",
                "getTimeline",
                "search",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "comment": [
                "add",
                "deleteComment",
                "search",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "log": [
                "addAttachment",
                "create",
                "deleteLog",
                "deleteAttachment",
                "executeResponder",
                "get",
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "observable": [
                "create",
                "deleteObservable",
                "executeAnalyzer",
                "executeResponder",
                "get",
                "search",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "page": [
                "create",
                "deletePage",
                "search",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "query": [
                "executeQuery",
                "__CUSTOM_API_CALL__"
            ],
            "task": [
                "create",
                "deleteTask",
                "executeResponder",
                "get",
                "search",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.theHiveTool",
        "displayName": "TheHive Tool",
        "description": "Consume TheHive API",
        "group": "transform",
        "keywords": [
            "thehive",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/TheHive/thehive.svg"
        },
        "isToolVariant": true,
        "operations": {
            "log": [
                "create",
                "executeResponder",
                "getAll",
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "alert": [],
            "case": [],
            "observable": [],
            "task": [],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.timescaleDbTool",
        "displayName": "TimescaleDB Tool",
        "description": "Add and update data in TimescaleDB",
        "group": "input",
        "keywords": [
            "timescaledb",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/TimescaleDb/timescaleDb.svg",
            "darkValue": "nodes/TimescaleDb/timescaleDb.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "executeQuery",
                "insert",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.todoistTool",
        "displayName": "Todoist Tool",
        "description": "Consume Todoist API",
        "group": "output",
        "keywords": [
            "todoist",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Todoist/todoist.svg"
        },
        "isToolVariant": true,
        "operations": {
            "task": [
                "close",
                "create",
                "delete",
                "get",
                "getAll",
                "move",
                "quickAdd",
                "reopen",
                "update"
            ],
            "project": [
                "archive",
                "create",
                "delete",
                "get",
                "getCollaborators",
                "getAll",
                "unarchive",
                "update"
            ],
            "section": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "comment": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "label": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "reminder": [
                "create",
                "delete",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.totpTool",
        "displayName": "TOTP Tool",
        "description": "Generate a time-based one-time password",
        "group": "transform",
        "keywords": [
            "totp",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "fa",
            "value": "fingerprint"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "generateSecret"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.travisCiTool",
        "displayName": "TravisCI Tool",
        "description": "Consume TravisCI API",
        "group": "output",
        "keywords": [
            "travisci",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/TravisCi/travisci.png"
        },
        "isToolVariant": true,
        "operations": {
            "build": [
                "cancel",
                "get",
                "getAll",
                "restart",
                "trigger"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.trelloTool",
        "displayName": "Trello Tool",
        "description": "Create, change and delete boards and cards",
        "group": "transform",
        "keywords": [
            "trello",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Trello/trello.svg"
        },
        "isToolVariant": true,
        "operations": {
            "attachment": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "board": [
                "create",
                "delete",
                "get",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "boardMember": [
                "add",
                "getAll",
                "invite",
                "remove",
                "__CUSTOM_API_CALL__"
            ],
            "card": [
                "create",
                "delete",
                "get",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "cardComment": [
                "create",
                "delete",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "checklist": [
                "create",
                "createCheckItem",
                "delete",
                "deleteCheckItem",
                "get",
                "getCheckItem",
                "completedCheckItems",
                "getAll",
                "updateCheckItem",
                "__CUSTOM_API_CALL__"
            ],
            "label": [
                "addLabel",
                "create",
                "delete",
                "get",
                "getAll",
                "removeLabel",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "list": [
                "archive",
                "create",
                "get",
                "getCards",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.twakeTool",
        "displayName": "Twake Tool",
        "description": "Consume Twake API",
        "group": "transform",
        "keywords": [
            "twake",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Twake/twake.png"
        },
        "isToolVariant": true,
        "operations": {
            "message": [
                "send",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.twilioTool",
        "displayName": "Twilio Tool",
        "description": "Send SMS and WhatsApp messages or make phone calls",
        "group": "transform",
        "keywords": [
            "twilio",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Twilio/twilio.svg"
        },
        "isToolVariant": true,
        "operations": {
            "sms": [
                "send",
                "__CUSTOM_API_CALL__"
            ],
            "call": [
                "make",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.twistTool",
        "displayName": "Twist Tool",
        "description": "Consume Twist API",
        "group": "input",
        "keywords": [
            "twist",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Twist/twist.png"
        },
        "isToolVariant": true,
        "operations": {
            "channel": [
                "archive",
                "create",
                "delete",
                "get",
                "getAll",
                "unarchive",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "comment": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "messageConversation": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "thread": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.twitterTool",
        "displayName": "X (Formerly Twitter) Tool",
        "description": "Post, like, and search tweets, send messages, search users, and add users to lists",
        "group": "output",
        "keywords": [
            "formerly",
            "twitter",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Twitter/x.svg",
            "darkValue": "nodes/Twitter/x.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "directMessage": [
                "create",
                "__CUSTOM_API_CALL__"
            ],
            "list": [
                "add",
                "__CUSTOM_API_CALL__"
            ],
            "tweet": [
                "create",
                "delete",
                "like",
                "retweet",
                "search",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "searchUser",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.unleashedSoftwareTool",
        "displayName": "Unleashed Software Tool",
        "description": "Consume Unleashed Software API",
        "group": "transform",
        "keywords": [
            "unleashed",
            "software",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/UnleashedSoftware/unleashedSoftware.png"
        },
        "isToolVariant": true,
        "operations": {
            "salesOrder": [
                "getAll"
            ],
            "stockOnHand": [
                "get",
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.upleadTool",
        "displayName": "Uplead Tool",
        "description": "Consume Uplead API",
        "group": "output",
        "keywords": [
            "uplead",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Uplead/uplead.png"
        },
        "isToolVariant": true,
        "operations": {
            "company": [
                "enrich"
            ],
            "person": [
                "enrich"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.uprocTool",
        "displayName": "uProc Tool",
        "description": "Consume uProc API",
        "group": "output",
        "keywords": [
            "uproc",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/UProc/uproc.png"
        },
        "isToolVariant": true
    },
    {
        "name": "n8n-nodes-base.uptimeRobotTool",
        "displayName": "UptimeRobot Tool",
        "description": "Consume UptimeRobot API",
        "group": "output",
        "keywords": [
            "uptimerobot",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/UptimeRobot/uptimerobot.svg"
        },
        "isToolVariant": true,
        "operations": {
            "account": [
                "get"
            ],
            "monitor": [
                "create",
                "delete",
                "get",
                "getAll",
                "reset",
                "update"
            ],
            "alertContact": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "maintenanceWindow": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "publicStatusPage": [
                "create",
                "delete",
                "get",
                "getAll"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.urlScanIoTool",
        "displayName": "urlscan.io Tool",
        "description": "Provides various utilities for monitoring websites like health checks or screenshots",
        "group": "transform",
        "keywords": [
            "urlscan.io",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/UrlScanIo/urlScanIo.svg"
        },
        "isToolVariant": true,
        "operations": {
            "scan": [
                "get",
                "getAll",
                "perform",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.veroTool",
        "displayName": "Vero Tool",
        "description": "Consume Vero API",
        "group": "output",
        "keywords": [
            "vero",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Vero/vero.svg"
        },
        "isToolVariant": true,
        "operations": {
            "user": [
                "addTags",
                "alias",
                "create",
                "delete",
                "resubscribe",
                "removeTags",
                "unsubscribe"
            ],
            "event": [
                "track"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.venafiTlsProtectCloudTool",
        "displayName": "Venafi TLS Protect Cloud Tool",
        "description": "Consume Venafi TLS Protect Cloud API",
        "group": "input",
        "keywords": [
            "venafi",
            "tls",
            "protect",
            "cloud",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Venafi/venafi.svg"
        },
        "isToolVariant": true,
        "operations": {
            "certificate": [
                "delete",
                "download",
                "get",
                "getMany",
                "renew",
                "__CUSTOM_API_CALL__"
            ],
            "certificateRequest": [
                "create",
                "get",
                "getMany",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.venafiTlsProtectDatacenterTool",
        "displayName": "Venafi TLS Protect Datacenter Tool",
        "description": "Consume Venafi TLS Protect Datacenter",
        "group": "input",
        "keywords": [
            "venafi",
            "tls",
            "protect",
            "datacenter",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Venafi/venafi.svg"
        },
        "isToolVariant": true,
        "operations": {
            "certificate": [
                "create",
                "delete",
                "download",
                "get",
                "getMany",
                "renew",
                "__CUSTOM_API_CALL__"
            ],
            "policy": [
                "get",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.vonageTool",
        "displayName": "Vonage Tool",
        "description": "Consume Vonage API",
        "group": "input",
        "keywords": [
            "vonage",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Vonage/vonage.svg",
            "darkValue": "nodes/Vonage/vonage.dark.svg"
        },
        "isToolVariant": true,
        "operations": {
            "sms": [
                "send"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.webflowTool",
        "displayName": "Webflow Tool",
        "description": "Consume the Webflow API",
        "group": "transform",
        "keywords": [
            "webflow",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Webflow/webflow.svg"
        },
        "isToolVariant": true,
        "operations": {
            "item": [
                "create",
                "deleteItem",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.wekanTool",
        "displayName": "Wekan Tool",
        "description": "Consume Wekan API",
        "group": "transform",
        "keywords": [
            "wekan",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Wekan/wekan.svg"
        },
        "isToolVariant": true,
        "operations": {
            "board": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "card": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "cardComment": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "checklist": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "checklistItem": [
                "delete",
                "get",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "list": [
                "create",
                "delete",
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.whatsAppTool",
        "displayName": "WhatsApp Business Cloud Tool",
        "description": "Access WhatsApp API",
        "group": "output",
        "keywords": [
            "whatsapp",
            "business",
            "cloud",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/WhatsApp/whatsapp.svg"
        },
        "isToolVariant": true,
        "operations": {
            "message": [
                "send",
                "sendAndWait",
                "sendTemplate"
            ],
            "media": [
                "mediaUpload",
                "mediaUrlGet",
                "mediaDelete"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.wooCommerceTool",
        "displayName": "WooCommerce Tool",
        "description": "Consume WooCommerce API",
        "group": "output",
        "keywords": [
            "woocommerce",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/WooCommerce/wooCommerce.svg"
        },
        "isToolVariant": true,
        "operations": {
            "customer": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "product": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "order": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.wordpressTool",
        "displayName": "Wordpress Tool",
        "description": "Consume Wordpress API",
        "group": "output",
        "keywords": [
            "wordpress",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Wordpress/wordpress.svg"
        },
        "isToolVariant": true,
        "operations": {
            "post": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "page": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.xeroTool",
        "displayName": "Xero Tool",
        "description": "Consume Xero API",
        "group": "output",
        "keywords": [
            "xero",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Xero/xero.svg"
        },
        "isToolVariant": true,
        "operations": {
            "contact": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "invoice": [
                "create",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.yourlsTool",
        "displayName": "Yourls Tool",
        "description": "Consume Yourls API",
        "group": "input",
        "keywords": [
            "yourls",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Yourls/yourls.png"
        },
        "isToolVariant": true,
        "operations": {
            "url": [
                "expand",
                "shorten",
                "stats"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.zammadTool",
        "displayName": "Zammad Tool",
        "description": "Consume the Zammad API",
        "group": "input",
        "keywords": [
            "zammad",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Zammad/zammad.svg"
        },
        "isToolVariant": true,
        "operations": {
            "group": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "organization": [
                "create",
                "delete",
                "get",
                "getAll",
                "update"
            ],
            "ticket": [
                "create",
                "delete",
                "get",
                "getAll"
            ],
            "user": [
                "create",
                "delete",
                "get",
                "getAll",
                "getSelf",
                "update"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.zendeskTool",
        "displayName": "Zendesk Tool",
        "description": "Consume Zendesk API",
        "group": "output",
        "keywords": [
            "zendesk",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Zendesk/zendesk.svg"
        },
        "isToolVariant": true,
        "operations": {
            "ticket": [
                "create",
                "delete",
                "get",
                "getAll",
                "recover",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "ticketField": [
                "get",
                "getAll",
                "__CUSTOM_API_CALL__"
            ],
            "user": [
                "create",
                "delete",
                "get",
                "getAll",
                "getOrganizations",
                "getRelatedData",
                "search",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "organization": [
                "count",
                "create",
                "delete",
                "get",
                "getAll",
                "getRelatedData",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.zohoCrmTool",
        "displayName": "Zoho CRM Tool",
        "description": "Consume Zoho CRM API",
        "group": "transform",
        "keywords": [
            "zoho",
            "crm",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Zoho/zoho.svg"
        },
        "isToolVariant": true,
        "operations": {
            "account": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "contact": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "deal": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "invoice": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "lead": [
                "create",
                "upsert",
                "delete",
                "get",
                "getFields",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "product": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "purchaseOrder": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "quote": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "salesOrder": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "vendor": [
                "create",
                "upsert",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.zoomTool",
        "displayName": "Zoom Tool",
        "description": "Consume Zoom API",
        "group": "input",
        "keywords": [
            "zoom",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Zoom/zoom.svg"
        },
        "isToolVariant": true,
        "operations": {
            "meeting": [
                "create",
                "delete",
                "get",
                "getAll",
                "update",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "n8n-nodes-base.zulipTool",
        "displayName": "Zulip Tool",
        "description": "Consume Zulip API",
        "group": "output",
        "keywords": [
            "zulip",
            "tool",
            "output",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Zulip/zulip.svg"
        },
        "isToolVariant": true,
        "operations": {
            "message": [
                "delete",
                "get",
                "sendPrivate",
                "sendStream",
                "update",
                "updateFile"
            ],
            "stream": [
                "create",
                "delete",
                "getAll",
                "getSubscribed",
                "update"
            ],
            "user": [
                "create",
                "deactivate",
                "get",
                "getAll",
                "update"
            ]
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.anthropicTool",
        "displayName": "Anthropic Tool",
        "description": "Interact with Anthropic AI models",
        "group": "transform",
        "keywords": [
            "anthropic",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vendors/Anthropic/anthropic.svg"
        },
        "isToolVariant": true,
        "operations": {
            "document": [
                "analyze",
                "__CUSTOM_API_CALL__"
            ],
            "file": [
                "upload",
                "get",
                "list",
                "deleteFile",
                "__CUSTOM_API_CALL__"
            ],
            "image": [
                "analyze",
                "__CUSTOM_API_CALL__"
            ],
            "prompt": [
                "generate",
                "improve",
                "templatize",
                "__CUSTOM_API_CALL__"
            ],
            "text": [
                "message",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.googleGeminiTool",
        "displayName": "Google Gemini Tool",
        "description": "Interact with Google Gemini AI models",
        "group": "transform",
        "keywords": [
            "google",
            "gemini",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vendors/GoogleGemini/gemini.svg"
        },
        "isToolVariant": true,
        "operations": {
            "audio": [
                "analyze",
                "transcribe"
            ],
            "document": [
                "analyze"
            ],
            "file": [
                "upload"
            ],
            "fileSearch": [
                "createStore",
                "deleteStore",
                "listStores",
                "uploadToStore"
            ],
            "image": [
                "analyze",
                "generate",
                "edit"
            ],
            "text": [
                "message"
            ],
            "video": [
                "analyze",
                "generate",
                "download"
            ]
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.ollamaTool",
        "displayName": "Ollama Tool",
        "description": "Interact with Ollama AI models",
        "group": "transform",
        "keywords": [
            "ollama",
            "tool",
            "transform",
            "tools",
            "other"
        ],
        "icon": {
            "type": "url",
            "value": "icons/@n8n/n8n-nodes-langchain/dist/nodes/vendors/Ollama/ollama.svg"
        },
        "isToolVariant": true,
        "operations": {
            "image": [
                "analyze",
                "__CUSTOM_API_CALL__"
            ],
            "text": [
                "message",
                "__CUSTOM_API_CALL__"
            ],
            "__CUSTOM_API_CALL__": []
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.chatTool",
        "displayName": "Chat Tool",
        "description": "Send a message into the chat",
        "group": "input",
        "keywords": [
            "chat",
            "tool",
            "input",
            "tools",
            "other"
        ],
        "icon": {
            "type": "fa",
            "value": "comments",
            "color": "black"
        },
        "isToolVariant": true,
        "operations": {
            "_": [
                "send",
                "sendAndWait"
            ]
        }
    },
    {
        "name": "n8n-nodes-base.discordHitlTool",
        "displayName": "Discord",
        "description": "Request human approval for tools",
        "group": "output",
        "keywords": [
            "discord",
            "output",
            "tools",
            "human",
            "the",
            "loop"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Discord/discord.svg"
        }
    },
    {
        "name": "n8n-nodes-base.emailSendHitlTool",
        "displayName": "Send Email",
        "description": "Request human approval for tools",
        "group": "output",
        "keywords": [
            "send",
            "email",
            "output",
            "tools",
            "human",
            "the",
            "loop"
        ],
        "icon": {
            "type": "fa",
            "value": "envelope"
        }
    },
    {
        "name": "n8n-nodes-base.googleChatHitlTool",
        "displayName": "Google Chat",
        "description": "Request human approval for tools",
        "group": "input",
        "keywords": [
            "google",
            "chat",
            "input",
            "tools",
            "human",
            "the",
            "loop"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Chat/googleChat.svg"
        }
    },
    {
        "name": "n8n-nodes-base.gmailHitlTool",
        "displayName": "Gmail",
        "description": "Request human approval for tools",
        "group": "transform",
        "keywords": [
            "gmail",
            "transform",
            "tools",
            "human",
            "the",
            "loop"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Google/Gmail/gmail.svg"
        }
    },
    {
        "name": "n8n-nodes-base.microsoftOutlookHitlTool",
        "displayName": "Microsoft Outlook",
        "description": "Request human approval for tools",
        "group": "transform",
        "keywords": [
            "microsoft",
            "outlook",
            "transform",
            "tools",
            "human",
            "the",
            "loop"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/Outlook/outlook.svg"
        }
    },
    {
        "name": "n8n-nodes-base.microsoftTeamsHitlTool",
        "displayName": "Microsoft Teams",
        "description": "Request human approval for tools",
        "group": "input",
        "keywords": [
            "microsoft",
            "teams",
            "input",
            "tools",
            "human",
            "the",
            "loop"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Microsoft/Teams/teams.svg"
        }
    },
    {
        "name": "n8n-nodes-base.slackHitlTool",
        "displayName": "Slack",
        "description": "Request human approval for tools",
        "group": "output",
        "keywords": [
            "slack",
            "output",
            "tools",
            "human",
            "the",
            "loop"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Slack/slack.svg"
        }
    },
    {
        "name": "n8n-nodes-base.telegramHitlTool",
        "displayName": "Telegram",
        "description": "Request human approval for tools",
        "group": "output",
        "keywords": [
            "telegram",
            "output",
            "tools",
            "human",
            "the",
            "loop"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/Telegram/telegram.svg"
        }
    },
    {
        "name": "n8n-nodes-base.whatsAppHitlTool",
        "displayName": "WhatsApp Business Cloud",
        "description": "Request human approval for tools",
        "group": "output",
        "keywords": [
            "whatsapp",
            "business",
            "cloud",
            "output",
            "tools",
            "human",
            "the",
            "loop"
        ],
        "icon": {
            "type": "url",
            "value": "nodes/WhatsApp/whatsapp.svg"
        }
    },
    {
        "name": "@n8n/n8n-nodes-langchain.chatHitlTool",
        "displayName": "Chat",
        "description": "Request human approval for tools",
        "group": "input",
        "keywords": [
            "chat",
            "input",
            "tools",
            "human",
            "the",
            "loop"
        ],
        "icon": {
            "type": "fa",
            "value": "comments",
            "color": "black"
        }
    }
];
//# sourceMappingURL=node-index.js.map